/* ════════════════════════════════════════════════════════════════════
   Cell Devices Master Quote Calculator — JavaScript
   File: assets/cd-calculator.js
   ════════════════════════════════════════════════════════════════════ */
(function() {
  'use strict';
  console.log('[CellDevices Calculator] v3.0 loaded');

  /* CONFIG */
  var WA_NUMBER     = '447577545706';
  var FORMSPREE_URL = 'https://formspree.io/f/xqajjdgp';
  var OPS_INTAKE_URL = 'https://ops.celldevices.co.uk/api/intake';
  // Website↔OS plan, Wave 6 Stage B + Wave 7 (2026-09-02): the ops app publishes a READ-ONLY pricing table.
  // When it answers { mode:'live' } the figures below are overlaid on the baked constants in place (REPAIR_PRICES,
  // the flat fees, and the trade-in offers via liveValueFor). Baked stays the permanent fallback: a slow or
  // failed fetch, or { mode:'baked' }, changes nothing. Trade-in offers in live mode are the app's own derived
  // buy offers (eBay Grade B anchor − parts − margin − overhead), never a percentage of a listing price.
  var OPS_PRICING_URL = 'https://ops.celldevices.co.uk/api/pricing/table';
  var LIVE = null;            // { 'iPhone 13|128': { good, low, screen, battery, screen_battery } } when live
  var LIVE_MANUAL = [];       // combos the app could not price firmly → "we'll quote you personally"
  // r163 (PDX-04) — WHY THE BUILT IN FIGURES WERE USED, KEPT FOR THE LEAD. 'waiting' until the table answers, then 'live',
  // 'off' (the app's pricing switched off) or 'failed' (no answer, an error, or not a table). Off and failed both quoted
  // the built in figures and both read "Pricing: baked-v3.0" on the lead, so nobody could tell a switch from a fault.
  var LIVE_STATE = 'waiting';
  var LIVE_UNREADABLE = [];   // r163 (PDX-04) — buy rows the table sent without a usable price: quoted personally
  var PRICING_VERSION = 'baked-v3.0';
  var GADS_CONV     = 'AW-939277776/0gt1CJv35YscEND78L8D';
  var BUNDLE_DISCOUNT = 0.20;
  var DIAG_FEE        = 20;   // D-20260915-m: £20, "just to cover postage". Seed locked by migration 101 + the v366 parity test
  var PARTS_PRICE     = 20;   // D-20260915-n rule 3 / D-20260915-o: the parts price for a locked or untestable phone
  var CAM_LENS_PRICE  = 50;
  var FACE_ID_PRICE   = 220;
  // r150 (FSA-006, Dan D-20260927-a (11)) — ONE LIST of the models whose Face ID we repair (it was typed out in four places),
  // and the ones repaired only at a personal quote: the iPhone 17 family and the Air, where a new module leaves too little
  // at the flat price. Matched by indexOf, as before, so "iPhone 16" covers the 16e and "iPhone 17" the 17 Pro and 17e.
  var FACE_ID_MODELS = ['iPhone 12','iPhone 13','iPhone 14','iPhone 15','iPhone 16','iPhone 17','iPhone Air'];
  var FACE_ID_QUOTE_ONLY = ['iPhone 17','iPhone Air'];
  function faceIdFixable(model) { var m = String(model || ''); return FACE_ID_MODELS.some(function (x) { return m.indexOf(x) !== -1; }); }
  function faceIdQuoteOnly(model) { var m = String(model || ''); return FACE_ID_QUOTE_ONLY.some(function (x) { return m.indexOf(x) !== -1; }); }

  /* STATE */
  var S = {
    type:'iphone', model:'', intent:'', repair:'', parts:'',
    faults:[], cond:'', lock:'', history:[], current:'s0',
    // R-096 (second wave) — the repair panels open on the folded "What's wrong with it?" screen, in order (goStep).
    panels:[],
    sym:{ scr:[], bat:[], gls:[], cm:[], sft:[], sml:[], chg:[], cam:[] },
    // r170 (CXH1012-06) — WHICH QUESTION WROTE EACH SYMPTOM ('bucket:value' → 'primary' | 'detail'); see liveSymptoms.
    symFrom:{},
    storage:'', battHealth:'', primaryFromQuiz:false, chosenUpgrade:null, tradeFlow:'', glsBatt:'', faulty:'', carrier:'', blacklist:'',
    // ⚠ WHO PUT 'battery' IN S.faults — the seller, or the battery-health answer? Indistinguishable
    // once both write the same array, and R-096 made that ambiguity reachable: see set-batt-health.
    battFaultDerived:false,
    // r148 (CC-04) — how a FAULTY phone looks apart from its faults ('good' | 'fair'), asked on the faulty branch too.
    faultGrade:''
  };

  var _prefillRepair = '', _prefillIntent = '', _prefillSym = '', _prefillApplied = false;
  // r165 (R-163, D-20261008-c) — THE SELL ONLY MODE. The section sets data-quote-mode="sell" on #cdmc for the sell ad landing
  // pages and leaves every repair screen, price and link out of the page. This script refuses the repair path there too:
  // a link naming a fault, a saved repair quote, the switch from an offer. Read once in init(); false on the main quote page.
  var SELL_ONLY = false;
  // r165 — THE CONDITION LINK ANSWER. 'working' or 'broken' answers "Does the phone have any faults?"; 'likenew', 'good' and
  // 'fair' answer it as working and pick that grade. From the section (data-preset-cond) or a link's ?cond=, the link winning.
  // Applied when the condition screen opens with that question unanswered, so the visitor can still change it.
  var PRESET_COND = '';
  var COND_MAP = { working:'working', broken:'broken', faulty:'broken', damaged:'broken', cracked:'broken',
    likenew:'likenew', 'like-new':'likenew', 'like_new':'likenew', good:'good', fair:'fair' };

  /* Ops intake state (fire-and-forget): a short-lived token + an idempotency key so a
     retried submission can't create a duplicate lead. Must NEVER block the WhatsApp flow. */
  var _opsToken = '', _opsTokenExp = 0, _opsIdemKey = '', _opsIdemFor = '';   // _opsIdemFor: the enquiry the key names (DOR-07)
  var _opsIdemByBody = {};   // W7.1 — each unconfirmed enquiry's own key (see opsSendLead)

  var MODELS = {
    iphone: [
      'iPhone 17 Pro Max','iPhone 17 Pro','iPhone Air','iPhone 17','iPhone 17e',   // r150 (FSA-006, Dan D-20260927-a)
      'iPhone 16 Pro Max','iPhone 16 Pro','iPhone 16 Plus','iPhone 16','iPhone 16e',
      'iPhone 15 Pro Max','iPhone 15 Pro','iPhone 15 Plus','iPhone 15',
      'iPhone 14 Pro Max','iPhone 14 Pro','iPhone 14 Plus','iPhone 14',
      'iPhone 13 Pro Max','iPhone 13 Pro','iPhone 13','iPhone 13 mini',
      'iPhone 12 Pro Max','iPhone 12 Pro','iPhone 12','iPhone 12 mini',
      'iPhone SE (3rd gen)',
      'iPhone 11 Pro Max','iPhone 11 Pro','iPhone 11',
      'iPhone SE (2nd gen)',
      'iPhone XS Max','iPhone XS','iPhone XR','iPhone X',
      'iPhone 8 Plus','iPhone 8',
      'iPhone 7 Plus','iPhone 7'
    ],
    ipad: [
      'iPad Pro 13" (M4)','iPad Pro 11" (M4)',
      'iPad Air 13" (M2)','iPad Air 11" (M2)',
      'iPad mini (6th gen)',
      'iPad Pro 12.9" (6th gen)','iPad Pro 11" (4th gen)',
      'iPad Air (5th gen)',
      'iPad (11th gen)',
      'iPad (10th gen)',
      'iPad Air (4th gen)',
      'iPad (9th gen)',
      'iPad (8th gen)',
      'iPad (7th gen)'
    ],
    samsung: [
      'Galaxy S25 Ultra','Galaxy S25+','Galaxy S25',
      'Galaxy S24 Ultra','Galaxy S24+','Galaxy S24',
      'Galaxy S23 Ultra','Galaxy S23+','Galaxy S23',
      'Galaxy S22 Ultra','Galaxy S22+','Galaxy S22',
      'Galaxy S21 Ultra','Galaxy S21+','Galaxy S21',
      'Galaxy Z Fold 6','Galaxy Z Flip 6',
      'Galaxy Z Fold 5','Galaxy Z Flip 5',
      'Galaxy Z Fold 4','Galaxy Z Flip 4',
      'Galaxy A56','Galaxy A55','Galaxy A54','Galaxy A35','Galaxy A34'
    ],
    google: [
      'Pixel 9 Pro XL','Pixel 9 Pro Fold','Pixel 9 Pro','Pixel 9',
      'Pixel 8 Pro','Pixel 8','Pixel 8a',
      'Pixel 7 Pro','Pixel 7','Pixel 7a',
      'Pixel 6 Pro','Pixel 6','Pixel 6a'
    ]
  };

  var HOUSING_ONLY = [
    'iPhone 8','iPhone 8 Plus',
    'iPhone X','iPhone XS','iPhone XS Max','iPhone XR',
    'iPhone 11','iPhone 11 Pro','iPhone 11 Pro Max',
    'iPhone 12','iPhone 12 mini','iPhone 12 Pro','iPhone 12 Pro Max',
    'iPhone 13','iPhone 13 mini','iPhone 13 Pro','iPhone 13 Pro Max',
    'iPhone 14 Pro','iPhone 14 Pro Max',
    'iPhone SE (2nd gen)','iPhone SE (3rd gen)'
  ];

  // FREE RECYCLING, never a cash offer — D-20260911-d (Dan, 2026-09-11, shown the old £25–£70 offers: "Woah that's
  // way too high for this just free offers"). compValueFor() checks this list FIRST, before the live table and the
  // baked COMP maths, and answers { recycle: true }; every trade-in / sell / credit surface renders that as free
  // recycling, never a £ figure. BUYING only: repairs on these models (REPAIR_PRICES, the repair flow) are unchanged.
  // Theme gate 2f (current live site/tools/theme-truth-check.mjs) fails if a model drops off this list or
  // compValueFor() stops checking it first.
  var RECYCLE_ONLY = ['iPhone 7','iPhone 7 Plus','iPhone 8','iPhone 8 Plus'];
  function isRecycleOnly(model) { return RECYCLE_ONLY.indexOf(String(model || '').trim()) !== -1; }
  var RECYCLE_LABEL = 'Free recycling';

  var REPAIR_PRICES = {
    // r150 (FSA-006, Dan D-20260927-a (9) to (11)): the iPhone 17 family's well backed prices only. Not here, so quoted
    // personally until Dan prices them: the Air's genuine screen, every 17 family camera, the 17e's charging port (and so
    // its small parts) and its third party battery. Back glass and frame are SPLIT on these models (not the same number).
    'iPhone 17 Pro Max::screen::oled':209,'iPhone 17 Pro Max::screen::genuine':409,
    'iPhone 17 Pro::screen::oled':179,'iPhone 17 Pro::screen::genuine':389,
    'iPhone Air::screen::oled':169,
    'iPhone 17::screen::oled':159,'iPhone 17::screen::genuine':339,
    'iPhone 17e::screen::oled':149,'iPhone 17e::screen::genuine':249,
    'iPhone 17 Pro Max::battery::third-party':69,'iPhone 17 Pro::battery::third-party':69,'iPhone Air::battery::third-party':69,'iPhone 17::battery::third-party':69,
    'iPhone 17 Pro Max::battery::genuine':129,'iPhone 17 Pro::battery::genuine':129,'iPhone Air::battery::genuine':129,'iPhone 17::battery::genuine':129,'iPhone 17e::battery::genuine':129,
    'iPhone 17 Pro Max::back-glass':179,'iPhone 17 Pro::back-glass':179,'iPhone Air::back-glass':209,'iPhone 17::back-glass':179,'iPhone 17e::back-glass':199,
    'iPhone 17 Pro Max::housing':279,'iPhone 17 Pro::housing':229,'iPhone Air::housing':169,'iPhone 17::housing':179,'iPhone 17e::housing':209,
    'iPhone 17 Pro Max::charging-port':89,'iPhone 17 Pro::charging-port':89,'iPhone Air::charging-port':89,'iPhone 17::charging-port':89,

    'iPhone 16 Pro Max::screen::oled':189,'iPhone 16 Pro Max::screen::genuine':379,
    'iPhone 16 Pro::screen::oled':179,'iPhone 16 Pro::screen::genuine':299,
    'iPhone 16 Plus::screen::oled':149,'iPhone 16 Plus::screen::genuine':279,
    'iPhone 16::screen::oled':149,'iPhone 16::screen::genuine':279,
    'iPhone 16e::screen::oled':149,'iPhone 16e::screen::genuine':249,
    'iPhone 15 Pro Max::screen::oled':199,'iPhone 15 Pro Max::screen::genuine':299,
    'iPhone 15 Pro::screen::oled':199,'iPhone 15 Pro::screen::genuine':299,
    'iPhone 15 Plus::screen::oled':199,'iPhone 15 Plus::screen::genuine':299,
    'iPhone 15::screen::oled':149,'iPhone 15::screen::genuine':199,
    'iPhone 14 Pro Max::screen::oled':199,'iPhone 14 Pro Max::screen::genuine':299,
    'iPhone 14 Pro::screen::oled':179,'iPhone 14 Pro::screen::genuine':229,
    'iPhone 14 Plus::screen::oled':119,'iPhone 14 Plus::screen::genuine':199,
    'iPhone 14::screen::oled':119,'iPhone 14::screen::genuine':199,
    'iPhone 13 Pro Max::screen::oled':179,'iPhone 13 Pro Max::screen::genuine':259,
    'iPhone 13 Pro::screen::oled':129,'iPhone 13 Pro::screen::genuine':259,
    'iPhone 13::screen::lcd':99,'iPhone 13::screen::oled':119,'iPhone 13::screen::genuine':199,
    'iPhone 13 mini::screen::lcd':99,'iPhone 13 mini::screen::oled':119,'iPhone 13 mini::screen::genuine':199,
    'iPhone 12 Pro Max::screen::lcd':99,'iPhone 12 Pro Max::screen::oled':119,'iPhone 12 Pro Max::screen::genuine':199,
    'iPhone 12 Pro::screen::lcd':99,'iPhone 12 Pro::screen::oled':119,'iPhone 12 Pro::screen::genuine':149,
    'iPhone 12::screen::lcd':99,'iPhone 12::screen::oled':119,'iPhone 12::screen::genuine':149,
    'iPhone 12 mini::screen::lcd':99,'iPhone 12 mini::screen::oled':119,'iPhone 12 mini::screen::genuine':149,
    'iPhone 11 Pro Max::screen::lcd':69,'iPhone 11 Pro Max::screen::oled':119,
    'iPhone 11 Pro::screen::lcd':59,'iPhone 11 Pro::screen::oled':99,
    'iPhone 11::screen::lcd':79,
    'iPhone XS Max::screen::lcd':69,'iPhone XS Max::screen::oled':99,
    'iPhone XS::screen::lcd':59,'iPhone XS::screen::oled':99,
    'iPhone XR::screen::lcd':69,
    'iPhone X::screen::lcd':69,'iPhone X::screen::oled':99,
    'iPhone SE (3rd gen)::screen::lcd':59,
    'iPhone SE (2nd gen)::screen::lcd':59,
    'iPhone 8 Plus::screen::lcd':59,
    'iPhone 8::screen::lcd':59,

    'iPhone 16 Pro Max::battery::third-party':69,'iPhone 16 Pro::battery::third-party':69,'iPhone 16 Plus::battery::third-party':69,'iPhone 16::battery::third-party':69,'iPhone 16e::battery::third-party':69,
    'iPhone 15 Pro Max::battery::third-party':69,'iPhone 15 Pro::battery::third-party':69,'iPhone 15 Plus::battery::third-party':69,'iPhone 15::battery::third-party':49,
    'iPhone 14 Pro Max::battery::third-party':69,'iPhone 14 Pro::battery::third-party':69,'iPhone 14 Plus::battery::third-party':49,'iPhone 14::battery::third-party':49,
    'iPhone 13 Pro Max::battery::third-party':69,'iPhone 13 Pro::battery::third-party':69,'iPhone 13::battery::third-party':49,'iPhone 13 mini::battery::third-party':49,
    'iPhone 12 Pro Max::battery::third-party':69,'iPhone 12 Pro::battery::third-party':49,'iPhone 12::battery::third-party':49,'iPhone 12 mini::battery::third-party':49,
    'iPhone 11 Pro Max::battery::third-party':49,'iPhone 11 Pro::battery::third-party':49,'iPhone 11::battery::third-party':49,
    'iPhone XS Max::battery::third-party':49,'iPhone XS::battery::third-party':49,'iPhone XR::battery::third-party':49,'iPhone X::battery::third-party':49,
    'iPhone SE (3rd gen)::battery::third-party':49,'iPhone SE (2nd gen)::battery::third-party':49,
    'iPhone 8 Plus::battery::third-party':49,'iPhone 8::battery::third-party':49,
    'iPhone 16 Pro Max::battery::genuine':129,'iPhone 16 Pro::battery::genuine':129,'iPhone 16 Plus::battery::genuine':129,'iPhone 16::battery::genuine':129,'iPhone 16e::battery::genuine':129,
    'iPhone 15 Pro Max::battery::genuine':129,'iPhone 15 Pro::battery::genuine':129,'iPhone 15 Plus::battery::genuine':129,'iPhone 15::battery::genuine':129,
    'iPhone 14 Pro Max::battery::genuine':129,'iPhone 14 Pro::battery::genuine':129,'iPhone 14 Plus::battery::genuine':129,'iPhone 14::battery::genuine':129,
    'iPhone 13 Pro Max::battery::genuine':129,'iPhone 13 Pro::battery::genuine':129,'iPhone 13::battery::genuine':129,'iPhone 13 mini::battery::genuine':129,
    'iPhone 12 Pro Max::battery::genuine':129,'iPhone 12 Pro::battery::genuine':129,'iPhone 12::battery::genuine':129,'iPhone 12 mini::battery::genuine':129,
    'iPhone 11 Pro Max::battery::genuine':129,'iPhone 11 Pro::battery::genuine':129,'iPhone 11::battery::genuine':129,
    'iPhone XS Max::battery::genuine':129,'iPhone XS::battery::genuine':129,'iPhone XR::battery::genuine':129,'iPhone X::battery::genuine':129,
    'iPhone SE (3rd gen)::battery::genuine':129,'iPhone SE (2nd gen)::battery::genuine':129,
    'iPhone 8 Plus::battery::genuine':129,'iPhone 8::battery::genuine':129,

    'iPhone 16 Pro Max::back-glass':179,'iPhone 16 Pro::back-glass':179,'iPhone 16 Plus::back-glass':149,'iPhone 16::back-glass':149,'iPhone 16e::back-glass':179,
    'iPhone 15 Pro Max::back-glass':129,'iPhone 15 Pro::back-glass':80,'iPhone 15 Plus::back-glass':129,'iPhone 15::back-glass':80,
    'iPhone 14 Plus::back-glass':80,'iPhone 14::back-glass':80,

    'iPhone 14 Pro Max::housing':199,'iPhone 14 Pro::housing':179,
    'iPhone 16 Pro Max::housing':179,'iPhone 16 Pro::housing':179,'iPhone 16 Plus::housing':149,'iPhone 16::housing':149,'iPhone 16e::housing':179,
    'iPhone 15 Pro Max::housing':129,'iPhone 15 Pro::housing':80,'iPhone 15 Plus::housing':129,'iPhone 15::housing':80,
    'iPhone 14 Plus::housing':80,'iPhone 14::housing':80,
    'iPhone 13 Pro Max::housing':179,'iPhone 13 Pro::housing':179,'iPhone 13::housing':149,'iPhone 13 mini::housing':149,
    'iPhone 12 Pro Max::housing':149,'iPhone 12 Pro::housing':149,'iPhone 12::housing':129,'iPhone 12 mini::housing':129,
    'iPhone 11 Pro Max::housing':149,'iPhone 11 Pro::housing':139,'iPhone 11::housing':119,
    'iPhone XS Max::housing':89,'iPhone XS::housing':89,'iPhone XR::housing':89,'iPhone X::housing':89,
    'iPhone SE (3rd gen)::housing':129,'iPhone SE (2nd gen)::housing':129,'iPhone 8 Plus::housing':129,'iPhone 8::housing':129,

    'iPhone 16 Pro Max::camera':149,'iPhone 16 Pro::camera':139,'iPhone 16 Plus::camera':119,'iPhone 16::camera':99,
    'iPhone 15 Pro Max::camera':129,'iPhone 15 Pro::camera':119,'iPhone 15 Plus::camera':99,'iPhone 15::camera':89,
    'iPhone 14 Pro Max::camera':109,'iPhone 14 Pro::camera':99,'iPhone 14 Plus::camera':79,'iPhone 14::camera':75,
    'iPhone 13 Pro Max::camera':89,'iPhone 13 Pro::camera':79,'iPhone 13::camera':65,'iPhone 13 mini::camera':65,
    'iPhone 12 Pro Max::camera':75,'iPhone 12 Pro::camera':65,'iPhone 12::camera':55,'iPhone 12 mini::camera':55,
    'iPhone 11 Pro Max::camera':69,'iPhone 11 Pro::camera':65,'iPhone 11::camera':55,
    'iPhone XS Max::camera':55,'iPhone XS::camera':55,'iPhone XR::camera':49,'iPhone X::camera':55,

    'iPhone 16 Pro Max::charging-port':79,'iPhone 16 Pro::charging-port':79,'iPhone 16 Plus::charging-port':79,'iPhone 16::charging-port':79,'iPhone 16e::charging-port':79,
    'iPhone 15 Pro Max::charging-port':79,'iPhone 15 Pro::charging-port':79,'iPhone 15 Plus::charging-port':79,'iPhone 15::charging-port':79,
    'iPhone 14 Pro Max::charging-port':89,'iPhone 14 Pro::charging-port':89,'iPhone 14 Plus::charging-port':79,'iPhone 14::charging-port':79,
    'iPhone 13 Pro Max::charging-port':79,'iPhone 13 Pro::charging-port':79,'iPhone 13::charging-port':69,'iPhone 13 mini::charging-port':69,
    'iPhone 12 Pro Max::charging-port':69,'iPhone 12 Pro::charging-port':69,'iPhone 12::charging-port':69,'iPhone 12 mini::charging-port':69,
    'iPhone 11 Pro Max::charging-port':69,'iPhone 11 Pro::charging-port':69,'iPhone 11::charging-port':69,
    'iPhone XS Max::charging-port':69,'iPhone XS::charging-port':69,'iPhone XR::charging-port':69,'iPhone X::charging-port':69,
    'iPhone SE (3rd gen)::charging-port':69,'iPhone SE (2nd gen)::charging-port':69,
    'iPhone 8 Plus::charging-port':69,'iPhone 8::charging-port':69,

    'Galaxy S25 Ultra::screen':180,'Galaxy S25+::screen':149,'Galaxy S25::screen':149,
    'Galaxy S24 Ultra::screen':180,'Galaxy S24+::screen':149,'Galaxy S24::screen':149,
    'Galaxy S23 Ultra::screen':180,'Galaxy S23+::screen':149,'Galaxy S23::screen':149,
    'Galaxy S22 Ultra::screen':249,'Galaxy S22+::screen':149,'Galaxy S22::screen':149,
    'Galaxy S21 Ultra::screen':239,'Galaxy S21+::screen':149,'Galaxy S21::screen':149,
    'Galaxy Z Fold 5::screen':599,'Galaxy Z Flip 5::screen':259,
    'Galaxy Z Fold 4::screen':549,'Galaxy Z Flip 4::screen':239,
    'Galaxy A55::screen':149,'Galaxy A54::screen':149,'Galaxy A35::screen':129,'Galaxy A34::screen':129,
    'Galaxy S25 Ultra::battery':69,'Galaxy S25+::battery':69,'Galaxy S25::battery':69,
    'Galaxy S24 Ultra::battery':69,'Galaxy S24+::battery':69,'Galaxy S24::battery':69,
    'Galaxy S23 Ultra::battery':69,'Galaxy S23+::battery':69,'Galaxy S23::battery':69,
    'Galaxy S22 Ultra::battery':69,'Galaxy S22+::battery':69,'Galaxy S22::battery':69,
    'Galaxy S21 Ultra::battery':69,'Galaxy S21+::battery':69,'Galaxy S21::battery':69,
    'Galaxy A55::battery':69,'Galaxy A54::battery':69,'Galaxy A35::battery':69,'Galaxy A34::battery':69,
    'Galaxy A55::back-glass':79,'Galaxy A54::back-glass':79,'Galaxy A35::back-glass':79,'Galaxy A34::back-glass':79,
    'Galaxy S25 Ultra::back-glass':79,'Galaxy S25+::back-glass':79,'Galaxy S25::back-glass':79,
    'Galaxy S24 Ultra::back-glass':79,'Galaxy S24+::back-glass':79,'Galaxy S24::back-glass':79,
    'Galaxy S23 Ultra::back-glass':79,'Galaxy S23+::back-glass':79,'Galaxy S23::back-glass':79,
    'Galaxy S22 Ultra::back-glass':79,'Galaxy S22+::back-glass':79,'Galaxy S22::back-glass':79,
    'Galaxy S21 Ultra::back-glass':79,'Galaxy S21+::back-glass':79,'Galaxy S21::back-glass':79,
    'Galaxy S25 Ultra::charging-port':89,'Galaxy S25+::charging-port':89,'Galaxy S25::charging-port':89,
    'Galaxy S24 Ultra::charging-port':89,'Galaxy S24+::charging-port':89,'Galaxy S24::charging-port':89,
    'Galaxy S23 Ultra::charging-port':89,'Galaxy S23+::charging-port':89,'Galaxy S23::charging-port':89,
    'Galaxy S22 Ultra::charging-port':89,'Galaxy S22+::charging-port':89,'Galaxy S22::charging-port':89,
    'Galaxy S21 Ultra::charging-port':89,'Galaxy S21+::charging-port':89,'Galaxy S21::charging-port':89,

    'Pixel 9 Pro XL::screen':259,'Pixel 9 Pro::screen':239,'Pixel 9::screen':199,
    'Pixel 8 Pro::screen':229,'Pixel 8::screen':189,'Pixel 8a::screen':169,
    'Pixel 7 Pro::screen':199,'Pixel 7::screen':159,'Pixel 7a::screen':149,
    'Pixel 6 Pro::screen':189,'Pixel 6::screen':149,'Pixel 6a::screen':139,
    'Pixel 9 Pro XL::battery':79,'Pixel 9 Pro::battery':75,'Pixel 9::battery':69,
    'Pixel 8 Pro::battery':75,'Pixel 8::battery':65,'Pixel 8a::battery':59,
    'Pixel 7 Pro::battery':69,'Pixel 7::battery':59,'Pixel 7a::battery':55,
    'Pixel 6 Pro::battery':65,'Pixel 6::battery':55,'Pixel 6a::battery':49,

    'iPad (11th gen)::screen-lcd':179,'iPad (11th gen)::screen-touch':99,
    'iPad (10th gen)::screen-lcd':179,'iPad (10th gen)::screen-touch':99,
    'iPad (9th gen)::screen-lcd':129,'iPad (9th gen)::screen-touch':80,
    'iPad (8th gen)::screen-lcd':129,'iPad (8th gen)::screen-touch':80,
    'iPad (7th gen)::screen-lcd':129,'iPad (7th gen)::screen-touch':80,
    'iPad (6th gen)::screen-touch':80,'iPad (5th gen)::screen-touch':80,
    'iPad Pro 13" (M4)::screen':399,'iPad Pro 11" (M4)::screen':349,
    'iPad Pro 12.9" (6th gen)::screen':349,'iPad Pro 11" (4th gen)::screen':299,
    'iPad Air 13" (M2)::screen':259,'iPad Air 11" (M2)::screen':229,
    'iPad Air (5th gen)::screen':199,'iPad Air (4th gen)::screen':179,
    'iPad mini (6th gen)::screen':169,
    'iPad Pro 13" (M4)::battery':119,'iPad Pro 11" (M4)::battery':99,
    'iPad Pro 12.9" (6th gen)::battery':99,'iPad Pro 11" (4th gen)::battery':89,
    'iPad Air 13" (M2)::battery':79,'iPad Air 11" (M2)::battery':75,
    'iPad Air (5th gen)::battery':65,'iPad Air (4th gen)::battery':65,
    'iPad (11th gen)::battery':89,'iPad (10th gen)::battery':89,
    'iPad (9th gen)::battery':89,'iPad (8th gen)::battery':89,'iPad (7th gen)::battery':89,
    'iPad mini (6th gen)::battery':59
  };

  var COMP = {
    'iPhone 17 Pro Max|256':835,'iPhone 17 Pro Max|512':925,'iPhone 17 Pro Max|1000':1130,'iPhone 17 Pro Max|2000':1350,
    'iPhone 17 Pro|256':755,'iPhone 17 Pro|512':860,'iPhone 17 Pro|1000':875,
    'iPhone Air|256':555,'iPhone Air|512':735,'iPhone Air|1000':695,
    'iPhone 17|256':595,'iPhone 17|512':750,
    'iPhone 17e|256':450,'iPhone 17e|512':450,
    'iPhone 16 Pro Max|256':615,'iPhone 16 Pro Max|512':700,'iPhone 16 Pro Max|1000':740,
    'iPhone 16 Pro|128':535,'iPhone 16 Pro|256':560,'iPhone 16 Pro|512':590,'iPhone 16 Pro|1000':630,
    'iPhone 16 Plus|128':410,'iPhone 16 Plus|256':450,'iPhone 16 Plus|512':490,
    'iPhone 16|128':390,'iPhone 16|256':450,'iPhone 16|512':480,
    'iPhone 15 Pro Max|256':460,'iPhone 15 Pro Max|512':515,'iPhone 15 Pro Max|1000':560,
    'iPhone 15 Pro|128':390,'iPhone 15 Pro|256':440,'iPhone 15 Pro|512':470,'iPhone 15 Pro|1000':490,
    'iPhone 15 Plus|128':350,'iPhone 15 Plus|256':400,'iPhone 15 Plus|512':420,
    'iPhone 15|128':320,'iPhone 15|256':370,'iPhone 15|512':400,
    'iPhone 14 Pro Max|128':365,'iPhone 14 Pro Max|256':405,'iPhone 14 Pro Max|512':430,'iPhone 14 Pro Max|1000':465,
    'iPhone 14 Pro|128':315,'iPhone 14 Pro|256':350,'iPhone 14 Pro|512':370,'iPhone 14 Pro|1000':405,
    'iPhone 14 Plus|128':255,'iPhone 14 Plus|256':285,'iPhone 14 Plus|512':320,
    'iPhone 14|128':261,'iPhone 14|256':294,'iPhone 14|512':295,
    'iPhone 13 Pro Max|128':280,'iPhone 13 Pro Max|256':315,'iPhone 13 Pro Max|512':345,'iPhone 13 Pro Max|1000':360,
    'iPhone 13 Pro|128':245,'iPhone 13 Pro|256':270,'iPhone 13 Pro|512':300,'iPhone 13 Pro|1000':325,
    'iPhone 13|128':185,'iPhone 13|256':225,'iPhone 13|512':255,
    'iPhone 13 mini|128':160,'iPhone 13 mini|256':185,'iPhone 13 mini|512':210,
    'iPhone 12 Pro Max|128':225,'iPhone 12 Pro Max|256':245,'iPhone 12 Pro Max|512':265,
    'iPhone 12 Pro|128':170,'iPhone 12 Pro|256':200,'iPhone 12 Pro|512':225,
    'iPhone 12|64':145,'iPhone 12|128':147,'iPhone 12|256':175,
    'iPhone 12 mini|64':100,'iPhone 12 mini|128':115,'iPhone 12 mini|256':125,
    'iPhone 11 Pro Max|64':145,'iPhone 11 Pro Max|256':160,'iPhone 11 Pro Max|512':170,
    'iPhone 11 Pro|64':115,'iPhone 11 Pro|256':135,'iPhone 11 Pro|512':155,
    'iPhone 11|64':95,'iPhone 11|128':110,'iPhone 11|256':125,
    'iPhone XS Max|64':60,'iPhone XS Max|256':70,
    'iPhone XS|64':50,'iPhone XS|256':60,
    'iPhone XR|64':45,'iPhone XR|128':55,'iPhone XR|256':60,
    'iPhone X|64':35,'iPhone X|256':45,
    'iPhone SE (3rd gen)|64':130,'iPhone SE (3rd gen)|128':145,'iPhone SE (3rd gen)|256':165,
    'iPhone SE (2nd gen)|64':75,'iPhone SE (2nd gen)|128':85,'iPhone SE (2nd gen)|256':100,
    'iPhone 8 Plus|64':60,'iPhone 8 Plus|256':70,
    'iPhone 8|64':45,'iPhone 8|256':55,
    'iPhone 7 Plus|32':35,'iPhone 7 Plus|128':45,
    'iPhone 7|32':25,'iPhone 7|128':32
  };

  var SYMPTOM_LABELS = {
    scr_cracked:'Cracked / smashed glass', scr_touch:'Touch not working',
    scr_lines:'Lines / discolouration', scr_dead:'Black / no display',
    scr_flicker:'Flickering', scr_dim:'Very dim / backlight gone', scr_notsure:'Screen issue (not sure)',
    scr_glass:'Cracked glass only, screen works',   // R-129 ST-11: it arrived on the lead as "Screen issue (not sure)"
    bat_drain:'Battery drains very fast', bat_pct:'Battery % jumps or wrong',
    bat_shutdown:'Shuts off suddenly', bat_hot:'Gets very hot',
    bat_slow:'Phone running slowly', bat_health:'Low battery health', bat_notsure:'Battery issue (not sure)',
    gls_cracked:'Cracked back glass', gls_shattered:'Shattered back glass',
    gls_scratched:'Deep scratches / scuffs', gls_frame:'Bent / damaged frame',
    gls_sharp:'Sharp edges', gls_cosmetic:'Cosmetic only', gls_screen_lift:'Screen lifting from frame',
    gls_notsure:'Back glass issue (not sure)',
    sft_wont_on:"Won't turn on", sft_bootloop:'Stuck in boot loop',
    sft_disabled:'iPhone disabled / locked out', sft_slow:'Extremely slow / freezing',
    sft_update:'Stuck on update or restore', sft_other:'Other software issue',
    sml_speaker:'Speaker: no sound, or muffled', sml_mic:"Microphone: people can't hear me",
    sml_earpiece:'Earpiece: quiet on calls', sml_power_btn:'Power button stuck / not clicking',
    sml_vol_btn:'Volume buttons not working', sml_mute:'Mute switch stuck / broken',
    sml_vibrate:'Vibration not working', sml_notsure:'Small parts issue (not sure)',
    chg_angle:'Only charges at an angle', chg_cables:'Works with some cables only',
    chg_loose:"Cable doesn't click / sits loose", chg_nofit:"Cable won't go in properly",
    chg_slow:'Charges very slowly', chg_none:"Won't charge at all", chg_notsure:'Charging issue (not sure)',
    cam_blurry:'Blurry / won\'t focus', cam_spots:'Black spots / marks',
    cam_vibrate:'Vibrating / rattling', cam_noise:'Clicking / noise',
    cam_lens_cracked:'Lens glass cracked', cam_scratched:'Lens scratched',
    cam_flare:'Lens flare / haze', cam_lens_fine:'Camera works fine, just the glass',
    cm_blur:'Blurry / won\'t focus', cm_black:'Black screen in camera app',
    cm_crash:'Camera app crashes', cm_shake:'Shaky / OIS not working',
    cm_flash:'Flash not working', cm_dust:'Dust / spots inside lens',
    cm_lens_cracked:'Lens glass cracked', cm_switched:'One specific lens not working',
    cm_notsure:'Camera issue (not sure)',
    fid_wont_scan:"Face ID won't scan / not recognising face",
    fid_unavailable:'Face ID unavailable in Settings',
    fid_setup_fail:"Can't set up Face ID, it keeps failing",
    fid_front_cam:'Front camera not working / black screen',
    fid_after_screen:'Stopped working after a screen repair',
    fid_other:'Other Face ID issue',
    wat_wont_on:"Device won't turn on after water damage",
    wat_turns_on:'Turns on but has issues',
    wat_speaker:'Speaker muffled / distorted',
    wat_charging:"Won't charge",
    wat_screen:'Screen issues / lines',
    wat_recent:'Happened within the last 24 hours'
  };

  var SYMPTOM_TO_FAULT = {
    scr_cracked:'screen_cracked', scr_touch:'screen_damaged', scr_lines:'screen_damaged',
    scr_dead:'screen_damaged', scr_flicker:'screen_damaged', scr_dim:'screen_damaged', scr_glass:'screen_cracked',
    bat_drain:'battery', bat_pct:'battery', bat_shutdown:'battery',
    bat_hot:'battery', bat_slow:'battery', bat_health:'battery',
    gls_cracked:'back_glass', gls_shattered:'back_glass', gls_scratched:'back_glass',
    gls_frame:'back_glass', gls_sharp:'back_glass', gls_cosmetic:'back_glass',
    cm_blur:'rear_camera', cm_black:'rear_camera', cm_crash:'rear_camera',
    cm_shake:'rear_camera', cm_flash:'rear_camera', cm_switched:'rear_camera',
    cm_dust:'rear_camera', cm_lens_cracked:'camera_lens_damage', cm_notsure:'rear_camera',
    sft_wont_on:'wont_turn_on', sft_bootloop:'wont_turn_on', sft_disabled:'other_fault',
    sft_slow:'other_fault', sft_update:'other_fault', sft_other:'other_fault',
    sml_speaker:'speaker', sml_mic:'speaker', sml_earpiece:'speaker',
    sml_power_btn:'buttons', sml_vol_btn:'buttons', sml_mute:'buttons', sml_vibrate:'buttons',
    chg_angle:'charging', chg_cables:'charging', chg_loose:'charging',
    chg_nofit:'charging', chg_slow:'charging', chg_none:'charging',
    cam_blurry:'rear_camera', cam_spots:'rear_camera',
    cam_lens_cracked:'camera_lens_damage', cam_scratched:'camera_lens_damage', cam_flare:'camera_lens_damage', cam_lens_fine:'camera_lens_damage',
    cam_vibrate:'rear_camera', cam_noise:'rear_camera'
  };

  var FAULT_LABELS = {
    screen_cracked:'Cracked screen', screen_damaged:'Screen dead / no display',
    screen_touch_only:'Touch panel replacement', screen_lcd_fault:'LCD / display replacement',
    battery:'Battery issues', wont_turn_on:"Won't turn on",
    charging:'Charging issue', back_glass:'Back glass cracked',
    rear_camera:'Camera fault', camera_lens_damage:'Camera lens damaged',
    face_id:'Face ID issue',
    speaker:'Speaker / mic fault',
    buttons:'Buttons not working', water:'Water damage', other_fault:'Other fault'
  };

  function faultLabel(f) {
    if (f === 'back_glass') return HOUSING_ONLY.indexOf(S.model) !== -1 ? 'Housing replacement' : 'Back glass cracked';
    return FAULT_LABELS[f] || f;
  }
  var FAULT_TO_REPAIR_KEY = {
    screen_cracked:'screen', screen_damaged:'screen',
    screen_touch_only:'screen-touch',
    screen_lcd_fault:'screen-lcd',
    battery:'battery', wont_turn_on:null,
    charging:'charging-port', back_glass:'back-glass',
    rear_camera:'camera', camera_lens_damage:'camera-lens',
    face_id:'face-id',
    speaker:'small-parts', buttons:'small-parts',
    water:null, other_fault:null
  };

  // r165 (R-163) — `sell: true` marks a review that is about selling to us or about how we deal, never about a phone bought
  // from us or a repair: the sell only mode shows those alone, so a seller reads sellers.
  var REVIEWS = [
    { quote: '"Great communication, very honest and open"', author: 'Lisa J. · Google review', sell: true },
    { quote: '"Very easy and fast process, would highly recommend"', author: 'JElo U. · Google review', sell: true },
    { quote: '"I don\'t feel like a customer but a friend, that\'s how it should be"', author: 'Mohammad H. · Google review' },
    { quote: '"Whole process so easy, friendly, no pressure. iPad in great condition"', author: 'Hannah R. · Google review' },
    { quote: '"Quickest delivery buying a phone. Quality exactly as described. 100% coming back"', author: 'Jessie W. · Google review' },
    { quote: '"Phone was in better condition than described, Dan was even in contact through his holiday"', author: 'Owen P. · Google review' },
    { quote: '"Cash was in my account within two days. Great service, great price, hassle free"', author: 'Horses, Hounds & Heels · Google review', sell: true },
    { quote: '"Clearly trustful, honest and a mobile expert. Highly recommended"', author: 'Peter A. · Google review', sell: true },
    { quote: '"Super impressed with promptness, clear comms and honesty"', author: 'Mark S. · Google review', sell: true },
    { quote: '"Camera issue sorted straight away, no extra charge, no second questioning"', author: 'Mohammad H. · Google review' },
    { quote: '"Came through with everything promised, couldn\'t recommend better"', author: 'Kallum M. · Google review', sell: true }
  ];

  /* HELPERS */
  function $(id)   { return document.getElementById(id); }
  function show(el){ if (el) el.classList.remove('cd-hidden'); }
  function hide(el){ if (el) el.classList.add('cd-hidden'); }

  function escHTML(s) {
    return String(s || '').replace(/[&<>"']/g, function(c){
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function priceFor(model, repair, parts) {
    if (!model || !repair) return null;
    if (repair === 'software' || repair === 'other' || repair === 'water') return DIAG_FEE;
    if (repair === 'face-id') {
      if (faceIdQuoteOnly(model)) return null;   // r150: repairable, quoted personally (no flat price)
      return faceIdFixable(model) ? FACE_ID_PRICE : DIAG_FEE;
    }
    if (repair === 'camera-lens') return CAM_LENS_PRICE;
    if (repair === 'small-parts') {
      return REPAIR_PRICES[model + '::charging-port'] || null;
    }
    if (repair === 'back-glass' && HOUSING_ONLY.indexOf(model) !== -1) {
      return REPAIR_PRICES[model + '::housing'] || null;
    }
    if (repair === 'back-glass' && model.indexOf('Pixel') !== -1) {
      return null;
    }
    if (parts) {
      var keyed = REPAIR_PRICES[model + '::' + repair + '::' + parts];
      if (keyed != null) return keyed;
    }
    var bare = REPAIR_PRICES[model + '::' + repair];
    if (bare != null) return bare;
    if (repair === 'screen') {
      var sLcd = REPAIR_PRICES[model + '::screen::lcd'];
      if (sLcd == null) sLcd = REPAIR_PRICES[model + '::screen::oled'];
      if (sLcd == null) sLcd = REPAIR_PRICES[model + '::screen::genuine'];
      return sLcd != null ? sLcd : null;
    }
    if (repair === 'battery' || repair === 'screen-lcd' || repair === 'screen-touch') {
      return REPAIR_PRICES[model + '::' + repair + '::third-party'] || null;
    }
    return null;
  }

  var FAULT_REDUCTIONS = {
    screen_cracked: 0.35, screen_damaged: 0.35,
    battery: 0.15, charging: 0.12,
    back_glass: 0.25, rear_camera: 0.20,
    camera_lens_damage: 0.12,
    speaker: 0.10, buttons: 0.10,
    wont_turn_on: 0.50, water: 0.50,
    other_fault: 0.15
  };

  function applyLivePricing(table) {
    // r163 (PDX-04) — A ROW IS CHECKED BEFORE IT PRICES ANYTHING. liveValueFor did arithmetic on whatever a row held, so a
    // 'good' that was text, blank or missing gave NaN, and the quote read "£NaN" and stored no price. A row whose 'good' is not
    // a number above £0 is set aside as unreadable (the model then reads as "we'll quote you personally", the same answer a
    // manual row gets: the table carries the model, so the built in figures must not stand in for it). Any other column that
    // is not a number of £0 or more reads as missing, which already means "quote this fault personally" where it is asked.
    var BUY_COLUMNS = ['low', 'screen', 'battery', 'screen_battery', 'untestable', 'recycle', 'credit_max'];
    function readBuyRows(buy) {
      var rows = {}, unreadable = [];
      if (!buy || typeof buy !== 'object') return { rows: rows, unreadable: unreadable };
      Object.keys(buy).forEach(function (k) {
        var row = buy[k];
        var good = row && typeof row === 'object' && row.good !== null && row.good !== '' ? Number(row.good) : NaN;
        if (!isFinite(good) || good <= 0) { unreadable.push(k); return; }
        var out = {};
        Object.keys(row).forEach(function (c) { out[c] = row[c]; });
        out.good = good;
        BUY_COLUMNS.forEach(function (c) {
          if (row[c] == null || row[c] === '') { out[c] = null; return; }
          var v = Number(row[c]);
          out[c] = isFinite(v) && v >= 0 ? v : null;
        });
        rows[k] = out;
      });
      return { rows: rows, unreadable: unreadable };
    }
    // r168 (PDX-03, its theme half) — AN ANSWER OF OFF WITHDRAWS A TABLE THIS PAGE ALREADY APPLIED. A page now fetches the
    // table again once it has held it a while (ageLivePricing), and "off" then puts back the built in figures as the theme
    // shipped them (BAKED_FIGURES): the prices a page opened now would show. A failed fetch is not an answer and never
    // comes here once a table is held; a page that never applied one has nothing to withdraw.
    if (!table || table.mode !== 'live') {
      if (!table || typeof table !== 'object' || !LIVE) return false;
      Object.keys(REPAIR_PRICES).forEach(function (k) { delete REPAIR_PRICES[k]; });
      Object.keys(BAKED_FIGURES.repair).forEach(function (k) { REPAIR_PRICES[k] = BAKED_FIGURES.repair[k]; });
      DIAG_FEE = BAKED_FIGURES.diag; CAM_LENS_PRICE = BAKED_FIGURES.lens; FACE_ID_PRICE = BAKED_FIGURES.face;
      LIVE = null; LIVE_MANUAL = []; LIVE_UNREADABLE = []; PRICING_VERSION = BAKED_FIGURES.version;
      return true;
    }
    if (table.repair) {
      // r158 (app v915; Claude cloud audit CC-18) — a live price of £0 or less is "contact us": it takes the price away (the page
      // says Contact us and a bundle leaves it out), where it used to be stored as 0 and shown as a £0 line in every bundle.
      Object.keys(table.repair).forEach(function (k) {
        var v = Number(table.repair[k]);
        if (isFinite(v) && v > 0) REPAIR_PRICES[k] = v;
        else if (isFinite(v)) delete REPAIR_PRICES[k];
      });
    }
    if (table.fees) {
      // r158 (CC-18's sibling) — a fee is a price shown as it stands ("£0 diagnostic"), so only one above £0 replaces the built in one
      var fee = function (v, was) { v = Number(v); return isFinite(v) && v > 0 ? v : was; };
      DIAG_FEE = fee(table.fees.diag_fee, DIAG_FEE);
      CAM_LENS_PRICE = fee(table.fees.camera_lens, CAM_LENS_PRICE);
      FACE_ID_PRICE = fee(table.fees.face_id, FACE_ID_PRICE);
    }
    var checked = readBuyRows(table.buy);
    LIVE = checked.rows;
    LIVE_UNREADABLE = checked.unreadable;
    // a row with no usable price is a personal quote, never the built in figure: listing it as manual is what says so
    LIVE_MANUAL = (Array.isArray(table.manual) ? table.manual : []).concat(checked.unreadable);
    PRICING_VERSION = table.pricing_version || 'live';
    return true;
  }
  // r163 (PDX-04) — the line the lead and the summary carry when the built in figures, or a personal quote, stood in for
  // the live table. Empty when the table priced this quote.
  function livePricingNote(kind, model) {
    if (LIVE_STATE === 'waiting') return 'Live price table: had not arrived, built in figures';
    if (LIVE_STATE === 'off') return 'Live price table: switched off, built in figures';
    if (LIVE_STATE === 'failed') return 'Live price table: failed to load, built in figures';
    var aged = liveAgeNote();   // r168 (PDX-03): a table held past its age says so on any quote it priced
    if (kind === 'repair' || !model) return aged;
    if (isRecycleOnly(model)) return '';   // never priced, and the truth check's rule: the recycle check before any row is read
    var mine = function (k) { return String(k).split('|')[0] === model; };
    if (LIVE_UNREADABLE.some(mine)) return 'Live price table: this model\'s row was unreadable, quoted personally';
    // liveRowFor's own answer: no row and an undefined miss is "not a live model", which is what sends a quote to the built
    // in figures (a null miss is the table carrying the model at another capacity, or as a manual row)
    var found = liveRowFor(model);
    if (!found.row && found.miss === undefined) return 'Live price table: does not carry this model, built in figures';
    return aged;
  }
  // r168 (PDX-03) — the line a quote carries when the table that priced it had been held past LIVE_MAX_AGE_MS (its fetch
  // again failed, or was still on its way); empty while the table is fresh. Measured on this device's clock alone.
  function liveAgeNote() {
    if (LIVE_STATE !== 'live' || !LIVE_AT) return '';
    var held = Date.now() - LIVE_AT;
    if (held >= 0 && held <= LIVE_MAX_AGE_MS) return '';
    var mins = Math.floor(held / 60000);
    var age = held < 0 ? 'of unknown age (this device\'s clock moved back)'
      : mins < 120 ? mins + ' minutes old' : mins < 2880 ? Math.floor(mins / 60) + ' hours old' : Math.floor(mins / 1440) + ' days old';
    return 'Live price table: ' + age + ' on this page, ' + (LIVE_FETCHING ? 'a fresh copy was on its way' : 'a fresh copy could not be fetched');
  }
  // r168 (PDX-03, its theme half) — A TABLE THIS PAGE HAS HELD FOR A WHILE IS FETCHED AGAIN. It was fetched once, when the
  // page opened, so a tab left open (on a desk overnight, or brought back from the phone's tab list or the browser's
  // history) went on quoting from it however old it was, and the lead carried those figures as the customer's quote. Now a
  // table held past LIVE_MAX_AGE_MS is fetched again: on the minute tick while the page is in view, and as soon as it comes
  // back into view (init). A changed table redraws the prices on screen; the same figures sent again only renew the
  // version; "off" puts back the built in figures; a fetch that fails keeps the table held, is tried again no sooner than
  // LIVE_TRY_GAP_MS, and the lead says how old the held table was (liveAgeNote). The age is this device's clock measured
  // against itself, so a clock that disagrees with the app's can neither age a table nor keep one young, and a clock that
  // moved back reads as old.
  var LIVE_MAX_AGE_MS = 30 * 60 * 1000;
  var LIVE_TRY_GAP_MS = 5 * 60 * 1000;
  var LIVE_AT = 0;            // when the app last answered with a table or with off (0: it has not)
  var LIVE_TRIED_AT = 0;      // when the last fetch set out
  var LIVE_FETCHING = false;
  var LIVE_SIG = '';          // the figures of the table held, to tell a changed table from the same one sent again
  // the built in figures as the theme shipped them, taken before any table is laid over them, for an answer of off
  var BAKED_FIGURES = (function () {
    var repair = {};
    Object.keys(REPAIR_PRICES).forEach(function (k) { repair[k] = REPAIR_PRICES[k]; });
    return { repair: repair, diag: DIAG_FEE, lens: CAM_LENS_PRICE, face: FACE_ID_PRICE, version: PRICING_VERSION };
  })();
  function liveSignature(t) { return JSON.stringify([t.buy || null, t.manual || null, t.repair || null, t.fees || null]); }
  // the app's answer: a table, off, or nothing usable (r163, PDX-04: off is the app saying so; anything else that is not a
  // live table is a failure). Only an answer moves the state once one has come; a failure moves only the first wait.
  function takeLiveAnswer(t) {
    var answer = t && typeof t === 'object' ? (t.mode === 'live' ? 'live' : 'off') : 'failed';
    if (answer === 'failed') { if (LIVE_STATE === 'waiting') LIVE_STATE = 'failed'; return; }
    var sig = answer === 'live' ? liveSignature(t) : '';
    var changed = sig !== LIVE_SIG || answer !== LIVE_STATE;
    LIVE_STATE = answer; LIVE_SIG = sig; LIVE_AT = Date.now();
    // WEB-046 — A PRICE ARRIVING IS NOT A NEW MODEL. This used to call onModelChange(S.model), which
    // clears every answer (repair, part, symptoms, storage, intent) while leaving the screen where it
    // was — so a deep-linked or quick customer ended on 'Repair · Contact us · not yet listed' with the
    // genuine battery they had just chosen gone. Only the things DERIVED from prices are redrawn.
    if (applyLivePricing(t) && changed) refreshPricedViews();
  }
  // init calls this each minute and when the page comes back into view: a fresh table, a fetch already out, or a page
  // out of view does nothing
  function ageLivePricing() {
    if (LIVE_FETCHING || LIVE_STATE === 'waiting') return false;
    if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return false;
    var now = Date.now(), held = now - LIVE_AT, since = now - LIVE_TRIED_AT;
    if (LIVE_AT && held >= 0 && held < LIVE_MAX_AGE_MS) return false;
    if (since >= 0 && since < LIVE_TRY_GAP_MS) return false;
    loadLivePricing(true);
    return true;
  }
  // R-130 (SJ-01) — the table used to be built on request (2.0–2.9 s) and this gave up at 2.5 s, so the first visitor
  // after each cache expiry got the old baked prices — up to 62% above the engine — shown as "highly accurate". The app
  // now prepares the table ahead (v522), this waits up to 6 s, and one failed attempt is retried once.
  function loadLivePricing(isRetry) {
    try {
      LIVE_FETCHING = true;
      LIVE_TRIED_AT = Date.now();
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 6000) : null;
      return fetch(OPS_PRICING_URL, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (t) { if (timer) clearTimeout(timer); LIVE_FETCHING = false; takeLiveAnswer(t); })
        .catch(function () {
          LIVE_FETCHING = false;
          if (LIVE_STATE === 'waiting') LIVE_STATE = 'failed';   // then baked constants stay, never labelled firm
          // the first load tries once more; after that the minute tick does the trying (a redraw that threw is no reason)
          if (!isRetry && !LIVE_AT) setTimeout(function () { loadLivePricing(true); }, 1500);
        });
    } catch (e) { LIVE_FETCHING = false; return Promise.resolve(); }
  }
  // Live trade-in valuation. Returns undefined when the model is not in the live table (→ baked maths), null when
  // the app could not price it firmly (→ "we'll quote you personally"), else the same shape compValueBaked returns.
  // v512 — ONE ROW LOOKUP, TWO CALLERS. Extracted from liveValueFor so the untestable pair below reads
  // the SAME row by the SAME rules. The audit that prompted this release found two hand-maintained
  // fault lists that had silently drifted apart (A-01); copying this lookup for the new caller would
  // have planted the identical defect in the pricing path, where it costs money rather than a button.
  //
  // Returns { row, miss } — `miss` carries liveValueFor's original two-valued answer: null means "this
  // model IS priced live but not this capacity / not automatically" (→ quote personally), undefined
  // means "not a live model at all" (→ fall through to the baked table). Those two are not
  // interchangeable and collapsing them is how a manual-quote row starts quoting a sibling's price.
  // "256GB" / "1TB" → 256 / 1000. Lives out here beside liveRowFor because BOTH lookups need it;
  // it used to sit inside liveValueFor, and moving the row lookup out without moving this left
  // liveRowFor calling a function in another function's scope — a ReferenceError on every quote.
  // The suite caught it before it shipped; the browser would have thrown on the first valuation.
  function gbOf(st) {
    var m = String(st || '').match(/([\d.]+)\s*(tb|gb)/i);
    return m ? (/tb/i.test(m[2]) ? Math.round(parseFloat(m[1]) * 1000) : parseFloat(m[1])) : null;
  }

  function liveRowFor(model) {
    // r148 (found 27 Sep, CC-04's browser check) — NO TABLE YET IS "NOT A LIVE MODEL", NEVER A CRASH. LIVE is null until
    // the app's table arrives (up to 6 s, or never when the fetch fails), and Object.keys(null) threw: the lock buttons,
    // the parts price and the result page broke half drawn. undefined sends the caller to the built in figures, as a
    // model the table does not carry already does.
    if (!LIVE) return { row: null, miss: undefined };
    var gb = gbOf(S.storage);
    var row = null;
    var known = function (k) { return k.split('|')[0] === model; };
    if (gb != null) {
      // DOR-80 — A CHOSEN CAPACITY IS PRICED FROM ITS OWN ROW OR NOT AT ALL. This used to fall through to
      // the cheapest sibling, so a 128GB the app had deliberately made a manual quote was offered the
      // 256GB price. The server keys 1TB as "1000" and any other TB as its label ("2TB"): try both.
      var tb = String(S.storage || '').replace(/\s+/g, '').toUpperCase();
      row = LIVE[model + '|' + gb] || (/TB$/.test(tb) ? LIVE[model + '|' + tb] : null) || null;
      if (!row) return { row: null, miss: (Object.keys(LIVE).some(known) || LIVE_MANUAL.some(known)) ? null : undefined };
    } else {
      Object.keys(LIVE).forEach(function (k) { if (known(k) && (!row || LIVE[k].good < row.good)) row = LIVE[k]; }); // no storage yet → the cheapest storage with a live offer (storage only adds value)
    }
    if (!row) return { row: null, miss: LIVE_MANUAL.some(known) ? null : undefined };
    return { row: row, miss: undefined };
  }

  function liveValueFor(model, cond, faults) {
    if (!LIVE || !model) return undefined;
    var found = liveRowFor(model);
    if (found.row == null) return found.miss;   // null = "we'll quote personally", undefined = not a live model
    var row = found.row;
    var fs = (faults || []).filter(function (f) { return f && f !== 'none'; });
    var hasScreen = fs.some(function (f) { return f === 'screen_cracked' || f === 'screen_damaged'; });
    var hasBattery = fs.indexOf('battery') !== -1;
    var others = fs.filter(function (f) { return f !== 'screen_cracked' && f !== 'screen_damaged' && f !== 'battery'; });
    var hi = row.good, lo = row.low;
    if (hasScreen && hasBattery) { if (row.screen_battery == null) return null; hi = row.screen_battery; lo = null; }
    else if (hasScreen) { if (row.screen == null) return null; hi = row.screen; lo = null; }
    else if (hasBattery) { if (row.battery == null) return null; hi = row.battery; lo = null; }
    // Faults the app does not price per part keep the calculator's published deductions, applied to the app's offer.
    var r = 0; others.forEach(function (f) { r += (FAULT_REDUCTIONS[f] || 0); }); r = Math.min(r, 0.60);
    // Condition: 'fair' keeps its published 0.70; 'likenew' is NOT uplifted — the app's offer is the safe ceiling.
    var gm = cond === 'fair' ? 0.70 : 1.00;
    var f5 = function (x) { return Math.max(Math.floor(x / 5) * 5, 0); };
    var cashHi = f5(hi * gm * (1 - r));
    var cash = lo != null ? f5(lo * gm * (1 - r)) : cashHi;
    if (cashHi < 10) return null;
    // D-20260915-o / R-116: a quote is a RANGE, never "£55 – £55". The app's offer is the TOP; the range starts at
    // least 10% below it. A row's own Grade-C low stays where it is lower. The low end only ever moves DOWN from
    // the app's figure, so it can never promise more than the engine would pay (BD-002).
    // D-20260921-k (SJ-42) — Dan: "more variation on the prices … more wiggle room". 20% under the top (was 10%). The TOP
    // is still the engine's figure, so the range can only widen downwards and never promises more (BD-002).
    cash = Math.min(cash, f5(cashHi * 0.80));
    if (cash > cashHi) cash = cashHi;
    var c5 = function (x) { return Math.ceil(x / 5) * 5; };
    var upgLo = Math.max(c5(cash * 1.375), 10);          // the calculator's published 0.55/0.40 uplift ratio, unchanged (uplift model still an open decision)
    var upgHi = Math.max(c5(cashHi * 1.30), upgLo + 5);   // the calculator's published ×1.30, unchanged
    // r150 (app v764, Dan D-20260927-a (4)) — TRADE IN CREDIT NEVER ABOVE CeX'S VOUCHER PRICE PLUS 10%. The app sends that
    // limit as credit_max on the phone's row (null when CeX has no fresh voucher price: then ×1.30 stands, as before).
    // The credit is held under it but never under the cash figure it exists to beat; the low end follows the top down.
    var cm = Number(row.credit_max);
    if (row.credit_max != null && isFinite(cm) && cm > 0) {
      upgHi = Math.max(cashHi, Math.min(upgHi, Math.floor(cm / 5) * 5));
      upgLo = Math.min(upgLo, upgHi);
    }
    return { cash: cash, cashHi: cashHi, upgrade: upgLo, upgHi: upgHi, live: true, asOf: row.anchor_at || null };
  }
  // ── v512 — THE UNTESTABLE PAIR (Dan, 2026-09-20) ────────────────────────────────────────────────
  // "anything untestable is given a working but worse case scenario part wise price and a recycling
  // price". A phone we cannot power on gets TWO figures instead of "We'll assess": what we pay if it
  // turns out to work, and what we pay if it turns out to be parts.
  //
  // Both come from the server (`untestable` and `recycle` on the live row) — NOT computed here. The
  // working branch already has a screen, a housing and a battery deducted at the worst case and has
  // passed the same no-loss ceiling as every other column, and the recycling band is already clamped
  // to sit strictly below every other figure for that phone. Re-deriving either here would be a
  // second cost model, which is precisely the shape that produced the v511 defect.
  //
  // `other_fault` is deliberately NOT in this list: Dan picked won't-turn-on, screen-dead and water,
  // and the catch-all box can contain anything, so a screen+housing+battery worst case says nothing
  // useful about it. It keeps "We'll assess".
  var UNTESTABLE_FAULTS = ['wont_turn_on', 'water', 'screen_damaged'];
  // Liquid damage that powers on today can corrode and die on the bench next week, and "not as
  // described" does not cover it because the seller described it honestly. Dan chose an extra
  // deduction on the water working branch over capping it or ignoring the risk. DAN-CONFIGURABLE.
  var WATER_RISK_FACTOR = 0.70;

  // The per-phone recycling band, or null when the server did not publish one for this row (→ quote
  // personally). Used by the untestable pair AND by the lock panel, which used to state a flat "£20"
  // in the markup — the same number for an iPhone 7 and a 17 Pro Max, and a figure the engine could
  // not move. Dan, 2026-09-20: "recycling should change with device as well then".
  function recycleBandFor(model) {
    if (isRecycleOnly(model)) return null;
    var found = liveRowFor(model);
    if (!found.row) return null;
    var r = found.row.recycle;
    return (r != null && isFinite(Number(r))) ? Number(r) : null;
  }

  function untestablePairFor(model, faults) {
    if (isRecycleOnly(model)) return null;                       // D-20260911-d still dominates
    var fs = (faults || []).filter(function (f) { return f && f !== 'none'; });
    if (!fs.some(function (f) { return UNTESTABLE_FAULTS.indexOf(f) !== -1; })) return null;
    if (fs.indexOf('other_fault') !== -1) return null;           // unknown fault → no worst case to quote
    var found = liveRowFor(model);
    if (!found.row) return null;
    var row = found.row;
    var recycle = (row.recycle != null && isFinite(Number(row.recycle))) ? Number(row.recycle) : null;
    var hi = (row.untestable != null && isFinite(Number(row.untestable))) ? Number(row.untestable) : null;
    // Face ID on a phone we cannot test: the working branch depends on Face ID passing, and we cannot
    // check that on a phone that will not power up. Dan, 2026-09-20: "face id will have to work for the
    // working device. and if not we can fall back to recycling". So the pair collapses to the band.
    // (A Face ID fault on an otherwise WORKING phone stays a personal quote — compValueFor refuses it.)
    if (fs.indexOf('face_id') !== -1) hi = null;
    // v513 (ChatGPT v512 watch, OPEN MEDIUM) — THE ENVELOPE HAS A SHAPE, AND A FAULT OUTSIDE IT IS NOT PRICED BY IT.
    // `row.untestable` deducts a screen, a housing and a battery at the worst case — nothing else. A seller who
    // also ticks a camera, speaker, charging or button fault was getting the SAME "if it works" figure as one who
    // did not, so declaring extra damage honestly changed nothing. Rather than invent a second cost model here,
    // any known fault outside the envelope takes the working branch away — the same fallback as Face ID: the
    // parts figure still stands, and the working price is quoted personally.
    var ENVELOPE = ['wont_turn_on', 'water', 'screen_damaged', 'screen_cracked', 'screen_touch_only',
      'screen_lcd_fault', 'battery', 'back_glass', 'face_id'];
    if (fs.some(function (f) { return ENVELOPE.indexOf(f) === -1; })) hi = null;
    var f5 = function (x) { return Math.max(Math.floor(x / 5) * 5, 0); };
    if (hi != null && fs.indexOf('water') !== -1) hi = f5(hi * WATER_RISK_FACTOR);
    // A network-locked phone is worth less WORKING (the existing 10% rule); its PARTS are worth the
    // same either way, so the band is left alone.
    if (hi != null && S.carrier === 'no') hi = f5(hi * NETWORK_LOCK_FACTOR);
    // The working branch is a RANGE on the same rule as every other quote (R-116: never "£55 – £55"),
    // and it must stay above the band or it is not a second outcome at all.
    if (hi != null && (hi < 10 || (recycle != null && hi <= recycle))) hi = null;
    if (hi == null && recycle == null) return null;              // nothing provable → "We'll assess"
    var lo = hi != null ? Math.min(f5(hi * 0.90), hi) : null;
    return { workingLo: lo, workingHi: hi, recycle: recycle, asOf: row.anchor_at || null };
  }

  function compValueFor(model, cond, faults, ignoreNetwork) {
    // D-20260911-d: FIRST — before the live table or the baked maths can put a figure on it. Every caller checks
    // .recycle; the zeros are only there so nothing downstream can do arithmetic on a missing field.
    if (isRecycleOnly(model)) return { recycle: true, cash: 0, cashHi: 0, upgrade: 0, upgHi: 0 };
    // R-109 (2026-09-20) — FACE ID HAS NO AUTOMATIC PRICE, ON EITHER PATH.
    //
    // `face_id` is a selectable fault (FAULT_LABELS, the fault checklist) and was absent from
    // FAULT_REDUCTIONS, so the reduction loop below added 0 for it and a phone with a dead Face ID
    // was offered the FULL working price. Not a rounding error: a broken TrueDepth module is a
    // board-level repair, and the £220 repair price on 12–16 says what it is worth.
    //
    // The fix is a refusal, NOT a percentage. PRICING_LOGIC's prohibited list names "universal Face
    // ID deduction" explicitly, and the ops app already marks it manual — a number invented here to
    // fill the gap would contradict both. Face ID is also the one fault whose real cost depends on
    // whether the module or the flex failed, which cannot be known before inspection.
    //
    // It sits in compValueFor, after the recycle guard and BEFORE liveValueFor and compValueBaked,
    // because those two are the only pricing paths and this is the only door both pass through —
    // one rule, one door. Returning null is the established "we'll quote you personally" signal
    // that every caller already handles.
    if ((faults || []).indexOf('face_id') !== -1) return null;
    // r148 (Claude cloud audit CC-04) — A FAULTY PHONE IS PRICED AT THE LOOKS IT WAS GIVEN. The faulty branch never asked the
    // grade and 'broken' took the 1.00 multiplier, so a worn phone declared with a cracked camera lens was offered MORE than
    // the same phone answered honestly as Fair and working (£205 to £260 against £140 to £175 on the audit's run), against
    // Dan's rule that declaring more damage never pays more (v522, SJ-02). Fair looks now take Fair's 0.70 on the live and
    // the baked path alike. Good looks, or none given (the repair page's trade in figure never asks), keep the 1.00.
    var priced = cond === 'broken' && S.faultGrade === 'fair' ? 'fair' : cond;
    var live = liveValueFor(model, priced, faults);
    var v = live !== undefined ? live : compValueBaked(model, priced, faults);
    return ignoreNetwork ? v : applyNetworkLock(v);
  }
  // D-20260915-n rule 4 + D-20260915-o: a phone locked to one network is worth less — 10% off every figure. Only
  // once the seller has SAID it is locked; an unanswered question takes nothing off. `ignoreNetwork` lets the
  // breakdown show the unlocked figure beside the deduction instead of hiding the 10% inside "clean & working".
  var NETWORK_LOCK_FACTOR = 0.90;
  function applyNetworkLock(v) {
    if (!v || v.recycle || S.carrier !== 'no') return v;
    var f5 = function (x) { return Math.max(Math.floor(x / 5) * 5, 0); };
    var cashHi = f5(v.cashHi * NETWORK_LOCK_FACTOR);
    if (cashHi < 10) return null;   // same floor as the live table: below £10 we quote personally, never a £5 promise
    var cash = Math.min(f5(v.cash * NETWORK_LOCK_FACTOR), cashHi);
    var upgrade = Math.max(f5(v.upgrade * NETWORK_LOCK_FACTOR), 10);
    var upgHi = Math.max(f5(v.upgHi * NETWORK_LOCK_FACTOR), upgrade + 5);
    return { cash: cash, cashHi: cashHi, upgrade: upgrade, upgHi: upgHi, live: v.live, asOf: v.asOf || null, networkLocked: true };
  }
  function compValueBaked(model, cond, faults) {
    if (!model || !cond) return null;
    var baseline = null;
    Object.keys(COMP).forEach(function(k) {
      if (k.split('|')[0] === model) {
        var p = COMP[k];
        if (baseline === null || p < baseline) baseline = p;
      }
    });
    if (!baseline) return null;
    var gm = cond === 'likenew' ? 1.20 : cond === 'fair' ? 0.70 : 1.00;
    var r = 0;
    (faults || []).forEach(function(f) {
      r += (FAULT_REDUCTIONS[f] || 0);
    });
    r = Math.min(r, 0.60);
    var adj = Math.ceil(baseline * 0.80 * gm * (1 - r) / 5) * 5;
    var cashLo = Math.max(Math.ceil(adj * 0.40 / 5) * 5, 10);
    var cashHi = Math.max(Math.ceil(adj * 0.65 / 5) * 5, cashLo + 5);
    var upgLo  = Math.max(Math.ceil(adj * 0.55 / 5) * 5, 10);
    var upgHi  = Math.max(Math.ceil(cashHi * 1.30 / 5) * 5, upgLo + 5);
    return { cash: cashLo, cashHi: cashHi, upgrade: upgLo, upgHi: upgHi };
  }

  // ── ONE WRITER FOR EVERY "£X – £Y" (R-116, Dan 2026-09-16) ───────────────────────────────────
  // Dan caught the trade-in banner reading *"Trade in and get £20 – £20 more"*. It was not one bad
  // line. The calculator built a range string in TEN places and only the teaser guarded the two ends
  // being equal — and R-116 had made the PRICES wide, which is a different promise from making the
  // RENDERING honest: the day any row's low equals its high, every unguarded site prints "£55 – £55"
  // again, including the breakdown total that Dan reported R-116 for in the first place.
  // So the rule lives at ONE door and every site calls it (L-always-08: enumerate the writers, and
  // make the enumeration something the code re-derives rather than something a reader must remember).
  function moneyRange(lo, hi, suffix) {
    var s = suffix || '';
    if (lo == null || hi == null) return '';
    return (lo === hi) ? ('£' + lo + s) : ('£' + lo + ' to £' + hi + s);
  }

  // ── THE STEP MACHINE ──────────────────────────────────────────────────────────────────────────
  // R-096 (2026-09-14). The SELL / TRADE-IN path is four steps: s0 → s1 → st-check → st3.
  // `st1` (grade picker), `st2` (fault log) and `st2b` (per-fault detail) are gone from this list
  // because they are no longer destinations — their markup lives inside `st-check` and is revealed
  // in place. Repair followed on 2026-10-05 (R-096's second wave): see REPAIR_PANELS below.
  var STEP_IDS = [
    's0','s1','sr1','sr2','sr-batt-health','sr3','sr4',
    'sr-screen','sr-batt','sr-glass','sr-cammod','sr-soft','sr-small','sr-charge','sr-cam','sr-faceid','sr-water',
    'st-check','st3','success'
  ];
  // R-096, SECOND WAVE (2026-10-05) — THE REPAIR PATH IS FOUR SCREENS TOO: device, choice, "What's wrong with it?", price.
  // These ids are not screens any more. Their markup lives INSIDE #cdmc-sr1, in the order a customer meets them (the
  // symptom check, the part quality, battery health, any other faults), and goStep reveals each one there, under the
  // answers already given, instead of swapping the page. Measured on the harness before the fold
  // (tools/calc-repair-walk.mjs): 6 to 10 screens to a repair price, every one from sr1 on labelled "03 / 04"; the per
  // fault detail screen (sr-detail, once per extra fault) is gone, its questions open under "Any other faults?".
  // They stay in STEP_IDS so a screen change still hides every one of them.
  var REPAIR_PANELS = ['sr-screen','sr-batt','sr-glass','sr-cammod','sr-soft','sr-small','sr-charge','sr-cam','sr-faceid','sr-water',
    'sr2','sr-batt-health','sr3'];
  function isRepairPanel(id) { return REPAIR_PANELS.indexOf(id) !== -1; }
  function screenOf(id) { return isRepairPanel(id) ? 'sr1' : id; }

  // The four tracker stages are read off this percentage (>=90 → 4, >=65 → 3, >=40 → 2), so the
  // sell path's three values have to land in three different bands or the tracker stalls on one
  // stage for the whole quote. `st-check` is stage 3 because it IS the third of four screens.
  // r157 (app v914; Codex FSA-007's new repair gate found it): the battery health question, which every iPhone repair
  // but a battery one walks through between the parts and the options, had no value here, so the bar emptied to 0 and
  // the tracker fell back to stage 1 for that one screen. tools/theme-repair-flow-check.mjs holds every screen to a value
  // and the repair path to never going back.
  // R-096 (second wave): the folded repair screen is stage 3 like selling's condition screen, so the whole of it sits in
  // the stage 3 band and its panels move the bar on as they open, never back, never into the price's band.
  var STEP_PROGRESS = {
    s0:10, s1:40, sr1:65, sr4:90,
    'sr-screen':70,'sr-batt':70,'sr-glass':70,'sr-cammod':70,
    'sr-soft':70,'sr-small':70,'sr-charge':70,'sr-cam':70,'sr-faceid':70,'sr-water':70,
    sr2:74, 'sr-batt-health':78, sr3:82,
    'st-check':65, st3:90, success:100
  };

  function updateProgressTracker(id) {
    var pct = STEP_PROGRESS[id] || 0;
    var active = pct >= 90 ? 4 : pct >= 65 ? 3 : pct >= 40 ? 2 : 1;
    document.querySelectorAll('.cdmc__tracker-stage').forEach(function(el){
      var st = parseInt(el.getAttribute('data-stage'), 10);
      el.classList.toggle('done', st < active);
      el.classList.toggle('current', st === active);
    });
    var s2 = $('cdmc-stage2-name'), s3 = $('cdmc-stage3-name');
    // Each stage names the screen the customer is actually on. It used to read "Check", naming a
    // Device-check SCREEN that R-096 folded into Condition — a tracker label for a screen that no
    // longer exists is the same defect as a stale step counter, in the widget that exists to say
    // where you are. Since R-096's second wave both paths are four screens, so stage 2 is the choice for
    // both and stage 3 is what the third screen asks: the condition to sell, the fault to repair.
    if (s2) s2.textContent = 'Choose';
    if (s3) s3.textContent = S.intent === 'repair' ? 'Fault' : 'Condition';
    var msg = $('cdmc-tracker-msg');
    if (msg) {
      var m;
      if (id === 'success') m = '\u2705 All done!';
      // FSA-014: a refused phone has no details to give, so the tracker does not ask for them
      else if (id === 'st3' && S.blacklist === 'stolen') m = '\u26d4 We can\u2019t buy this phone';
      else if (pct >= 90) m = '\ud83d\ude80 Almost finished, just your details';
      else if (pct >= 65) m = '\ud83c\udf89 You\u2019re nearly there!';
      else if (pct >= 40) m = '\u2705 Looking good so far';
      else m = '\u26a1 Just a few quick questions';
      msg.textContent = m;
    }
  }
  /* CONSENT (2026-09-13) — snippets/cd-consent.liquid owns the choice and defines window.CDConsent
     first in <head>. ⚠ `typeof window.gtag === 'function'` is NOT a consent test, and it was never a
     working "is tracking on" test either: it was false for the entire life of the Google Ads
     conversion below, so that conversion never fired once and every quote Dan took was invisible to
     Ads (L-always-14). Fails CLOSED — no CDConsent on the page means nothing is tracked. */
  function analyticsAllowed() {
    try { return !!(window.CDConsent && window.CDConsent.granted()); } catch (e) { return false; }
  }
function trackStep(id) {
    if (!analyticsAllowed()) return;   // "Necessary only" means necessary only — nothing below fires
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'calc_step', { step_id: id, intent: S.intent || 'none', device: S.type || '' });
      }
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'cdmc_step', cdmc_step: id, cdmc_intent: S.intent || 'none' });
      }
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'cdmc_step', id);
        window.clarity('set', 'cdmc_furthest', id);
      }
    } catch (e) {}
  }
  // R-096 (second wave) — WHICH PANEL WAS JUST ANSWERED. The click handler sets it from the control's own panel and goStep
  // reads it once: the next panel opens under that one and every panel after it goes, so what follows is asked again
  // from the new answer (going back to a screen and answering it again did the same). Code that opens a panel with no
  // click behind it (a link that names a fault) leaves it empty, and the panel is added at the end.
  var _panelSource = null;
  function dropPanelsAfter(id) {
    if (!S.panels) S.panels = [];
    var at = id === 'sr1' ? -1 : S.panels.indexOf(id);
    if (id !== 'sr1' && at === -1) return;
    S.panels.slice(at + 1).forEach(function (p) { hide($('cdmc-' + p)); });
    S.panels = S.panels.slice(0, at + 1);
    if (screenOf(S.current) === 'sr1') S.current = S.panels.length ? S.panels[S.panels.length - 1] : 'sr1';
  }
  // r165 (R-163) — `stay`: draw the screen without scrolling to it. Only the sell ad page's first draw uses it: there the
  // headline and promises above the tool ARE the ad's message, and the first draw scrolled straight past them on load
  // (measured on the harness: 469 px at phone width). Every screen change a visitor makes still scrolls as before.
  function goStep(id, pushHistory, stay) {
    if (!S.panels) S.panels = [];
    var src = _panelSource; _panelSource = null;
    var panel = isRepairPanel(id);
    var to = screenOf(id);
    var from = S.current ? screenOf(S.current) : '';
    // History holds SCREENS, never panels. Going on from the folded repair screen to the price always leaves the way
    // back to it: the price is reached with pushHistory false from several doors, and before the fold Back then landed
    // on whichever sub screen happened to be pushed last. (Only going ON: Back from it to the choice must not push it.)
    if (from && from !== to && (pushHistory !== false || (from === 'sr1' && to === 'sr4'))) S.history.push(from);
    if (to === 'sr1') {
      if (!panel) { if (pushHistory !== false) S.panels = []; }   // a fresh visit asks again; Back keeps the answers on show
      else {
        if (src === 'sr1' || (src && S.panels.indexOf(src) !== -1)) dropPanelsAfter(src);
        else if (S.panels.indexOf(id) !== -1) S.panels = S.panels.slice(0, S.panels.indexOf(id));
        if (S.panels[S.panels.length - 1] !== id) S.panels.push(id);
      }
    }
    STEP_IDS.forEach(function(s){ hide($('cdmc-' + s)); });
    show($('cdmc-' + to));
    if (to === 'sr1') S.panels.forEach(function (p) { show($('cdmc-' + p)); });
    S.current = to === 'sr1' && S.panels.length ? S.panels[S.panels.length - 1] : id;
    saveQuoteState();
    var prog = STEP_PROGRESS[id] || 0;
    var bar = $('cdmc-prog-fill');
    if (bar) bar.style.width = prog + '%';
    updateProgressTracker(id);
    trackStep(id);
    var back = $('cdmc-back');
    if (back) {
      if (id === 's0' || id === 'success' || S.history.length === 0) hide(back);
      else show(back);
    }
    // A new screen scrolls to the top of the quote tool; a panel opening on the folded repair screen scrolls to that panel,
    // so the question just asked is the one in view (the answers above it stay on the page).
    var calcTop = panel ? $('cdmc-' + id) : $('cdmc');
    if (calcTop && !stay) {
      // r152 (app v783; Codex FSA-067) — the site's menu sticks to the top once the page scrolls (#cdn-sticky-wrap,
      // newnav.liquid), and the step landed under it, the tracker hidden. It lands below the menu now.
      var sticky = document.getElementById('cdn-sticky-wrap');
      var menuH = sticky ? Math.max(0, Math.round(sticky.getBoundingClientRect().height)) : 0;
      var offset = calcTop.getBoundingClientRect().top + window.pageYOffset - 12 - menuH;
      try { window.scrollTo({ top: offset, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, offset); }
    }
  }

  function goBack() {
    if (S.history.length === 0) return;
    var prev = S.history.pop();
    goStep(prev, false);
  }

  function populateModels(type) {
    var sel = $('cdmc-model-sel');
    if (!sel) return;
    sel.innerHTML = '<option value="">Choose your model</option>';
    var list = MODELS[type] || [];
    list.forEach(function(m){
      var o = document.createElement('option');
      o.value = m; o.textContent = m;
      sel.appendChild(o);
    });
  }

  // r149 (Codex FSA-015, FSA-065) — WHAT A PHONE HAS, so the calculator offers only repairs and faults it can have. Face ID
  // is on iPhone X and later (never an SE, 7 or 8) and on iPad Pro; face unlock on a Samsung or a Pixel is not Face ID. A
  // glass back is on iPhone 8 and later (the 7's back is aluminium: its Frame repair stays) and on Samsung and Pixel, never
  // an iPad. The shared "any other faults" grid and the seller's fault chips follow the same answer.
  function deviceHas(part) {
    var m = String(S.model || ''), t = S.type;
    if (part === 'face_id') return t === 'iphone' ? !/^iPhone (7|8|SE)\b/.test(m) : (t === 'ipad' ? /iPad Pro/i.test(m) : false);
    if (part === 'back_glass') return t === 'iphone' ? !/^iPhone 7\b/.test(m) : t !== 'ipad';
    return true;
  }
  function applyDeviceParts() {
    var show = function (el, on) { if (el) el.style.display = on ? '' : 'none'; };
    document.querySelectorAll('.cdmc__repair-btn[data-repair="face-id"]').forEach(function (b) { show(b, deviceHas('face_id')); });
    show($('cdmc-btn-backglass'), deviceHas('back_glass'));
    document.querySelectorAll('.cdmc__vfault[data-fault="face_id"]').forEach(function (b) { show(b, deviceHas('face_id')); });
    document.querySelectorAll('.cdmc__vfault[data-fault="back_glass"]').forEach(function (b) { show(b, deviceHas('back_glass')); });
    show($('cdmc-scr-ios-note'), S.type === 'iphone');
  }

  // r154 (Codex CX0927-15) — the storage buttons too: they showed the chosen size with 'active' only, so a screen reader heard none.
  var PRESSABLE = '.cdmc__vfault, .cdmc__cond-btn, .cdmc__toggle-btn, .cdmc__faultq-btn, .cdmc__repair-btn, .cdmc__parts-btn, .cdmc__type-tab, .cdmc__storage-btn';
  function syncPressed() {
    document.querySelectorAll('#cdmc button').forEach(function (b) {
      if (b.matches && b.matches(PRESSABLE)) b.setAttribute('aria-pressed', b.classList.contains('active') ? 'true' : 'false');
    });
  }

  function setType(type) {
    S.type = type;
    S.model = '';
    document.querySelectorAll('.cdmc__type-tab').forEach(function(t){
      var on = t.getAttribute('data-type') === type;
      t.classList.toggle('active', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');   // v870 (Codex CX0927-13): announced as well as shown, whoever calls it
    });
    applyDeviceParts();   // r149 (FSA-015): a new type, before its model is chosen
    ['iphone','ipad','samsung','google','other'].forEach(function(t){
      var el = $('cdmc-cred-' + t);
      if (el) el.classList.toggle('cd-hidden', t !== type);
    });
    // Storage and Continue belong to a CHOSEN model (R-096 moved both onto this screen), so both
    // go away with the model list whenever the device type changes.
    hide($('cdmc-storage-wrap'));
    hide($('cdmc-s0-continue'));
    if (type === 'other') {
      hide($('cdmc-model-wrap'));
      show($('cdmc-other-form'));
    } else {
      show($('cdmc-model-wrap'));
      hide($('cdmc-other-form'));
      populateModels(type);
    }
    var canTrade = (type !== 'other');
    document.querySelectorAll('#cdmc-intent-tradein, #cdmc-intent-sell').forEach(function(el){
      el.classList.toggle('cd-hidden', !canTrade);
    });
  }

  // WEB-046 — redraw only what is COMPUTED from prices, never the customer's answers. The model
  // teaser is always recomputed; a result the customer is already reading is rebuilt from the same
  // answers with the new prices, and they are told the figure was refreshed.
  // WEB-007 (W7) — the label says where the figure came from. It read "Based on recent sales" for every figure, including
  // the baked constants used whenever the live table has not arrived or does not cover the model; only a figure from the
  // app's live table (built from recent sales) says so, with the day its market anchor was last updated when known.
  function teaserSource(tv) {
    if (!(tv && tv.live)) return '📊 Typical range';
    var d = tv.asOf ? new Date(String(tv.asOf).replace(' ', 'T') + (/[zZ]|[+-]\d\d:?\d\d$/.test(String(tv.asOf)) ? '' : 'Z')) : null;
    // Fixed month names, not toLocaleDateString: browsers disagree on "Sep" / "Sept".
    var when = d && !isNaN(d.getTime()) ? d.getUTCDate() + ' ' + ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getUTCMonth()] : '';
    return '📊 From recent sales' + (when ? ' · updated ' + when : '');
  }
  function renderModelTeaser(value) {
    var teaser = $('cdmc-model-teaser');
    var teaserVal = $('cdmc-teaser-value');
    if (teaser && teaserVal) {
      var tv = compValueFor(value, 'good', []);
      var teaserLabel = $('cdmc-teaser-label');
      if (teaserLabel) teaserLabel.textContent = teaserSource(tv);
      if (tv && tv.recycle) {
        teaser.classList.add('cd-hidden');   // D-20260911-d: no "worth £X" for a free-recycling model
      } else if (tv && tv.cash > 0) {
        var vg = compValueFor(value, 'good', []);
        var vln = compValueFor(value, 'likenew', []);
        var lo = vg ? vg.cash : 0;
        var hi = vln ? vln.cashHi : 0;
        if (lo > 0 && hi > lo) {
          teaserVal.textContent = moneyRange(lo, hi);   // guarded by hi > lo above; routed here so no raw builder is left to copy
          teaser.classList.remove('cd-hidden');
        } else if (lo > 0) {
          teaserVal.textContent = 'from £' + lo;
          teaser.classList.remove('cd-hidden');
        } else {
          teaser.classList.add('cd-hidden');
        }
      } else {
        teaser.classList.add('cd-hidden');
      }
    }
  }
  // r171 (CX1012-06, Codex 12 Oct; Dan, D-20261013-b: "Ask the part again") — A TABLE THAT NO LONGER OFFERS THE PART THEY
  // CHOSE asks the part question again, with no price until they choose. The result kept that part's name and warranty while
  // priceFor fell to the next tier's price, and the enquiry carried both. Only on the way to the price (the repair screen or
  // the price itself): a sent enquiry is left alone, and a part question still ahead is simply asked fresh when it comes.
  function askPartAgain() {
    if (!S.parts || S.type !== 'iphone' || (S.repair !== 'screen' && S.repair !== 'battery')) return false;
    if (S.current !== 'sr4' && screenOf(S.current) !== 'sr1') return false;
    var pk = S.repair === 'battery' ? 'battery' : 'screen';
    var po = partsOptionsFor(S.model, pk);
    if (po.some(function (o) { return o.parts === S.parts; })) return false;
    S.parts = '';
    if (!po.length || (S.current !== 'sr4' && (S.panels || []).indexOf('sr2') === -1)) return false;
    drawPartsGrid(pk, po);
    goStep('sr2', false);
    showNotif('Cell Devices', 'Prices just refreshed and that part is no longer offered. Please choose your part again', '💷');
    return true;
  }
  function refreshPricedViews() {
    if (!S.model) return;
    renderModelTeaser(S.model);
    if (askPartAgain()) return;   // r171 (CX1012-06)
    // Review (S2): the screens a deep link actually lands on carry prices too — the lock-price line on
    // the condition screen and the part-quality grid — so they are redrawn in place (no navigation).
    if (S.current === 'st-check') renderLockInfoPrice();
    else if (S.current === 'sr2' || (S.panels && S.panels.indexOf('sr2') !== -1)) { var pk = S.repair === 'battery' ? 'battery' : 'screen'; var po = partsOptionsFor(S.model, pk); if (po.length) drawPartsGrid(pk, po); }   // r171: with one left too, never the withdrawn one
    if (S.current === 'sr4') { renderRepairResult(); showNotif('Cell Devices', 'Prices just refreshed, so your estimate is up to date', '💷'); }
    else if (S.current === 'st3') { renderTradeinResult(); showNotif('Cell Devices', 'Prices just refreshed, so your offer is up to date', '💷'); }
  }

  function onModelChange(value) {
    var keepType = S.type;
    S.model = value;
    S.storage = ''; S.intent = ''; S.repair = ''; S.parts = '';
    S.faults = []; S.cond = ''; S.lock = ''; S.battHealth = ''; S.battFaultDerived = false; S.faultGrade = '';
    S.glsBatt = ''; S.primaryFromQuiz = false; S.chosenUpgrade = null;
    S.tradeFlow = ''; _battHealthCallback = null;
    S.faulty = ''; S.carrier = ''; S.blacklist = '';
    Object.keys(S.sym).forEach(function(k){ S.sym[k] = []; }); S.symFrom = {};
    S.type = keepType;
    document.querySelectorAll('.cdmc__storage-btn.active, .cdmc__repair-btn.active, .cdmc__parts-btn.active, .cdmc__cond-btn.active, .cdmc__vfault.active, .cdmc__toggle-btn.active').forEach(function(b){ b.classList.remove('active'); });
    // Back to "— SELECT MODEL —" means there is nothing to continue to, and the storage row below
    // is describing a device that is no longer chosen.
    hide($('cdmc-s0-continue'));
    if (!value) { hide($('cdmc-storage-wrap')); return; }
    var storageWrap = $('cdmc-storage-wrap');
    if (storageWrap) {
      storageWrap.classList.remove('cd-hidden');
      var STORAGE_MAP = {
        'iPhone 17 Pro Max': ['256GB','512GB','1TB','2TB'],   // r150 (FSA-006): the one phone with a 2TB
        'iPhone 17 Pro':     ['256GB','512GB','1TB'],
        'iPhone Air':        ['256GB','512GB','1TB'],
        'iPhone 17':         ['256GB','512GB'],
        'iPhone 17e':        ['256GB','512GB'],
        'iPhone 16 Pro Max': ['256GB','512GB','1TB'],
        'iPhone 16 Pro':     ['128GB','256GB','512GB','1TB'],
        'iPhone 16 Plus':    ['128GB','256GB','512GB'],
        'iPhone 16':         ['128GB','256GB','512GB'],
        'iPhone 16e':        ['128GB','256GB','512GB'],
        'iPhone 15 Pro Max': ['256GB','512GB','1TB'],
        'iPhone 15 Pro':     ['128GB','256GB','512GB','1TB'],
        'iPhone 15 Plus':    ['128GB','256GB','512GB'],
        'iPhone 15':         ['128GB','256GB','512GB'],
        'iPhone 14 Pro Max': ['128GB','256GB','512GB','1TB'],
        'iPhone 14 Pro':     ['128GB','256GB','512GB','1TB'],
        'iPhone 14 Plus':    ['128GB','256GB','512GB'],
        'iPhone 14':         ['128GB','256GB','512GB'],
        'iPhone 13 Pro Max': ['128GB','256GB','512GB','1TB'],
        'iPhone 13 Pro':     ['128GB','256GB','512GB','1TB'],
        'iPhone 13':         ['128GB','256GB','512GB'],
        'iPhone 13 mini':    ['128GB','256GB','512GB'],
        'iPhone 12 Pro Max': ['128GB','256GB','512GB'],
        'iPhone 12 Pro':     ['128GB','256GB','512GB'],
        'iPhone 12':         ['64GB','128GB','256GB'],
        'iPhone 12 mini':    ['64GB','128GB','256GB'],
        'iPhone 11 Pro Max': ['64GB','256GB','512GB'],
        'iPhone 11 Pro':     ['64GB','256GB','512GB'],
        'iPhone 11':         ['64GB','128GB','256GB'],
        'iPhone XS Max':     ['64GB','256GB','512GB'],
        'iPhone XS':         ['64GB','256GB','512GB'],
        'iPhone XR':         ['64GB','128GB','256GB'],
        'iPhone X':          ['64GB','256GB'],
        'iPhone SE (3rd gen)': ['64GB','128GB','256GB'],
        'iPhone SE (2nd gen)': ['64GB','128GB','256GB'],
        'iPhone 8 Plus':     ['64GB','256GB'],
        'iPhone 8':          ['64GB','256GB'],
        'iPhone 7 Plus':     ['32GB','128GB','256GB'],
        'iPhone 7':          ['32GB','128GB','256GB'],
        // r153 (Codex FSA-012; Dan, D-20260927-b (10): "add real sizes") — each Samsung and Pixel model's own sizes, the ones
        // it was sold in, instead of the generic 64GB to 1TB list that offered sizes the phone never came in. The iPads
        // (below the Pixels) had the same list, so they get their own sizes too.
        'Galaxy S25 Ultra':  ['256GB','512GB','1TB'],
        'Galaxy S25+':       ['256GB','512GB'],
        'Galaxy S25':        ['128GB','256GB','512GB'],
        'Galaxy S24 Ultra':  ['256GB','512GB','1TB'],
        'Galaxy S24+':       ['256GB','512GB'],
        'Galaxy S24':        ['128GB','256GB','512GB'],
        'Galaxy S23 Ultra':  ['256GB','512GB','1TB'],
        'Galaxy S23+':       ['256GB','512GB'],
        'Galaxy S23':        ['128GB','256GB','512GB'],
        'Galaxy S22 Ultra':  ['128GB','256GB','512GB','1TB'],
        'Galaxy S22+':       ['128GB','256GB'],
        'Galaxy S22':        ['128GB','256GB'],
        'Galaxy S21 Ultra':  ['128GB','256GB','512GB'],
        'Galaxy S21+':       ['128GB','256GB'],
        'Galaxy S21':        ['128GB','256GB'],
        'Galaxy Z Fold 6':   ['256GB','512GB','1TB'],
        'Galaxy Z Flip 6':   ['256GB','512GB'],
        'Galaxy Z Fold 5':   ['256GB','512GB','1TB'],
        'Galaxy Z Flip 5':   ['256GB','512GB'],
        'Galaxy Z Fold 4':   ['256GB','512GB','1TB'],
        'Galaxy Z Flip 4':   ['128GB','256GB','512GB'],
        'Galaxy A56':        ['128GB','256GB'],
        'Galaxy A55':        ['128GB','256GB'],
        'Galaxy A54':        ['128GB','256GB'],
        'Galaxy A35':        ['128GB','256GB'],
        'Galaxy A34':        ['128GB','256GB'],
        'Pixel 9 Pro XL':    ['128GB','256GB','512GB','1TB'],
        'Pixel 9 Pro Fold':  ['256GB','512GB'],
        'Pixel 9 Pro':       ['128GB','256GB','512GB','1TB'],
        'Pixel 9':           ['128GB','256GB'],
        'Pixel 8 Pro':       ['128GB','256GB','512GB','1TB'],
        'Pixel 8':           ['128GB','256GB'],
        'Pixel 8a':          ['128GB','256GB'],
        'Pixel 7 Pro':       ['128GB','256GB','512GB'],
        'Pixel 7':           ['128GB','256GB'],
        'Pixel 7a':          ['128GB'],
        'Pixel 6 Pro':       ['128GB','256GB','512GB'],
        'Pixel 6':           ['128GB','256GB'],
        'Pixel 6a':          ['128GB'],
        'iPad Pro 13" (M4)':        ['256GB','512GB','1TB','2TB'],
        'iPad Pro 11" (M4)':        ['256GB','512GB','1TB','2TB'],
        'iPad Air 13" (M2)':        ['128GB','256GB','512GB','1TB'],
        'iPad Air 11" (M2)':        ['128GB','256GB','512GB','1TB'],
        'iPad mini (6th gen)':      ['64GB','256GB'],
        'iPad Pro 12.9" (6th gen)': ['128GB','256GB','512GB','1TB','2TB'],
        'iPad Pro 11" (4th gen)':   ['128GB','256GB','512GB','1TB','2TB'],
        'iPad Air (5th gen)':       ['64GB','256GB'],
        'iPad (11th gen)':          ['128GB','256GB','512GB'],
        'iPad (10th gen)':          ['64GB','256GB'],
        'iPad Air (4th gen)':       ['64GB','256GB'],
        'iPad (9th gen)':           ['64GB','256GB'],
        'iPad (8th gen)':           ['32GB','128GB'],
        'iPad (7th gen)':           ['32GB','128GB']
      };
      var validSizes = STORAGE_MAP[value] || null;
      document.querySelectorAll('.cdmc__storage-btn').forEach(function(b){
        var sz = b.getAttribute('data-storage');
        if (validSizes) {
          b.style.display = validSizes.indexOf(sz) !== -1 ? '' : 'none';
        } else {
          b.style.display = ['64GB','128GB','256GB','512GB','1TB'].indexOf(sz) !== -1 ? '' : 'none';
        }
      });
    }
    renderModelTeaser(value);
    var isHousingModel = HOUSING_ONLY.indexOf(value) !== -1;
    var note = $('cdmc-housing-note');
    if (note) note.classList.toggle('cd-hidden', !isHousingModel);
    var bgBtn = $('cdmc-btn-backglass');
    if (bgBtn) {
      var bs = bgBtn.querySelectorAll('span');
      if (bs[0]) bs[0].textContent = isHousingModel ? '🏠' : '🪟';
      if (bs[1]) bs[1].textContent = isHousingModel ? 'Housing' : 'Back Glass';
    }
    var hBtn = $('cdmc-btn-housing');
    if (hBtn) {
      hBtn.style.display = isHousingModel ? 'none' : '';
      var hs = hBtn.querySelectorAll('span');
      if (hs[0]) hs[0].textContent = '🖼️';
      if (hs[1]) hs[1].textContent = 'Frame';
    }
    applyDeviceParts();   // r149 (FSA-015, FSA-065): only the repairs and faults this model can have
    // R-096: picking a model used to jump straight to the intent screen, which is why STORAGE had
    // to live over there — there was no moment on screen 1 at which to ask it. Storage describes
    // the device, so screen 1 now holds it and ends with a Continue. A deep link that also carries
    // an intent still skips straight past this: _applyDeferredPrefill calls setIntent, which
    // navigates on its own.
    show($('cdmc-s0-continue'));
    // Review of WEB-019 (S3): a type-only link's deferred fault/intent used to fire HERE, the moment
    // a model was picked, jumping past the storage row (and a keyboard arrow on the select was
    // enough). It now waits for Continue — see deviceContinue.
  }

  function deviceContinue() {
    if (!S.model) return;
    if (_prefillRepair || _prefillIntent) { _applyDeferredPrefill(); if (S.current !== 's0') return; }
    goStep('s1');
  }

  function setIntent(intent) {
    if (SELL_ONLY && intent === 'repair') return;   // r165 (R-163): no door into the repair path on a sell only page
    var prevIntent = S.intent;
    S.intent = intent;
    var hasState = S.faults.length > 0 || S.cond || S.battHealth ||
      Object.keys(S.sym).some(function(k){ return S.sym[k].length > 0; });
    if (!hasState || !prevIntent) {
      resetPrices();
    } else {
      S.repair = '';
      S.parts = '';
      S.primaryFromQuiz = false;
      S.chosenUpgrade = null;
      S.tradeFlow = '';
      _battHealthCallback = null;
      S.glsBatt = '';
      document.querySelectorAll('.cdmc__repair-btn.active, .cdmc__parts-btn.active').forEach(function(b){
        b.classList.remove('active');
      });
    }
    if (intent === 'repair') {
      showRepairsForType();
      goStep('sr1');
    } else if (intent === 'upgrade' || intent === 'sell') {
      _carryFaultsToTradeIn();
      enterCheck();
      applyPresetCond();
    }
  }

  // r165 (R-163) — the condition link answer (see PRESET_COND). Only an UNANSWERED faults question is answered for the
  // visitor: coming back to the screen, or arriving with faults carried from a repair quote, keeps what is already there.
  // ⚠ AND ONLY ONCE PER QUOTE (a restart re-arms it). Choosing an intent again with nothing ticked clears the answers
  // (setIntent → resetPrices), so a visitor who changed "Fully working" to "Has faults", went Back and came in again had the
  // page's guess put back over the answer they gave: measured on the harness, the L-ui-26 shape of a derived answer
  // overwriting a declared one. After the first time they are asked like anyone else.
  var _presetCondUsed = false;
  function applyPresetCond() {
    if (!PRESET_COND || S.faulty || _presetCondUsed) return;
    _presetCondUsed = true;
    if (PRESET_COND === 'broken') { setFaulty('yes'); return; }
    setFaulty('no');
    if (PRESET_COND === 'likenew' || PRESET_COND === 'good' || PRESET_COND === 'fair') setCond(PRESET_COND);
  }

  function showRepairsForType() {
    ['iphone','ipad','samsung','google'].forEach(function(t){
      var el = $('cdmc-repairs-' + t);
      if (el) el.classList.toggle('cd-hidden', t !== S.type);
    });
  }

  function resetPrices() {
    S.repair = '';
    S.parts = '';
    S.faults = [];
    S.cond = '';
    S.lock = '';
    S.faulty = '';
    S.carrier = '';
    S.blacklist = '';
    S.battHealth = '';
    S.battFaultDerived = false;
    S.faultGrade = '';
    _battHealthCallback = null;
    S.glsBatt = '';
    S.primaryFromQuiz = false;
    S.chosenUpgrade = null;
    S.tradeFlow = '';
    Object.keys(S.sym).forEach(function(k){ S.sym[k] = []; }); S.symFrom = {};
    document.querySelectorAll('.cdmc__repair-btn.active, .cdmc__parts-btn.active, .cdmc__cond-btn.active, .cdmc__vfault.active, .cdmc__toggle-btn.active').forEach(function(b){
      b.classList.remove('active');
    });
  }

  function setRepair(repair) {
    S.repair = repair;
    document.querySelectorAll('.cdmc__repair-btn').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-repair') === repair);
    });
    if (repair === 'camera-lens') { goStep('sr-cam'); return; }
    var symMap = {
      screen:'sr-screen', battery:'sr-batt', 'back-glass':'sr-glass',
      housing:'sr-glass', camera:'sr-cammod', 'charging-port':'sr-charge',
      'small-parts':'sr-small', software:'sr-soft', other:'sr-soft',
      'face-id':'sr-faceid', water:'sr-water',
      'ipad-frame':null
    };
    var next = symMap[repair];
    if (repair === 'ipad-frame') {
      goStep('sr4', false);
      renderRepairResult();
      return;
    }
    if (repair === 'face-id') {
      var isFidFixable = faceIdFixable(S.model);
      var cu = $('cdmc-fid-callout-unfixable');
      var cf = $('cdmc-fid-callout-fixable');
      if (cu) cu.classList.toggle('cd-hidden', isFidFixable);
      if (cf) cf.classList.toggle('cd-hidden', !isFidFixable);
      // r150 — the price in the green box is the fee the app serves (it was typed "£220"), or a personal quote.
      var ft = $('cdmc-fid-fixable-title');
      if (ft) ft.textContent = faceIdQuoteOnly(S.model)
        ? '✅ Face ID can be repaired on this model. We\'ll quote you personally'
        : '✅ Face ID can be repaired on this model, £' + FACE_ID_PRICE;
      goStep('sr-faceid');
      return;
    }
    if (next) { goStep(next); return; }
    goStep('sr4', false);
    renderRepairResult();
  }

  function toggleSym(bucket, fault, btn) {
    var arr = S.sym[bucket];
    var i = arr.indexOf(fault);
    if (i === -1) arr.push(fault); else arr.splice(i, 1);
    // r170 (CXH1012-06): the main repair's own question wrote it, so liveSymptoms sends it whatever is chosen further on.
    S.symFrom = S.symFrom || {};
    if (i === -1) S.symFrom[bucket + ':' + fault] = 'primary'; else delete S.symFrom[bucket + ':' + fault];
    if (btn) btn.classList.toggle('active', arr.indexOf(fault) !== -1);
  }

  function onSym(bucket, fault, btn) {
    toggleSym(bucket, fault, btn);
    if (bucket === 'scr') {
      var diag = ['scr_dead','scr_flicker','scr_dim'].some(function(f){ return S.sym.scr.indexOf(f) !== -1; });
      var el = $('cdmc-scr-diag-note'); if (el) el.classList.toggle('cd-hidden', !diag);
    }
    if (bucket === 'bat') {
      var el2 = $('cdmc-bat-heat-note'); if (el2) el2.classList.toggle('cd-hidden', S.sym.bat.indexOf('bat_hot') === -1);
    }
    if (bucket === 'gls') {
      var gf = $('cdmc-gls-frame-note'); if (gf) gf.classList.toggle('cd-hidden', S.sym.gls.indexOf('gls_frame') === -1);
      var gl = $('cdmc-gls-screen-lift-note'); if (gl) gl.classList.toggle('cd-hidden', S.sym.gls.indexOf('gls_screen_lift') === -1);
    }
    if (bucket === 'cm') {
      var soft = ['cm_black','cm_crash'].some(function(f){ return S.sym.cm.indexOf(f) !== -1; });
      var cs = $('cdmc-cm-soft-note'); if (cs) cs.classList.toggle('cd-hidden', !soft);
      var dust = S.sym.cm.indexOf('cm_dust') !== -1;
      var cd = $('cdmc-cm-dust-note'); if (cd) cd.classList.toggle('cd-hidden', !dust);
      var lensCracked = S.sym.cm.indexOf('cm_lens_cracked') !== -1;
      var moduleFaults = ['cm_blur','cm_black','cm_crash','cm_shake','cm_flash','cm_dust','cm_switched'].some(function(f){ return S.sym.cm.indexOf(f) !== -1; });
      var bothEl = $('cdmc-cm-both-note');
      if (bothEl) bothEl.classList.toggle('cd-hidden', !(lensCracked && moduleFaults));
      var lensOnly = lensCracked && !moduleFaults;
      var lo = $('cdmc-cm-lens-note'); if (lo) lo.classList.toggle('cd-hidden', !lensOnly);
    }
    if (bucket === 'sft') {
      var sd = $('cdmc-sft-disabled-note'); if (sd) sd.classList.toggle('cd-hidden', S.sym.sft.indexOf('sft_disabled') === -1);
      var hw = ['sft_wont_on','sft_bootloop'].some(function(f){ return S.sym.sft.indexOf(f) !== -1; });
      var sh = $('cdmc-sft-hardware-note'); if (sh) sh.classList.toggle('cd-hidden', !hw);
    }
    if (bucket === 'sml') {
      var soft2 = ['sml_speaker','sml_mic','sml_earpiece'].some(function(f){ return S.sym.sml.indexOf(f) !== -1; });
      var ss = $('cdmc-sml-soft-note'); if (ss) ss.classList.toggle('cd-hidden', !soft2);
    }
    if (bucket === 'chg') {
      var lint = ['chg_nofit','chg_loose'].some(function(f){ return S.sym.chg.indexOf(f) !== -1; });
      var cl = $('cdmc-chg-lint-note'); if (cl) cl.classList.toggle('cd-hidden', !lint);
    }
    if (bucket === 'cam') {
      var moduleFaults2 = ['cam_blurry','cam_spots','cam_vibrate','cam_noise'].some(function(f){ return S.sym.cam.indexOf(f) !== -1; });
      var cdn = $('cdmc-cam-diag-note'); if (cdn) cdn.classList.toggle('cd-hidden', !moduleFaults2);
      var lensOnly2 = ['cam_lens_cracked','cam_scratched','cam_flare','cam_lens_fine'].some(function(f){ return S.sym.cam.indexOf(f) !== -1; });
      var lensOkNote = $('cdmc-cam-lens-ok-note');
      if (lensOkNote) lensOkNote.classList.toggle('cd-hidden', !lensOnly2 || moduleFaults2);
    }
  }

  function onGlsBatt(val, btn) {
    S.glsBatt = (S.glsBatt === val) ? '' : val;
    document.querySelectorAll('[data-action="gls-batt"]').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-fault') === ('gls_batt_' + S.glsBatt));
    });
    var w = $('cdmc-gls-batt-warn'); if (w) w.classList.toggle('cd-hidden', S.glsBatt !== 'damaged');
  }

  function confirmSymptoms(repairKey) {
    var bucket = ({
      screen:'scr', battery:'bat', 'back-glass':'gls', housing:'gls',
      camera:'cm', software:'sft', other:'sft', 'small-parts':'sml',
      'charging-port':'chg', 'camera-lens':'cam'
    })[repairKey];
    if (bucket && S.sym[bucket].length > 0) {
      var preFaults = [];
      S.sym[bucket].forEach(function(sym){
        var f = SYMPTOM_TO_FAULT[sym];
        if (f && preFaults.indexOf(f) === -1) preFaults.push(f);
      });
      if (S.glsBatt === 'damaged' && preFaults.indexOf('battery') === -1) preFaults.push('battery');
      if (S.sym.gls && S.sym.gls.indexOf('gls_screen_lift') !== -1 && preFaults.indexOf('battery') === -1) {
        preFaults.push('battery');
      }
      S.faults = preFaults.slice();
      S.primaryFromQuiz = true;
    }

    if (repairKey === 'screen' && S.type === 'iphone') { renderPartsStep('screen'); return; }
    if (repairKey === 'battery' && S.type === 'iphone') { renderPartsStep('battery'); return; }

    if (repairKey === 'screen' && S.type === 'ipad') {
      var iPadLcdModels = ['iPad (10th gen)','iPad (9th gen)','iPad (8th gen)','iPad (7th gen)','iPad (6th gen)','iPad (5th gen)'];
      var isLcdModel = iPadLcdModels.some(function(m){ return S.model.indexOf(m) !== -1; });
      if (isLcdModel) {
        var hasLcdSyms = ['scr_dead','scr_lines','scr_flicker','scr_dim'].some(function(s){ return S.sym.scr.indexOf(s) !== -1; });
        var hasTouchSyms = ['scr_cracked','scr_touch','scr_notsure','scr_glass'].some(function(s){ return S.sym.scr.indexOf(s) !== -1; });   // ST-11: scr_glass was scr_notsure
        S.faults = S.faults.filter(function(f){
          return ['screen_cracked','screen_damaged','screen_lcd_fault','screen_touch_only'].indexOf(f) === -1;
        });
        if (hasLcdSyms && hasTouchSyms) {
          S.repair = 'screen-lcd';
          S.faults.unshift('screen_touch_only');
          S.faults.unshift('screen_lcd_fault');
        } else if (hasLcdSyms) {
          S.repair = 'screen-lcd';
          S.faults.unshift('screen_lcd_fault');
        } else {
          S.repair = 'screen-touch';
          S.faults.unshift('screen_touch_only');
        }
      }
    }

    if (S.type === 'iphone' && repairKey !== 'battery') {
      goStep('sr-batt-health');
    } else {
      goStep('sr3');
      renderSr3();
    }
  }

  /* WARRANTY BY PART — D-20260922-m (Dan, 2026-09-22), the same terms the ops app quotes.
     The warranty follows the PART we fit, not the repair: an aftermarket OLED 12 months, a genuine
     Apple part 3 (they are reclaimed, so they come to us used), a third-party battery 6, the budget
     LCD 3, and anything else 6. Anything this tool does not offer a parts choice for — a charging
     port, a camera, back glass — has no key here and lands on the 6-month default, which is exactly
     what "other parts" means in the rule.
     ⚠ KEEP THIS EQUAL TO ops-app/src/repair-form.js PART_TYPES. Two copies of one promise is how a
     customer gets told twelve months by the website and six by the email that prices the job. */
  var WARRANTY_MONTHS = { lcd: 3, oled: 12, genuine: 3, 'third-party': 6 };
  function warrantyMonthsFor(parts) { return WARRANTY_MONTHS[parts] || 6; }
  function warrantyWords(parts) { return warrantyMonthsFor(parts) + ' month warranty'; }

  /* PARTS (SR2) */
  // r149 (Codex FSA-059) — PROMOTION IS A FEW MODELS' SCREEN, NOT EVERY GENUINE SCREEN'S. The genuine option promised "Full True
  // Tone & ProMotion" on every model, an iPhone 11 included; 120Hz ProMotion is on the iPhone 13 to 16 Pro and Pro Max and
  // the iPhone 17 family and Air.
  function hasProMotion(model) { var m = String(model || ''); return /^iPhone 1[3-6] Pro\b/.test(m) || /^iPhone (17|Air)\b/.test(m); }
  function partsOptionsFor(model, kind) {
    var o = [];
    if (kind === 'screen') {
      var lcd = REPAIR_PRICES[model + '::screen::lcd'];
      var oled = REPAIR_PRICES[model + '::screen::oled'];
      var gen = REPAIR_PRICES[model + '::screen::genuine'];
      if (lcd != null)  o.push({parts:'lcd',     price:lcd,  badgeClass:'value',   badge:'Cheapest',    label:'LCD screen', desc:'Budget LCD panel. Ideal as a cheap temporary screen, or to get the phone working for a data transfer. Not as deep on blacks/brightness as OLED. Shows \'Unknown\' in Settings on models Apple tracks. 3 month warranty (aftermarket OLED: 12 months; genuine Apple: 3, because they are reclaimed).'});
      if (oled != null) o.push({parts:'oled',    price:oled, badgeClass:'value',   badge:'Best value',  label:'OLED screen (aftermarket)', desc:'High quality aftermarket OLED, with true blacks and full brightness, same panel type as original. Shows \'Unknown\' in Settings on models Apple tracks. 12 month warranty, the longest we give.'});
      if (gen != null)  o.push({parts:'genuine', price:gen,  badgeClass:'genuine', badge:'PREMIUM OEM', label:'Genuine Apple screen', desc:'Genuine Apple screen, reclaimed: this price is for a reclaimed screen, which shows \'Used\' in Settings on iPhone 12 and newer. ' + (hasProMotion(model) ? 'Full True Tone &amp; ProMotion.' : 'Full True Tone.') + ' 3 month warranty, because a reclaimed Apple part comes to us used. A brand new Apple screen can be ordered on request, quoted separately, with the same 3 month warranty.'});
    } else if (kind === 'battery') {
      var btp = REPAIR_PRICES[model + '::battery::third-party'];
      var bg  = REPAIR_PRICES[model + '::battery::genuine'];
      if (btp != null) o.push({parts:'third-party', price:btp, badgeClass:'value',   badge:'Best value',  label:'Third party battery', desc:'High quality aftermarket cell, with the same capacity and performance. In stock, no wait. Shows \'Unknown\' in Settings on models Apple tracks. 6 month warranty.'});
      if (bg  != null) o.push({parts:'genuine',     price:bg,  badgeClass:'genuine', badge:'PREMIUM OEM', label:'Genuine Apple battery', desc:'Genuine Apple battery, reclaimed from another phone, so it comes to us used: this price is for the reclaimed battery, which shows \'Used\' on iPhone 12 and newer. Ordered in 1 to 3 working days. 3 month warranty. A brand new one can be ordered on request, quoted separately, with the same 3 month warranty.'});
    }
    return o;
  }

  function renderPartsStep(kind) {
    var opts = partsOptionsFor(S.model, kind);
    var goNext = function () {
      if (S.type === 'iphone' && kind !== 'battery') { goStep('sr-batt-health'); }
      else { goStep('sr3'); renderSr3(); }
    };
    if (opts.length === 0) { goNext(); return; }
    if (opts.length === 1) { S.parts = opts[0].parts; goNext(); return; }
    drawPartsGrid(kind, opts);
    goStep('sr2');
  }
  function drawPartsGrid(kind, opts) {
    var grid = $('cdmc-parts-grid');
    var t = $('cdmc-sr2-title');
    var s = $('cdmc-sr2-sub');
    if (t) t.textContent = kind === 'battery' ? 'Which battery would you like?' : 'Which screen quality?';
    if (s) s.textContent = kind === 'battery' ? 'Both are quality checked. Here\'s the difference.' : 'All options are quality checked before fitting.';
    if (grid) {
      grid.style.gridTemplateColumns = opts.length === 3 ? '1fr' : '1fr 1fr';
      grid.innerHTML = opts.map(function (o) {
        return '<button type="button" class="cdmc__parts-btn' + (o.parts === S.parts ? ' active' : '') + '" data-parts="' + o.parts + '" data-action="set-parts">' +
          '<span class="cdmc__parts-badge cdmc__parts-badge--' + o.badgeClass + '">' + o.badge + '</span>' +
          '<strong>' + o.label + ', £' + o.price + '</strong>' +
          '<p>' + o.desc + '</p>' +
        '</button>';
      }).join('');
    }
  }

  function setParts(parts) {
    // r171 (CX1012-06) — a part the table has withdrawn since this grid was drawn is not taken: the grid is drawn again, as it is now
    var pk = S.repair === 'battery' ? 'battery' : 'screen', po = partsOptionsFor(S.model, pk);
    if (po.length && !po.some(function (o) { return o.parts === parts; })) { drawPartsGrid(pk, po); return; }
    S.parts = parts;
    document.querySelectorAll('.cdmc__parts-btn').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-parts') === parts);
    });
    if (S.type === 'iphone' && S.repair !== 'battery') {
      goStep('sr-batt-health');
    } else {
      goStep('sr3');
      renderSr3();
    }
  }

  function renderSr3() {
    var box = $('cdmc-sr3-confirmed');
    var list = $('cdmc-sr3-confirmed-list');
    if (S.repair && box && list) {
      var label = ({
        screen:'Screen', battery:'Battery', 'screen-lcd':'LCD panel', 'screen-touch':'Touch panel',
        'back-glass': HOUSING_ONLY.indexOf(S.model) !== -1 ? 'Housing' : 'Back glass',
        housing: HOUSING_ONLY.indexOf(S.model) !== -1 ? 'Housing' : 'Frame',
        camera:'Camera', 'camera-lens':'Camera lens',
        'charging-port':'Charging port', 'small-parts':'Small parts',
        'face-id':'Face ID', water:'Water damage',
        'ipad-frame':'Frame / housing', software:'Software / diagnostic', other:'Other'
      })[S.repair] || S.repair;
      list.innerHTML = '<span class="cdmc__sr3-confirmed-tag"><span class="cdmc__sr3-confirmed-tag-icon">✅</span>' + escHTML(label) + '</span>';
      show(box);
    }
    document.querySelectorAll('#cdmc-sr3 .cdmc__vfault').forEach(function(b){
      var f = b.getAttribute('data-fault');
      if (!f) return;
      b.classList.toggle('active', S.faults.indexOf(f) !== -1 && f !== 'none');
    });
    var otherBox = $('cdmc-r3-other-desc');
    if (otherBox) otherBox.classList.toggle('cd-hidden', S.faults.indexOf('other_fault') === -1);
    _sr3Skip = repairAnsweredFaults();
    renderRepairFaultDetails();
  }

  // ⚠ THE CONTAINER IDS HERE ARE AN ADDRESS, AND R-096 MOVED ONE OF THEM. The trade-in fault chips
  // used to live in step `#cdmc-st2`; they are now inside `#cdmc-cond-faults` on screen 3. The
  // repair path's own picker (`#cdmc-sr3`) is untouched — this function has always served both, and
  // that is exactly why the selector, not just the markup, had to move (L-always-16).
  function faultToggle(fault, btn) {
    if (fault === 'none') {
      S.faults = [];
      document.querySelectorAll('#cdmc-sr3 .cdmc__vfault, #cdmc-cond-faults .cdmc__vfault').forEach(function(b){
        b.classList.remove('active');
      });
      if (btn) btn.classList.add('active');
      renderFaultDetails();
      renderRepairFaultDetails();
      var otherBox0 = $('cdmc-r3-other-desc');
      if (otherBox0) otherBox0.classList.add('cd-hidden');
      return;
    }
    var container = (btn && btn.closest) ? (btn.closest('#cdmc-sr3') || btn.closest('#cdmc-cond-faults') || document) : document;
    container.querySelectorAll('[data-fault="none"]').forEach(function(nb){ nb.classList.remove('active'); });
    var i = S.faults.indexOf(fault);
    if (i === -1) S.faults.push(fault); else S.faults.splice(i, 1);
    if (btn) btn.classList.toggle('active', S.faults.indexOf(fault) !== -1);
    // Touching the battery chip at all means the seller owns that answer from here on, so the
    // battery-health question may no longer withdraw it. See set-batt-health.
    if (fault === 'battery') S.battFaultDerived = false;
    var inTradeIn = btn && btn.closest && btn.closest('#cdmc-cond-faults');
    if (fault === 'other_fault') {
      var box = inTradeIn ? $('cdmc-t2-other-desc') : $('cdmc-r3-other-desc');
      if (box) box.classList.toggle('cd-hidden', S.faults.indexOf('other_fault') === -1);
    }
    // The detail that used to be a screen per fault opens (and closes) under the chips, here, on both paths (the
    // repair path since R-096's second wave).
    if (inTradeIn) renderFaultDetails();
    else if (btn && btn.closest && btn.closest('#cdmc-sr3')) renderRepairFaultDetails();
  }

  function renderRepairResult() {
    try { _renderRepairResult(); } catch(e) {
      console.error('renderRepairResult error:', e);
      var note = $('cdmc-r-note');
      if (note) note.textContent = 'Something went wrong building your estimate. Please message us directly on WhatsApp.';
      goStep('sr4', false);
    }
  }
  function _renderRepairResult() {
    var model = S.model || 'Your device';
    var primaryKey = S.repair;
    var primaryPrice = priceFor(S.model, primaryKey, S.parts);
    var fidFixable = primaryKey === 'face-id' && faceIdFixable(S.model);
    var isDiag = (primaryKey === 'software' || primaryKey === 'other' ||
                  primaryKey === 'water' ||
                  (primaryKey === 'face-id' && !fidFixable) ||
                  S.faults.indexOf('wont_turn_on') !== -1 ||
                  S.faults.indexOf('water') !== -1);
    $('cdmc-r-device').textContent = model;
    var repairLabel = ({
      screen:'Screen replacement', 'screen-lcd':'LCD replacement',
      'screen-touch':'Touch panel replacement',
      battery:'Battery replacement',
      'back-glass': HOUSING_ONLY.indexOf(S.model) !== -1 ? 'Housing replacement' : 'Back glass repair',
      housing: HOUSING_ONLY.indexOf(S.model) !== -1 ? 'Housing replacement' : 'Frame replacement',
      camera:'Camera replacement', 'camera-lens':'Camera lens replacement',
      'charging-port':'Charging port', 'small-parts':'Small parts repair',
      'face-id': faceIdFixable(S.model) ? 'Face ID repair' : 'Face ID diagnostic',
      water:'Water damage assessment',
      'ipad-frame':'Frame or housing: contact us',
      software:'Software diagnostic', other:'Diagnostic & repair'
    })[primaryKey] || 'Repair';
    if (primaryKey === 'back-glass' && HOUSING_ONLY.indexOf(S.model) !== -1) repairLabel = 'Housing replacement';
    $('cdmc-r-repair').textContent = repairLabel;
    var priceEl = $('cdmc-r-price');
    var noPriceNote = $('cdmc-r-no-price-note');
    if (noPriceNote) noPriceNote.classList.add('cd-hidden');
    var noPrice = !primaryPrice && !isDiag;
    if (noPrice) {
      priceEl.textContent = 'Contact us';
      $('cdmc-r-from').textContent = 'quote via';
      var sv = $('cdmc-r-status-val'); if (sv) sv.textContent = 'We\'ll quote directly';
      if (noPriceNote) noPriceNote.classList.remove('cd-hidden');
    } else if (isDiag && !primaryPrice) {
      priceEl.textContent = '£' + DIAG_FEE;
      $('cdmc-r-from').textContent = 'diagnostic';
    } else if (primaryPrice) {
      priceEl.textContent = '£' + primaryPrice;
      $('cdmc-r-from').textContent = 'from';
    } else {
      priceEl.textContent = '£' + DIAG_FEE + '+';
      $('cdmc-r-from').textContent = 'diagnostic';
    }
    if (S.parts) {
      var partsLabel;
      if (primaryKey === 'screen') {
        partsLabel = S.parts === 'genuine' ? 'Genuine Apple OLED' : (S.parts === 'oled' ? 'Aftermarket OLED' : 'LCD');
      } else if (primaryKey === 'battery') {
        partsLabel = S.parts === 'genuine' ? 'Genuine Apple battery' : 'Third party battery';
      } else {
        partsLabel = S.parts === 'genuine' ? 'Genuine OEM' : 'Third party (premium)';
      }
      $('cdmc-r-parts-val').textContent = partsLabel;
      show($('cdmc-r-parts-row'));
    } else {
      hide($('cdmc-r-parts-row'));
    }
    var warrEl = $('cdmc-r-warranty-val');
    if (warrEl) warrEl.textContent = warrantyMonthsFor(S.parts) + ' months';
    $('cdmc-r-diag').classList.toggle('cd-hidden', !isDiag);
    $('cdmc-r-samsung').classList.toggle('cd-hidden', S.type !== 'samsung');
    $('cdmc-r-google').classList.toggle('cd-hidden', S.type !== 'google');
    var fidUnfixable = $('cdmc-fid-callout-unfixable');
    var fidFixable = $('cdmc-fid-callout-fixable');
    if (fidUnfixable) fidUnfixable.classList.toggle('cd-hidden', primaryKey !== 'face-id' || faceIdFixable);
    if (fidFixable) fidFixable.classList.toggle('cd-hidden', primaryKey !== 'face-id' || !faceIdFixable);
    var partsNote = $('cdmc-r-parts-note');
    var needsPartsOrder = (primaryKey === 'face-id' && faceIdFixable) || (primaryKey === 'battery' && S.parts === 'genuine');
    if (partsNote) partsNote.style.display = needsPartsOrder ? '' : 'none';
    var genuineNoteEl = $('cdmc-r-genuine-note');
    if (genuineNoteEl) {
      var showGenuineNote = S.type === 'iphone' &&
        (primaryKey === 'screen' || primaryKey === 'battery') &&
        S.parts !== 'genuine';
      if (showGenuineNote) {
        var genuinePrice = REPAIR_PRICES[S.model + '::' + primaryKey + '::genuine'] || null;
        if (genuinePrice) {
          genuineNoteEl.textContent = 'Genuine Apple ' + (primaryKey === 'battery' ? 'battery' : 'screen') +
            ' also available, £' + genuinePrice + '. Say so on your repair form and we\'ll price that instead.';
          genuineNoteEl.style.display = '';
        } else {
          genuineNoteEl.style.display = 'none';
        }
      } else {
        genuineNoteEl.style.display = 'none';
      }
    }
    // FSA-029: the price is emailed and accepted BEFORE anything is posted (the repair form, v539); it only moves if the phone differs.
    var note = 'We email you the price to accept before you send anything. It only changes if we find something different once it\'s here, and then you decide. Your repair carries a ' + warrantyWords(S.parts) + ' on the part we fit and our workmanship.';
    // D-20260923-l: lint only is a £20 clean of the port and the speakers, plus return postage, never the port price.
    if (primaryKey === 'charging-port') note = 'If it turns out to be only lint, you don\'t pay for a new port: it\'s £20 to clean the charging port and the speakers, plus return postage. ' + note;
    if (S.repair === 'small-parts') note = 'Small part repairs include speaker, mic, buttons, mute switch and vibration. ' + note;
    if (S.repair === 'camera-lens') note = 'Lens only repair. If the camera module itself has failed, it may need the full camera replacement instead. ' + note;
    if (primaryKey === 'face-id' && faceIdFixable) note = 'Face ID repair uses Apple Self Service Repair, with the part ordered specifically for your device serial number. ' + note;
    if (primaryKey === 'battery' && S.parts === 'genuine') note = 'Genuine Apple battery must be ordered before posting. We\'ll contact you when it arrives, usually 1 to 3 working days. You keep your phone until then. ' + note;
    if (primaryKey === 'housing' || (primaryKey === 'back-glass' && HOUSING_ONLY.indexOf(S.model) !== -1)) {
      var hCovers = ['speaker','buttons','charging','camera_lens_damage'].filter(function(f){ return S.faults.indexOf(f) !== -1; });
      if (hCovers.length > 0) {
        var hLabels = hCovers.map(function(f){ return ({speaker:'speaker / mic',buttons:'buttons',charging:'charging port',camera_lens_damage:'camera lens glass'})[f]; }).join(', ');
        note = 'Housing replacement also resolves ' + hLabels + ', included at no extra cost. ' + note;
      }
    }
    if (primaryKey === 'housing' && HOUSING_ONLY.indexOf(S.model) === -1) {
      var fCovers = ['speaker','buttons','charging'].filter(function(f){ return S.faults.indexOf(f) !== -1; });
      if (fCovers.length > 0) {
        var fLabels = fCovers.map(function(f){ return ({speaker:'speaker / mic',buttons:'buttons',charging:'charging port'})[f]; }).join(', ');
        note = 'Frame replacement also resolves ' + fLabels + ', included at no extra cost. Back glass is a separate repair if needed. ' + note;
      }
    }
    $('cdmc-r-note').textContent = note;
    if (noPrice) {
      var bundleEl = $('cdmc-r-additional-faults');
      if (bundleEl) hide(bundleEl);
      var compareEl = $('cdmc-r-upgrade-compare');
      if (compareEl) hide(compareEl);
      goStep('sr4', false);
      return;
    }
    renderAdditionalFaults(primaryKey, primaryPrice);
    renderRepairUpgradeCompare(primaryKey, primaryPrice);
    renderRepairSummary(primaryKey, primaryPrice);
    renderBenchNote(primaryKey);
  }

  function primaryFaultKeysFor(primaryKey) {
    switch (primaryKey) {
      case 'screen': return ['screen_cracked','screen_damaged'];
      case 'screen-lcd': return ['screen_lcd_fault','screen_cracked','screen_damaged'];
      case 'screen-touch': return ['screen_touch_only','screen_cracked','screen_damaged'];
      case 'battery': return ['battery'];
      case 'back-glass':
        return HOUSING_ONLY.indexOf(S.model) !== -1
          ? ['back_glass','speaker','buttons','charging','camera_lens_damage']
          : ['back_glass'];
      case 'housing':
        return HOUSING_ONLY.indexOf(S.model) !== -1
          ? ['back_glass','speaker','buttons','charging','camera_lens_damage']
          : ['speaker','buttons','charging'];
      case 'camera':      return ['rear_camera'];
      case 'camera-lens': return ['camera_lens_damage'];
      case 'charging-port': return ['charging'];
      case 'small-parts': return ['speaker','buttons'];
      case 'software':
      case 'other': return ['wont_turn_on','other_fault','water'];
    }
    return [];
  }

  function renderAdditionalFaults(primaryKey, primaryPrice) {
    var box = $('cdmc-r-additional-faults');
    var primaryFaultKeys = primaryFaultKeysFor(primaryKey);
    var extras = S.faults.filter(function(f){
      return primaryFaultKeys.indexOf(f) === -1 && f !== 'none';
    });
    var isBonded = HOUSING_ONLY.indexOf(S.model) !== -1;
    var primaryIsHousing = (primaryKey === 'housing' || primaryKey === 'back-glass');
    if (!primaryIsHousing) {
      if (isBonded) {
        var bondedCovered = ['back_glass','speaker','buttons','charging','camera_lens_damage'];
        var bondedMatches = extras.filter(function(f){ return bondedCovered.indexOf(f) !== -1; });
        if (bondedMatches.length >= 2) {
          extras = extras.filter(function(f){ return bondedCovered.indexOf(f) === -1; });
          if (extras.indexOf('back_glass') === -1) extras.push('back_glass');
        }
        if (extras.indexOf('back_glass') !== -1) {
          extras = extras.filter(function(f){ return f === 'back_glass' || bondedCovered.indexOf(f) === -1; });
        }
      } else {
        var smallParts = ['speaker','buttons','charging'];
        var smallMatches = extras.filter(function(f){ return smallParts.indexOf(f) !== -1; });
        if (smallMatches.length >= 2) {
          extras = extras.filter(function(f){ return smallParts.indexOf(f) === -1; });
          if (extras.indexOf('_frame_upgrade') === -1) extras.push('_frame_upgrade');
        }
        if (extras.indexOf('back_glass') !== -1) {
          extras = extras.filter(function(f){ return f !== 'camera_lens_damage'; });
        }
      }
    }
    if (extras.length === 0 || !primaryPrice) {
      hide(box);
      return;
    }
    show(box);
    var allItems = [{
      label: (function() {
        var labels = {
          screen:'Screen replacement', 'screen-lcd':'LCD replacement',
          'screen-touch':'Touch panel replacement',
          battery:'Battery replacement',
          'back-glass': HOUSING_ONLY.indexOf(S.model) !== -1 ? 'Housing replacement' : 'Back glass repair',
          housing: HOUSING_ONLY.indexOf(S.model) !== -1 ? 'Housing replacement' : 'Frame replacement', camera:'Camera replacement',
          'camera-lens':'Camera lens', 'charging-port':'Charging port',
          'small-parts':'Small parts', software:'Diagnostic', other:'Diagnostic'
        };
        return labels[primaryKey] || 'Primary repair';
      })(),
      price: primaryPrice,
      isPrimary: false
    }];
    extras.forEach(function(f){
      if (f === '_frame_upgrade') {
        var framePrice = priceFor(S.model, 'housing', null);
        if (framePrice == null) return;
        allItems.push({ label: 'Frame replacement', price: framePrice, isPrimary: false, genuinePrice: null });
        return;
      }
      var repairKey = FAULT_TO_REPAIR_KEY[f];
      if (!repairKey) return;
      var fullPrice = priceFor(S.model, repairKey, 'third-party');
      if (fullPrice == null) fullPrice = priceFor(S.model, repairKey, null);
      if (fullPrice == null) return;
      var genuinePrice = null;
      if (S.type === 'iphone' && (repairKey === 'screen' || repairKey === 'battery')) {
        genuinePrice = priceFor(S.model, repairKey, 'genuine');
      }
      allItems.push({ label: faultLabel(f), price: fullPrice, isPrimary: false, genuinePrice: genuinePrice });
    });
    allItems.sort(function(a, b){ return b.price - a.price; });
    allItems[0].isPrimary = true;
    if (allItems.length === 1) {
      hide(box);
      return;
    }
    var items = $('cdmc-r-fault-items');
    items.innerHTML = '';
    var extrasSubtotal = 0;
    var subtotalNoDiscount = 0;
    allItems.forEach(function(item) {
      subtotalNoDiscount += item.price;
      if (item.isPrimary) {
        var primaryGenuinePrice = null;
        if (S.type === 'iphone' && (primaryKey === 'screen' || primaryKey === 'battery')) {
          primaryGenuinePrice = priceFor(S.model, primaryKey, 'genuine');
        }
        var primaryGenuineNote = primaryGenuinePrice
          ? '<span class="cdmc__additional-fault-item-sub"><span class="cdmc__additional-fault-genuine">Genuine Apple, £' + primaryGenuinePrice + ' · let us know</span></span>'
          : '';
        items.insertAdjacentHTML('beforeend',
          '<div class="cdmc__additional-fault-item cdmc__additional-fault-item--primary">' +
            '<span class="cdmc__additional-fault-item-label">' + escHTML(item.label) +
              '<span class="cdmc__additional-fault-badge">PRIMARY</span>' +
              primaryGenuineNote +
            '</span>' +
            '<span class="cdmc__additional-fault-item-price">£' + item.price + '</span>' +
          '</div>'
        );
      } else {
        var discounted = Math.round(item.price * (1 - BUNDLE_DISCOUNT));
        extrasSubtotal += discounted;
        var genuineNote = '';
        if (item.genuinePrice) {
          var genuineDiscounted = Math.round(item.genuinePrice * (1 - BUNDLE_DISCOUNT));
          genuineNote = '<span class="cdmc__additional-fault-genuine">Genuine Apple, £' + genuineDiscounted + ' · let us know</span>';
        }
        items.insertAdjacentHTML('beforeend',
          '<div class="cdmc__additional-fault-item">' +
            '<span class="cdmc__additional-fault-item-label">' + escHTML(item.label) +
              (genuineNote ? '<span class="cdmc__additional-fault-item-sub">' + genuineNote + '</span>' : '') +
            '</span>' +
            '<span class="cdmc__additional-fault-item-price">' +
              '<span class="cdmc__additional-fault-was">£' + item.price + '</span>' +
              '£' + discounted +
            '</span>' +
          '</div>'
        );
      }
    });
    var primaryItemPrice = allItems[0].price;
    var discountAmt = subtotalNoDiscount - primaryItemPrice - extrasSubtotal;
    var total = primaryItemPrice + extrasSubtotal;
    var priceEl = $('cdmc-r-price');
    var fromEl = $('cdmc-r-from');
    if (priceEl) priceEl.textContent = '£' + total;
    if (fromEl) fromEl.textContent = 'bundle';
    $('cdmc-r-fault-count').textContent = allItems.length;
    $('cdmc-r-fault-subtotal').textContent = '£' + subtotalNoDiscount;
    $('cdmc-r-fault-discount').textContent = '−£' + discountAmt;
    $('cdmc-r-fault-combined').textContent = '£' + total;
    $('cdmc-r-primary-repair-name').textContent = allItems[0].label.toLowerCase();
    $('cdmc-r-bundle-save').textContent = '£' + primaryItemPrice;
    show($('cdmc-r-fault-total'));
  }

  function renderRepairUpgradeCompare(primaryKey, primaryPrice) {
    var compare = $('cdmc-r-upgrade-compare');
    var generic = $('cdmc-r-upgrade-generic');
    // r152 (app v781; Codex FSA-066) — A DIAGNOSTIC IS NOT A REPAIR PRICE. The £20 look at a phone that won't turn on, has been
    // in water or has a fault we have not named was set against a replacement as "this repair", and called cheaper than any
    // replacement. Only a priced repair is compared; a diagnostic gets the general "worth knowing" note.
    var isDiagnostic = primaryKey === 'software' || primaryKey === 'other' || primaryKey === 'water'
      || (primaryKey === 'face-id' && primaryPrice === DIAG_FEE);
    if (!primaryPrice || !S.model || isDiagnostic) { hide(compare); show(generic); return; }

    var displayedPriceEl = $('cdmc-r-price');
    var displayedFromEl  = $('cdmc-r-from');
    var isBundle = displayedFromEl && displayedFromEl.textContent === 'bundle';
    var repairPriceNum = displayedPriceEl ? parseInt(displayedPriceEl.textContent.replace(/[^0-9]/g,'')) : primaryPrice;
    var repairPriceStr = isBundle ? 'Bundle £' + repairPriceNum : '£' + repairPriceNum;
    var repairColLabel = isBundle ? '🔧 All repairs (bundle)' : '🔧 This repair';

    var isIphone = S.type === 'iphone';

    function brandKey(title) {
      var t = (title || '').toLowerCase();
      if (t.indexOf('iphone') !== -1) return 'iphone';
      if (t.indexOf('ipad') !== -1) return 'ipad';
      if (t.indexOf('galaxy') !== -1 || t.indexOf('samsung') !== -1) return 'samsung';
      if (t.indexOf('pixel') !== -1 || t.indexOf('google') !== -1) return 'google';
      return 'other';
    }

    fetchUpgradeOptions().then(function(opts){
      if (!opts.all || !opts.all.length) { hide(compare); show(generic); return; }

      var replacement = null;       // VS / "similar price" slot
      var bestUpgrade = null;       // premium / best-match slot
      var budgetLabelText = '📱 In stock now';
      var noteText = '';
      var showTradein = false;      // trade-in/net rows only make sense for priced (iPhone) trade-ins

      if (isIphone) {
        // ── iPhone: generation-aware ──────────────────────────────
        var currentGen = _genNum(_genTier(S.model));
        if (currentGen < 0) { hide(compare); show(generic); return; }

        var scored = opts.all
          .filter(function(p){ return p.title.indexOf('iPhone') !== -1; })
          .map(function(p) {
            var gen = _genNum(_genTier(p.title));
            return {
              p: p, gen: gen, genDiff: gen - currentGen,
              isPro: p.title.indexOf('Pro') !== -1,
              isProMax: p.title.indexOf('Pro Max') !== -1
            };
          })
          .filter(function(s){ return s.gen >= 0; });

        if (!scored.length) { hide(compare); show(generic); return; }

        var rep = scored.filter(function(s){ return s.genDiff >= 0; })
          .sort(function(a, b){ return a.p.price - b.p.price; })[0] || null;

        var upgrades = scored.filter(function(s){ return s.genDiff >= 1 && s.genDiff <= 4; })
          .sort(function(a, b) {
            if (a.isProMax && !b.isProMax) return -1;
            if (!a.isProMax && b.isProMax) return 1;
            if (a.isPro && !b.isPro) return -1;
            if (!a.isPro && b.isPro) return 1;
            return a.p.price - b.p.price;
          });
        if (!upgrades.length) {
          upgrades = scored.filter(function(s){ return s.genDiff >= 1; })
            .sort(function(a,b){ return a.p.price - b.p.price; });
        }
        var up = upgrades[0] || null;
        if (up && rep && up.p.handle === rep.p.handle) up = upgrades[1] || null;

        replacement = rep ? rep.p : null;
        bestUpgrade = up ? up.p : null;
        showTradein = true;

        if (rep) {
          budgetLabelText = rep.genDiff >= 2 ? '📱 Newer device'
            : rep.genDiff === 1 ? '📱 One gen newer'
            : '📱 Same generation';
        }
        if (replacement) {
          var diff = repairPriceNum - replacement.price;
          if (diff > 20) {
            // ⚠ The warranty on a phone we SELL is grade-specific — Grade A/B 12 months, Grade C 6 —
            // so this line may not promise twelve. It named a figure the policy does not always
            // honour, on the screen where somebody is deciding to spend money (ChatGPT whole-site
            // audit, 2026-09-14, OPEN HIGH). Repairs are the twelve-month promise; stock is graded.
            noteText = 'A fully working ' + replacement.title + ' is £' + replacement.price +
              ', less than this repair, graded, tested and warranted by grade. If you\'d rather upgrade, here\'s an option worth considering.';
          } else if (diff >= -20) {
            noteText = 'A working ' + replacement.title + ' is about the same price as this repair. ' +
              'If you\'d prefer a different phone, it\'s worth a look before you commit.';
          } else {
            noteText = 'This repair is cheaper than any replacement we have in stock, so it is good value to fix and keep. ' +
              'But if you fancy a change, here\'s one to consider.';
          }
        }

      } else {
        // ── Samsung / Pixel / iPad: price-based upsell ────────────
        // Surface devices at a SIMILAR-OR-HIGHER price than the repair
        // (never a cheap older model). Same brand for the like-for-like
        // slot; iPhone cross-sell for the premium slot.
        var myBrand = S.type; // 'samsung' | 'google' | 'ipad'
        var floor = Math.round(repairPriceNum * 0.85);

        var stock = opts.all.slice().sort(function(a, b){ return a.price - b.price; });
        var atOrAbove = stock.filter(function(p){ return p.price >= floor; });
        var pool = atOrAbove.length ? atOrAbove : stock;

        // r149 (Codex FSA-016, WEB-043) — LIKE FOR LIKE IS THE SAME BRAND AT OR ABOVE THE REPAIR'S PRICE, OR NONE. With no same
        // brand phone it took the nearest priced phone of ANY brand, and with nothing at or above the floor it searched the
        // cheapest stock too, so a Galaxy repair was set against an older, unrelated iPhone. The slot now stays empty
        // instead; the premium slot's iPhone below is unchanged.
        var sameBrand = atOrAbove.filter(function(p){ return brandKey(p.title) === myBrand; });
        replacement = sameBrand.slice().sort(function(a, b){
          return Math.abs(a.price - repairPriceNum) - Math.abs(b.price - repairPriceNum);
        })[0] || null;

        // Premium / cross-sell: prefer an iPhone (the conversion goal),
        // priced at/above the repair; else priciest available.
        var iphones = pool.filter(function(p){ return brandKey(p.title) === 'iphone'; });
        var upPool = iphones.length ? iphones : pool;
        bestUpgrade = upPool.filter(function(p){ return p.price >= repairPriceNum; })
          .sort(function(a, b){ return a.price - b.price; })[0]
          || upPool.slice().sort(function(a, b){ return b.price - a.price; })[0]
          || null;

        if (bestUpgrade && replacement && bestUpgrade.handle === replacement.handle) {
          bestUpgrade = upPool.filter(function(p){ return p.handle !== replacement.handle; })
            .sort(function(a, b){ return b.price - a.price; })[0] || null;
        }

        budgetLabelText = '📱 In stock now';
        if (replacement) {
          // r149 (WEB-043): "an Apple", never "a Apple"
          noteText = 'Repairs can cost almost as much as a replacement. For around the same money you could move to '
            + (/^[aeiou]/i.test(String(replacement.title || '').trim()) ? 'an ' : 'a ') +
            // ⚠ THE SENTENCE THE AUDIT QUOTED. "Everything we sell … 12-month warranty" is false for
            // Grade C, which carries six under our own published policy — the strongest promise on
            // the site exceeding the contract behind it, which is how warranty disputes start.
            replacement.title + ', or switch to a refurbished iPhone. Everything we sell is graded and tested, with a 12 month warranty on Excellent and Good and 6 months on Fair.';
        }
      }

      if (!replacement && !bestUpgrade) { hide(compare); show(generic); return; }

      show(compare); hide(generic);

      var colLabel = $('cdmc-r-repair-col-label');
      if (colLabel) colLabel.textContent = repairColLabel;
      $('cdmc-r-compare-repair-price').textContent = repairPriceStr;

      // ── Budget / VS slot ─────────────────────────────────────────
      var budgetSlot = $('cdmc-r-compare-budget-slot');
      var budgetLabel = $('cdmc-r-compare-budget-label');
      if (replacement && budgetSlot) {
        show(budgetSlot);
        if (budgetLabel) budgetLabel.textContent = budgetLabelText;
        $('cdmc-r-compare-budget-price').textContent = '£' + replacement.price;
        $('cdmc-r-compare-budget-sub').textContent = replacement.displayTitle || replacement.title;
        $('cdmc-r-compare-budget-facts').textContent = replacement.details || '';
        $('cdmc-r-compare-budget-link').setAttribute('aria-label', 'View ' + replacement.title + ' (opens in a new tab)');
        $('cdmc-r-compare-budget-link').href = replacement.url;
        hide($('cdmc-r-compare-budget-img'));
        if (replacement.image) {
          var img = $('cdmc-r-compare-budget-img');
          if (img) { img.src = replacement.image; show(img); }
        }

        // Trade-in / net-cost rows — iPhone only (priced trade-in data)
        var tiRow = $('cdmc-r-compare-tradein-row');
        var netRow = $('cdmc-r-compare-net-row');
        var tiValEl = $('cdmc-r-compare-tradein-val');
        var netValEl = $('cdmc-r-compare-net-val');
        if (showTradein) {
          var tradeinFaults = [];
          S.faults.forEach(function(f){ if(f !== 'none') tradeinFaults.push(f); });
          var primaryFaultMap = {
            'screen':'screen_cracked', 'battery':'battery', 'back-glass':'back_glass',
            'camera':'rear_camera', 'camera-lens':'camera_lens_damage',
            'charging-port':'charging', 'small-parts':'speaker',
            'water':'water', 'face-id':'face_id'
          };
          var primaryFaultKey = primaryFaultMap[S.repair];
          if (primaryFaultKey && tradeinFaults.indexOf(primaryFaultKey) === -1) {
            tradeinFaults.push(primaryFaultKey);
          }
          // r148 (CC-13): the headline's answer (recycling, blocked, a phone we must test: both rows stay hidden)
          var tiVal = autoTradeinValue('broken', tradeinFaults);
          if (tiVal && tiRow && tiValEl && netRow && netValEl) {
            tiValEl.textContent = moneyRange(tiVal.cash, tiVal.cashHi);
            show(tiRow);
            var netLo = Math.max(0, replacement.price - tiVal.cashHi);
            var netHi = Math.max(0, replacement.price - tiVal.cash);
            netValEl.textContent = netLo === 0 ? 'Could be £0 with trade in' : moneyRange(netLo, netHi, ' with trade in');
            show(netRow);
          } else {
            if (tiRow) hide(tiRow);
            if (netRow) hide(netRow);
          }
        } else {
          if (tiRow) hide(tiRow);
          if (netRow) hide(netRow);
        }
      } else if (budgetSlot) {
        hide(budgetSlot);
      }

      // ── Note copy ────────────────────────────────────────────────
      var noteEl = $('cdmc-r-compare-note');
      if (noteEl) noteEl.textContent = noteText;

      // ── Premium / cross-sell card ────────────────────────────────
      var premCard = $('cdmc-r-premium-card');
      if (bestUpgrade && premCard) {
        show(premCard);
        $('cdmc-r-premium-title').textContent = bestUpgrade.displayTitle || bestUpgrade.title;
        $('cdmc-r-premium-facts').textContent = bestUpgrade.details || '';
        $('cdmc-r-premium-link').setAttribute('aria-label', 'View ' + bestUpgrade.title + ' (opens in a new tab)');
        $('cdmc-r-premium-price').textContent = '£' + bestUpgrade.price;
        $('cdmc-r-premium-link').href = bestUpgrade.url;
        hide($('cdmc-r-premium-img'));
        if (bestUpgrade.image) {
          var pImg = $('cdmc-r-premium-img');
          if (pImg) { pImg.src = bestUpgrade.image; show(pImg); }
        }
      } else if (premCard) { hide(premCard); }

    }).catch(function(){ hide(compare); show(generic); });
  }

  var BENCH_NOTES = {
    'screen': "If the frame behind the screen is bent, I straighten it before fitting the new one. That's what keeps the screen flush and properly sealed.",
    'screen-lcd': "LCD only faults still get a full panel fit, because the LCD and glass come as one calibrated unit.",
    'screen-touch': "Touch faults are retested after fitting on every corner of the glass before it ships back.",
    'battery': "I check cycle count and the charging IC before fitting. Sometimes 'bad battery' is actually a charging fault.",
    'charging-port': "Plenty of the time it's just compacted lint, so I clear that first. If that's all it was, it's £20 to clean the port and the speakers, plus return postage. If it still won't charge properly, the port gets replaced.",
    'back-glass': "The glass comes off with controlled heat and patience, not a pry tool, so there is no stress on the frame or antennas.",
    'housing': "Everything transfers to the new housing (board, cameras, Face ID) and gets tested at each step.",
    'camera': "I test both lenses and stabilisation after fitting. OIS is where cheap camera repairs fail.",
    'camera-lens': "Lens glass only. If the camera underneath took damage too, I'll tell you before doing anything.",
    // r153 (Codex FSA-060; Dan, D-20260927-b (5): "Apple part for the serial") — the note said the original flex is repaired,
    // beside the quote's own line that the part is ordered for the serial through Apple's Self Service Repair: one method now.
    'face-id': "Face ID is paired to your phone's board, so the new part is ordered for your serial number and paired to it with Apple's own tools.",
    'small-parts': "Speakers and mics are cheap parts. The skill is reassembly without disturbing the water seal.",
    'software': "Won't turn on gets checked at board level first. It's often power management, not the screen.",
    'water': "First job is stopping the corrosion: strip down, ultrasonic clean, then assess what survived.",
    'other': "Describe it as best you can. After {repaired} repairs, very little surprises me."
  };

  function _reportRef() {
    return 'CD-' + Date.now().toString(36).toUpperCase().slice(-6);
  }

  function renderBenchNote(primaryKey) {
    var sumEl = $('cdmc-r-summary');
    if (!sumEl) return;
    var note = BENCH_NOTES[primaryKey];
    if (!note) return;
    // D-20260923-k: the one repaired figure (snippets/cd-counters.liquid), never a number typed here.
    note = note.replace('{repaired}', (window.CDCounters && window.CDCounters.text) ? window.CDCounters.text('repaired', '+') : '4,000+');
    var old = sumEl.querySelector('.cdmc__bench-note');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    sumEl.insertAdjacentHTML('beforeend',
      '<div class="cdmc__bench-note">🔧 <em>Technician\'s note:</em> ' + note + '</div>');
  }

  function renderRepairSummary(primaryKey, primaryPrice) {
    var sumEl = $('cdmc-r-summary');
    if (!sumEl) return;
    var rows = [
      ['📱','Device', S.model + (S.storage ? ' · ' + S.storage : '')],
      ['🔧','Repair', $('cdmc-r-repair').textContent],
      ['💷', $('cdmc-r-from').textContent === 'bundle' ? 'Bundle total' : 'From price', $('cdmc-r-price').textContent]
    ];
    if (S.parts) {
      var pl = S.parts === 'genuine' ? 'Genuine Apple' : (S.parts === 'oled' ? 'Aftermarket OLED' : (S.parts === 'lcd' ? 'LCD' : 'Third-party'));
      rows.push(['🧩','Parts', pl]);
    }
    if (S.battHealth && S.battHealth !== 'good' && S.battHealth !== 'unknown') {
      var bhSummary = S.battHealth === 'degraded' ? '80 to 89% (Degraded)' : 'Below 80% (Flagged for replacement)';
      rows.push(['🔋','Battery health', bhSummary]);
    }
    var sumPrimaryTags = primaryFaultKeysFor(primaryKey);
    var extras = S.faults.filter(function(f){ return f !== 'none' && sumPrimaryTags.indexOf(f) === -1; });
    if (extras.length > 0) rows.push(['📝','Other faults', extras.map(function(f){ return faultLabel(f); }).join(', ')]);
    rows.push(['🛡️','Warranty', warrantyMonthsFor(S.parts) + ' months']);
    rows.push(['🧾','Report ref', _reportRef()]);
    rows.push(['📅','Date', new Date().toLocaleDateString('en-GB', { timeZone: 'Europe/London' })]);   // r148 (CC-87)
    sumEl.innerHTML = '<span class="cdmc__sum-title">YOUR REPAIR</span>' +   // R-129 ST-37: nothing was diagnosed
      rows.map(function(r){
        return '<div class="cdmc__sum-row"><span class="cdmc__sum-icon">' + r[0] + '</span>' +
          '<span class="cdmc__sum-label">' + escHTML(r[1]) + '</span>' +
          '<span class="cdmc__sum-val">' + escHTML(r[2]) + '</span></div>';
      }).join('');
  }

  function revertToPrimary() {
    S.faults = [];
    document.querySelectorAll('#cdmc-sr3 .cdmc__vfault.active').forEach(function(b){ b.classList.remove('active'); });
    renderRepairFaultDetails();   // R-096 (second wave): its questions sit on the screen Back returns to
    renderRepairResult();
  }

  // ⚠ R-096 TOOK TWO THINGS OUT OF THIS FUNCTION, AND BOTH WOULD HAVE BEEN SILENT BUGS IF LEFT.
  // (1) Picking a grade used to BE the end of the flow — it ran the valuation immediately, because
  // the grade lived on a screen of its own with nothing under it. It now sits half way up screen 3
  // with battery, account, network and blacklist still to answer, so it must only record.
  // (2) The low-battery carry (`S.faults = ['battery']` when health is below 80%) used to be safe
  // here because battery health was asked on the PREVIOUS screen and could not be unanswered. On
  // one screen the grade can be picked FIRST, and then this line would read an empty `S.battHealth`
  // and wipe the deduction the seller is about to declare. It moved to checkContinue, where the
  // answer is known to exist. Same class as the ordering traps in L-always-17: a derivation must
  // read its input after the input is written, not before.
  function setCond(cond) {
    S.cond = cond;
    document.querySelectorAll('.cdmc__cond-btn').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-cond') === cond);
    });
    hide($('cdmc-check-err'));
  }

  // r148 (CC-04) — the faulty branch's own grade question: how the rest of the phone looks, Good or Fair.
  function setFaultGrade(g) {
    S.faultGrade = g === 'fair' ? 'fair' : g === 'good' ? 'good' : '';
    document.querySelectorAll('[data-action="set-fault-grade"]').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-fgrade') === S.faultGrade);
    });
    var q = $('cdmc-fault-grade'); if (q) q.classList.remove('cdmc__fault-detail--missing');
    hide($('cdmc-check-err'));
  }
  // A faulty phone's looks in words, wherever its condition is written (empty when not faulty or not given).
  function faultGradeWords() {
    if (S.cond !== 'broken' || !S.faultGrade) return '';
    return S.faultGrade === 'fair' ? 'Fair, visible wear' : 'Good, minimal wear';
  }

  // The lock panel explains TWO prices (the unlocked estimate vs a "£0 - £20" locked recycling price). A
  // free-recycling model has neither (D-20260911-d), so the panel stays shut for it; the lock answer still reaches Dan.
  function lockInfoApplies(lock) { return lock === 'no' && !isRecycleOnly(S.model); }

  function setLock(lock) {
    S.lock = lock;
    document.querySelectorAll('#cdmc-lock-yes, #cdmc-lock-no').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-lock') === lock);
    });
    $('cdmc-lock-info').classList.toggle('cd-hidden', !lockInfoApplies(lock));
    // v512 — the locked-phone parts price is this phone's recycling band, not a flat £20. When the
    // server publishes no band for the row we say so rather than printing a number we cannot stand
    // behind: the lock panel is read by someone deciding whether to bother removing the lock.
    var lp = $('cdmc-lock-parts-price');
    if (lp) { var b = recycleBandFor(S.model); lp.textContent = b != null ? ('£' + b) : 'Quoted personally'; }
    hide($('cdmc-t2-err'));
  }

  // The branch that used to be two DESTINATIONS (st1 for a working phone, st2 for a faulty one) is
  // now two sibling panels on screen 3, revealed in place. ⚠ Switching branch has to clear the
  // other branch's answers: a seller who ticked "Cracked screen", changed their mind and chose
  // "Fully working" would otherwise carry a screen deduction into a Grade A valuation, and the only
  // sign of it would be a price that came out low.
  function setFaulty(val) {
    S.faulty = val;
    document.querySelectorAll('[data-action="set-faulty"]').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-faulty') === val);
    });
    var working = $('cdmc-cond-working');
    var faulty  = $('cdmc-cond-faults');
    if (working) working.classList.toggle('cd-hidden', val !== 'no');
    if (faulty)  faulty.classList.toggle('cd-hidden', val !== 'yes');
    if (val === 'no') {
      S.faults = [];
      Object.keys(S.sym).forEach(function(k){ S.sym[k] = []; }); S.symFrom = {};
      document.querySelectorAll('#cdmc-cond-faults .cdmc__vfault.active').forEach(function(b){ b.classList.remove('active'); });
      hide($('cdmc-t2-other-desc'));
      var ot = $('cdmc-t2-other-text'); if (ot) ot.value = '';
      setFaultGrade('');   // r148 (CC-04): a working phone's grade is the one above, never the faulty branch's
    } else if (val === 'yes') {
      S.cond = '';
      document.querySelectorAll('#cdmc-cond-working .cdmc__cond-btn.active').forEach(function(b){ b.classList.remove('active'); });
    }
    renderFaultDetails();
    hide($('cdmc-check-err'));
  }

  function setCarrier(val) {
    S.carrier = val;
    document.querySelectorAll('#cdmc-carrier-yes, #cdmc-carrier-no').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-carrier') === val);
    });
    var w = $('cdmc-carrier-warn'); if (w) w.classList.toggle('cd-hidden', val !== 'no');
  }

  // D-20260915-n: four answers, not two. 'yes' = blocked by a network or insurer (may be bought for parts),
  // 'stolen' = reported lost or stolen (never bought — dominates every other answer), 'unsure' = treated as blocked
  // until the IMEI is checked, 'no' = clean. The old "Yes / not sure" button lumped the first three together.
  // R-130 (SJ-46) — 'unsure' is NOT blocked: most sellers do not know, and telling them their phone is blocked loses them.
  // They get the normal quote with a note that the IMEI is checked on arrival (cdmc-t-blacklist-unsure).
  function blacklistBlocked(val) { return val === 'yes'; }
  function setBlacklist(val) {
    S.blacklist = val;
    document.querySelectorAll('[data-action="set-blacklist"]').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-blacklist') === val);
    });
    var w = $('cdmc-bl-warn'); if (w) w.classList.toggle('cd-hidden', !blacklistBlocked(val));
    var sw = $('cdmc-bl-stolen-warn'); if (sw) sw.classList.toggle('cd-hidden', val !== 'stolen');
    hide($('cdmc-check-err'));
  }

  function showCheckErr(msg, near) {
    var e = $('cdmc-check-err');
    if (e) { e.textContent = '⚠ ' + msg; show(e); }
    // R-129 ST-25 — when the answer that is missing belongs to one question, go to THAT question and mark it; the
    // message by the button stays too, for anyone who scrolls back down.
    if (near) { near.classList.add('cdmc__fault-detail--missing'); }
    var target = near || e;
    if (target) { try { target.scrollIntoView({ behavior:'smooth', block:'center' }); } catch(x){} }
  }

  // R-096: this is now the END of the sell/trade-in questions, not a fork. It used to validate four
  // answers and then send the seller to one of two more screens; it validates the whole of screen 3
  // and runs the valuation.
  //
  // ⚠ THE CHECKS RUN IN THE ORDER THE QUESTIONS APPEAR DOWN THE PAGE. On two screens the order did
  // not matter because the unanswered question was always the one in front of you. On one screen a
  // message about the blacklist question while the grade picker above it is still blank sends the
  // seller looking in the wrong place.
  function checkContinue() {
    if (!S.faulty) { showCheckErr('Please tell us whether the phone is faulty or all working.'); return; }
    if (S.faulty === 'no' && !S.cond) {
      showCheckErr('Please choose the condition that matches your phone.'); return;
    }
    if (S.faulty === 'yes' && !S.faults.filter(function (f) { return f && f !== 'none'; }).length) {
      showCheckErr('Please pick at least one fault, or choose "Fully working" above.'); return;
    }
    // R-132 / SJ-07 (2026-09-21) — a screen fault needs its detail. The live audit got a price with "Cracked screen"
    // ticked and none of its "which of these?" answers chosen, so the lead arrived not saying what kind of damage.
    if (S.faulty === 'yes') {
      var scrMissing = S.faults.filter(function (f) {
        var cfg = FAULT_DETAIL[f];
        if (!cfg || cfg.bucket !== 'scr') return false;
        var picked = S.sym.scr || [];
        return !cfg.options.some(function (o) { return picked.indexOf(o.val) !== -1; });
      });
      if (scrMissing.length) {
        showCheckErr('Please tell us what the screen is doing. Choose one under "' + FAULT_DETAIL[scrMissing[0]].label + '".',
          document.querySelector('#cdmc-fault-details [data-detail-for="' + scrMissing[0] + '"]')); return;
      }
    }
    if (S.faulty === 'yes' && !S.faultGrade) {   // r148 (CC-04)
      showCheckErr('Please tell us how the rest of the phone looks.', $('cdmc-fault-grade')); return;
    }
    if (S.type === 'iphone' && !S.battHealth) { showCheckErr('Please choose your battery health.'); return; }
    if (!S.lock)      { showCheckErr('Please answer the Apple / Google account question.'); return; }
    if (!S.blacklist) { showCheckErr('Please answer the blacklist question.'); return; }
    hide($('cdmc-check-err'));
    if (S.faulty === 'yes') {
      S.cond = 'broken';
      // r148 (CC-04) — a battery below 80% is carried on this branch too, whatever order the answers came in: choosing
      // "Fully working" first clears the faults, and with them a battery fault the health answer had derived.
      if (S.battHealth === 'low' && S.faults.indexOf('battery') === -1) { S.faults.push('battery'); S.battFaultDerived = true; }
    } else {
      // Moved out of setCond, where it read S.battHealth before the seller had necessarily given
      // it — see the note on setCond. Here the answer is validated above, so a phone declared
      // "fully working" with a sub-80% battery still carries the battery deduction it should.
      S.faults = (S.battHealth === 'low') ? ['battery'] : [];
    }
    // ⚠ THIS ONE PUSHES HISTORY, AND THE OTHER CALLS DELIBERATELY DO NOT. Every other route to the
    // result passes `false` because it is arriving from a TRANSIENT screen (a queued fault detail,
    // or the result screen re-pricing itself after a switch) that Back should not return to. Screen
    // 3 is not transient — it holds every answer the seller gave — and with `false` here the Back
    // button walked straight past it to the intent screen, losing the one screen they would want to
    // correct. Caught on the harness; the old chain happened to push st-check on the way through
    // the fault log, so nothing about it was ever deliberate.
    runCalculatingOverlay(function(){ renderTradeinResult(); goStep('st3'); });
  }

  function renderLockInfoPrice() {
    var v0 = compValueFor(S.model, 'good', []);
    var lp = $('cdmc-lock-info-price');
    if (lp) lp.textContent = (v0 && v0.recycle) ? RECYCLE_LABEL : (v0 && S.type === 'iphone') ? moneyRange(v0.cash, v0.cashHi) : 'Your estimate';
  }
  function enterCheck() {
    var bw = $('cdmc-check-batt'); if (bw) bw.classList.toggle('cd-hidden', S.type !== 'iphone');
    renderLockInfoPrice();
    document.querySelectorAll('[data-action="set-faulty"]').forEach(function(b){ b.classList.toggle('active', !!S.faulty && b.getAttribute('data-faulty') === S.faulty); });
    // Screen 3 carries both branches and every follow-up now, so ENTERING it has to restore all of
    // them — coming back with the Back button, or arriving with faults already carried over from a
    // repair quote (_carryFaultsToTradeIn), must show what the seller already answered.
    var workingPanel = $('cdmc-cond-working');
    var faultsPanel  = $('cdmc-cond-faults');
    if (workingPanel) workingPanel.classList.toggle('cd-hidden', S.faulty !== 'no');
    if (faultsPanel)  faultsPanel.classList.toggle('cd-hidden', S.faulty !== 'yes');
    document.querySelectorAll('#cdmc-cond-faults [data-action="fault-toggle"]').forEach(function(b){
      b.classList.toggle('active', S.faults.indexOf(b.getAttribute('data-fault')) !== -1);
    });
    document.querySelectorAll('#cdmc-cond-working .cdmc__cond-btn').forEach(function(b){
      b.classList.toggle('active', !!S.cond && b.getAttribute('data-cond') === S.cond);
    });
    document.querySelectorAll('[data-action="set-batt-health"]').forEach(function(b){
      b.classList.toggle('active', !!S.battHealth && b.getAttribute('data-bh') === S.battHealth);
    });
    document.querySelectorAll('[data-action="set-fault-grade"]').forEach(function(b){   // r148 (CC-04)
      b.classList.toggle('active', !!S.faultGrade && b.getAttribute('data-fgrade') === S.faultGrade);
    });
    var otherBox = $('cdmc-t2-other-desc');
    if (otherBox) otherBox.classList.toggle('cd-hidden', S.faults.indexOf('other_fault') === -1);
    renderFaultDetails();
    document.querySelectorAll('#cdmc-lock-yes, #cdmc-lock-no').forEach(function(b){ b.classList.toggle('active', !!S.lock && b.getAttribute('data-lock') === S.lock); });
    document.querySelectorAll('#cdmc-carrier-yes, #cdmc-carrier-no').forEach(function(b){ b.classList.toggle('active', !!S.carrier && b.getAttribute('data-carrier') === S.carrier); });
    document.querySelectorAll('[data-action="set-blacklist"]').forEach(function(b){ b.classList.toggle('active', !!S.blacklist && b.getAttribute('data-blacklist') === S.blacklist); });
    $('cdmc-lock-info').classList.toggle('cd-hidden', !lockInfoApplies(S.lock));
    var cw = $('cdmc-carrier-warn'); if (cw) cw.classList.toggle('cd-hidden', S.carrier !== 'no');
    var blw = $('cdmc-bl-warn'); if (blw) blw.classList.toggle('cd-hidden', !blacklistBlocked(S.blacklist));
    var blsw = $('cdmc-bl-stolen-warn'); if (blsw) blsw.classList.toggle('cd-hidden', S.blacklist !== 'stolen');
    goStep('st-check');
  }

  var FAULT_DETAIL = {
    screen_cracked: { label:'Screen damage', icon:'😱', bucket:'scr', options:[
      {val:'scr_cracked',icon:'💔',label:'Badly smashed: pieces missing or sharp edges'},   // R-129 ST-39: it overlapped "cracked glass only" (both price as screen_cracked)
      {val:'scr_touch',icon:'👆',label:'Touch not working'},
      {val:'scr_lines',icon:'〰️',label:'Lines / discolouration'},
      {val:'scr_dead',icon:'⬛',label:'Black / no display'},
      {val:'scr_glass',icon:'🪟',label:'Cracked glass only, the screen works fine'}
    ]},
    screen_damaged: { label:'Screen not displaying', icon:'🖥️', bucket:'scr', options:[
      {val:'scr_dead',icon:'⬛',label:'Completely black / no display'},
      {val:'scr_lines',icon:'〰️',label:'Lines / discolouration'},
      {val:'scr_flicker',icon:'⚡',label:'Flickering'},
      {val:'scr_dim',icon:'🌑',label:'Very dim / backlight gone'},
      {val:'scr_notsure',icon:'🤷',label:'Not sure'}
    ]},
    battery: { label:'Battery issues', icon:'🔋', bucket:'bat', options:[
      {val:'bat_drain',icon:'📉',label:'Drains very fast'},
      {val:'bat_pct',icon:'🔋',label:'Battery % jumps or wrong'},
      {val:'bat_shutdown',icon:'💀',label:'Shuts off suddenly'},
      {val:'bat_hot',icon:'🌡️',label:'Gets very hot'},
      {val:'bat_health',icon:'📊',label:'Low battery health in Settings'},
      {val:'bat_notsure',icon:'🤷',label:'Not sure / general issues'}
    ]},
    wont_turn_on: { label:"Won't turn on", icon:'⚫', bucket:'sft', options:[
      {val:'sft_wont_on',icon:'⚫',label:"Completely dead, won't turn on"},
      {val:'sft_bootloop',icon:'🔄',label:'Stuck in boot loop'},
      {val:'sft_disabled',icon:'🔒',label:'iPhone disabled / locked out'},
      {val:'sft_update',icon:'📲',label:'Stuck on update or restore'},
      {val:'sft_slow',icon:'🐌',label:'Extremely slow / freezing'}
    ]},
    charging: { label:'Charging problems', icon:'🔌', bucket:'chg', options:[
      {val:'chg_angle',icon:'📐',label:'Only charges at an angle'},
      {val:'chg_loose',icon:'🔓',label:"Cable doesn't click / sits loose"},
      {val:'chg_nofit',icon:'🚫',label:"Cable won't go in properly"},
      {val:'chg_slow',icon:'🐢',label:'Charges very slowly'},
      {val:'chg_none',icon:'🔴',label:"Won't charge at all"},
      {val:'chg_notsure',icon:'🤷',label:'Not sure / other'}
    ]},
    speaker: { label:'Speaker / mic', icon:'🔊', bucket:'sml', options:[
      {val:'sml_speaker',icon:'🔊',label:'Speaker: no sound, or muffled'},
      {val:'sml_mic',icon:'🎤',label:"Microphone: people can't hear me"},
      {val:'sml_earpiece',icon:'📞',label:'Earpiece: quiet on calls'},
      {val:'sml_notsure',icon:'🤷',label:'Not sure'}
    ]},
    buttons: { label:'Buttons', icon:'🔘', bucket:'sml', options:[
      {val:'sml_power_btn',icon:'⚡',label:'Power button stuck / not clicking'},
      {val:'sml_vol_btn',icon:'🔇',label:'Volume buttons not working'},
      {val:'sml_mute',icon:'🔕',label:'Mute switch stuck / broken'},
      {val:'sml_vibrate',icon:'📳',label:'Vibration not working'},
      {val:'sml_notsure',icon:'🤷',label:'Not sure'}
    ]},
    rear_camera: { label:'Camera fault', icon:'📷', bucket:'cam', options:[
      {val:'cam_blurry',icon:'🌫️',label:"Blurry / won't focus"},
      {val:'cam_spots',icon:'⚫',label:'Black spots / marks'},
      {val:'cam_vibrate',icon:'📳',label:'Vibrating / rattling'},
      {val:'cam_lens_cracked',icon:'💔',label:'Lens glass cracked'},
      {val:'cam_notsure',icon:'🤷',label:'Other camera issue'}
    ]},
    back_glass: { label:'Back glass', icon:'🪟', bucket:'gls', options:[
      {val:'gls_cracked',icon:'💔',label:'Cracked / smashed'},
      {val:'gls_shattered',icon:'💥',label:'Shattered / missing pieces'},
      {val:'gls_scratched',icon:'🔆',label:'Deep scratches / scuffs'},
      {val:'gls_frame',icon:'🖼️',label:'Bent or damaged frame'},
      {val:'gls_cosmetic',icon:'✨',label:'Cosmetic only, the phone works fine'}
    ]},
    water: { label:'Water damage', icon:'💧', bucket:'sft', options:[
      {val:'sft_wont_on',icon:'⚫',label:"Phone won't turn on"},
      {val:'sml_speaker',icon:'🔊',label:'Speaker muffled / distorted'},
      {val:'chg_none',icon:'🔌',label:"Won't charge"},
      {val:'scr_lines',icon:'〰️',label:'Screen showing lines / damage'},
      {val:'sft_other',icon:'🤷',label:'Other water damage symptoms'}
    ]}
  };

  // r170 (CXH1012-06, Codex 12 Oct) — A SYMPTOM GOES WITH THE ENQUIRY ONLY WHILE SOMETHING CHOSEN STILL ASKS FOR IT.
  // Unticking an extra fault took it out of the price, the summary and fault_keys, but what was ticked under it stayed in
  // S.sym and every reader sent every bucket: "Drains very fast" reached Dan for a battery the customer had taken off the
  // quote. Two faults can share a bucket (speaker and buttons both write `sml`; water writes `sft` beside "Won't turn
  // on"), so emptying a bucket on untick would erase a still chosen fault's answers. So the readers ask this: a symptom a
  // fault's own question wrote (S.symFrom 'detail') goes only while a fault still in S.faults offers it in that bucket;
  // the main repair's own answers ('primary', toggleSym) and anything unmarked go as before. Not keyed on S.repair: the
  // camera questions change S.repair between 'camera' and 'camera-lens' after their answers are written.
  function liveSymptoms() {
    var chosen = {}, from = S.symFrom || {};
    S.faults.forEach(function (f) {
      var cfg = FAULT_DETAIL[f];
      if (cfg) cfg.options.forEach(function (o) { chosen[cfg.bucket + ':' + o.val] = true; });
    });
    var out = [];
    Object.keys(S.sym).forEach(function (bucket) {
      (S.sym[bucket] || []).forEach(function (sym) {
        var k = bucket + ':' + sym;
        if (from[k] !== 'detail' || chosen[k]) out.push(sym);
      });
    });
    return out;
  }

  // ── INLINE FAULT DETAIL (R-096, screen 3) ─────────────────────────────────────────────────────
  // Every ticked fault's follow-up question opens underneath the chips, all of them at once. This
  // is the whole six-screens-to-four win: the same questions used to be rendered ONE SCREEN PER
  // FAULT by _runDetailQueue below, so the "four step" counter was telling a seller with three
  // faults that they were on screen 3 of 4 for the third time running.
  //
  // ⚠ SEVERAL FAULTS SHARE A BUCKET ON PURPOSE — `screen_cracked` and `screen_damaged` both write
  // to `scr`, `speaker` and `buttons` both to `sml`, `water` and `wont_turn_on` both to `sft`. When
  // the queue showed them one at a time that was invisible. Side by side, a symptom ticked in one
  // group must light up in its twin, or the seller sees the same option unticked directly below the
  // one they just ticked — so the active state is re-derived across EVERY group from S.sym, never
  // toggled on the clicked button alone.
  // R-096 (second wave): the repair path's "Any other faults?" uses it too, into its own host and leaving out the faults
  // whose questions were already answered further up the same screen (renderRepairFaultDetails).
  function renderFaultDetails(hostId, skip) {
    var host = $(hostId || 'cdmc-fault-details');
    if (!host) return;
    var ticked = S.faults.filter(function (f) { return f !== 'none' && FAULT_DETAIL[f] && !(skip && skip[f]); });
    if (!ticked.length) { host.innerHTML = ''; return; }
    host.innerHTML = ticked.map(function (f) {
      var cfg = FAULT_DETAIL[f];
      if (!S.sym[cfg.bucket]) S.sym[cfg.bucket] = [];
      return '<div class="cdmc__fault-detail" data-detail-for="' + f + '">' +
        '<span class="cdmc__vfault-section-label">' + cfg.icon + ' ' + cfg.label + ': which of these?</span>' +
        '<div class="cdmc__vfault-grid">' +
        cfg.options.map(function (o) {
          return '<button type="button" class="cdmc__vfault cdmc__t2b-opt" ' +
            'data-action="t2b-toggle" data-sym="' + o.val + '" data-bucket="' + cfg.bucket + '">' +
            '<span class="cdmc__vfault-icon">' + o.icon + '</span>' +
            '<span class="cdmc__vfault-label">' + o.label + '</span></button>';
        }).join('') +
        '</div></div>';
    }).join('');
    syncFaultDetailActive();
  }

  function syncFaultDetailActive() {
    document.querySelectorAll('#cdmc-fault-details [data-action="t2b-toggle"], #cdmc-sr3-details [data-action="t2b-toggle"]').forEach(function (b) {
      var bucket = b.getAttribute('data-bucket');
      var list = S.sym[bucket] || [];
      b.classList.toggle('active', list.indexOf(b.getAttribute('data-sym')) !== -1);
    });
    // ST-25 — an answered question drops its "missing" mark
    document.querySelectorAll('#cdmc-fault-details .cdmc__fault-detail--missing').forEach(function (blk) {
      if (blk.querySelector('[data-action="t2b-toggle"].active')) blk.classList.remove('cdmc__fault-detail--missing');
    });
  }

  // ⚠ REPAIR'S EXTRA FAULTS, ON THE SAME SCREEN (R-096, second wave, 2026-10-05). They used to be asked one SCREEN per
  // fault (`sr-detail`, which had been selling's `st2b`), each labelled "03 / 04" again; now each ticked fault's question
  // opens under "Any other faults?" as selling's do. A fault whose question was already answered further up the screen
  // (the symptom check of the main repair) is not asked twice: the set is taken when "Any other faults?" opens
  // (renderSr3), from the answers above it, never while its own questions are being ticked, or answering one would
  // hide it.
  var _sr3Skip = {};
  function repairAnsweredFaults() {
    return {
      screen_cracked: S.sym.scr.length > 0,
      screen_damaged: S.sym.scr.length > 0,
      screen_lcd_fault: true,
      screen_touch_only: true,
      battery: S.sym.bat.length > 0,
      charging: S.sym.chg.length > 0,
      speaker: S.sym.sml.length > 0,
      buttons: S.sym.sml.length > 0,
      rear_camera: S.sym.cam.length > 0,
      back_glass: S.sym.gls.length > 0
    };
  }
  function renderRepairFaultDetails() { renderFaultDetails('cdmc-sr3-details', _sr3Skip); }

  var _battHealthCallback = null;

  // "Any other faults?" is the last question on the folded screen and its follow ups are already answered under it, so
  // Continue goes to the price (the history keeps the way back to the screen, goStep).
  function repairDetails() {
    goStep('sr4', false);
    renderRepairResult();
  }

  function calcTradein() {
    runCalculatingOverlay(function(){
      renderTradeinResult();
      goStep('st3', false);
    });
  }

  function runCalculatingOverlay(onDone) {
    var overlay = $('cdmc-calc');
    var linesEl = $('cdmc-calc-lines');
    var labelEl = $('cdmc-calc-label');
    if (!overlay || !linesEl) { onDone(); return; }
    show(overlay);
    linesEl.innerHTML = '';
    // r152 (app v784; Stranger ST-37) — plain words: what is actually happening, no "valuation engine" theatre
    var steps = isRecycleOnly(S.model) ? [
      'Checking the ' + S.model + '…',
      'Checking what we can offer for it…'
    ] : [
      'Checking recent sales of the ' + (S.model || 'phone') + '…',
      'Working out your cash and trade in values…'
    ];
    var i = 0;
    function nextLine() {
      if (i >= steps.length) {
        labelEl.textContent = 'Done.';
        setTimeout(function(){
          hide(overlay);
          onDone();
        }, 400);
        return;
      }
      var cls = (i === steps.length - 1) ? 'cdmc-calc__line cdmc-calc__line--ok' : 'cdmc-calc__line';
      var line = document.createElement('div');
      line.className = cls;
      line.textContent = '> ' + steps[i];
      linesEl.appendChild(line);
      Array.from(linesEl.children).forEach(function(el, idx){
        if (idx < linesEl.children.length - 2) el.classList.add('cdmc-calc__line--dim');
      });
      i++;
      setTimeout(nextLine, 480);
    }
    nextLine();
  }

  // r148 (Claude cloud audit CC-13) — ONE ANSWER TO "IS THERE AN AUTOMATIC TRADE IN FIGURE?", for the headline and for
  // everything that nets a figure off a price. The upgrade picker and the repair page's trade in row called compValueFor
  // straight and skipped the headline's routing, so a phone that will not turn on read "£90 to £100 if working · £40 if
  // not" above a picker saying "after £165 trade in credit", and a blocked phone's "We'll quote directly" sat above £330
  // of credit (L-always-08, D-20260915-n). Null whenever the headline gives no automatic figure: lost or stolen,
  // blocked, free recycling, no price, or a phone we have to test first (not an iPhone, or a fault only a test can price).
  var TRADEIN_DIAG_FAULTS = ['wont_turn_on', 'water', 'screen_damaged', 'other_fault'];
  function autoTradeinValue(cond, faults) {
    if (S.blacklist === 'stolen' || blacklistBlocked(S.blacklist)) return null;
    if (S.type !== 'iphone') return null;
    if ((faults || []).some(function (f) { return TRADEIN_DIAG_FAULTS.indexOf(f) !== -1; })) return null;
    var v = compValueFor(S.model, cond, faults);
    return v && !v.recycle && v.cash && v.cashHi ? v : null;
  }

  function renderTradeinResult() {
    try { _renderTradeinResult(); } catch(e) {
      console.error('renderTradeinResult error:', e);
    }
  }
  // r152 (app v785; ChatGPT WEB-007) — THE NOTE SAYS WHERE THE FIGURE CAME FROM, as the teaser does (W7). It said "Based on
  // recent sales" under every figure, the built in ones too (the live table not arrived yet, or the model not in it).
  function estNoteWords(v) {
    return (v && v.live ? 'Based on recent sales. ' : 'A typical range for this model. ')
      + 'We confirm your offer by email once you\'ve filled in the short buying form.';
  }
  function _renderTradeinResult() {
    var v = compValueFor(S.model, S.cond, S.faults);
    var estNote = $('cdmc-t-est-note'); if (estNote) estNote.textContent = estNoteWords(v);   // r152 (WEB-007)
    $('cdmc-t-device').textContent = S.model ? S.model + (S.storage ? ' · ' + S.storage : '') : 'Your device';   // R-132 (SJ-04)
    S.quoteUntestable = false;
    hide($('cdmc-t-untestable'));
    hide($('cdmc-t-stolen-warn'));
    show($('cdmc-t-details'));   // FSA-014: only a refusal hides the details form (below), so every other result gets it back
    // D-20260915-n rule 1: REPORTED LOST OR STOLEN DOMINATES EVERY PATH — before free recycling, the lock, the
    // blacklist parts route and any figure. A phone carrying this AND a lock (or a recycle-only model) still refuses.
    if (S.blacklist === 'stolen') { setRecycleView(false); _renderStolenResult(v); return; }
    setRecycleView(!!(v && v.recycle));
    if (v && v.recycle) { _renderRecycleResult(v); return; }   // D-20260911-d — free recycling, never a figure
    var isSell = (S.intent === 'sell');
    var isIphoneModel = S.type === 'iphone';
    var DIAG_FAULTS_T = TRADEIN_DIAG_FAULTS;   // r148 (CC-13): the same list autoTradeinValue reads
    var needsDiag = !isIphoneModel || !v || S.faults.some(function(f){ return DIAG_FAULTS_T.indexOf(f) !== -1; });
    // v512 — EVERY UNTESTABLE FAULT GETS THE PAIR, not just a dead screen (Dan, 2026-09-20). R-117 #2
    // built this for "screen dead" alone and hard-coded a flat £20 parts price beside it; the shape was
    // right and the reach was not. Won't-turn-on, water and screen-dead now all quote "X if working ·
    // Y if not", and Y is the SERVER's per-phone recycling band rather than one number for every model
    // from an iPhone 7 to a 17 Pro Max.
    //
    // ⚠ This is the market with NO competing bidder — measured 2026-09-20 across 461 model|storage
    // combos, nobody at all buys a no-power or water-damaged phone (see AUDIT / R-109). "We'll assess"
    // was sending the one customer nobody else will serve to a form.
    var untestable = untestablePairFor(S.model, S.faults);
    if (!v) v = { cash: 0, cashHi: 0, upgrade: 0, upgHi: 0 };
    var cashStr, upgStr, extraStr;
    if (needsDiag) {
      if (untestable && untestable.workingHi != null) {
        S.quoteUntestable = true;
        var recStr = untestable.recycle != null ? ('£' + untestable.recycle + ' if not')
          : 'we\'ll quote you personally if not';
        cashStr = moneyRange(untestable.workingLo, untestable.workingHi, ' if working') + ' · ' + recStr;
        $('cdmc-untestable-works').textContent = moneyRange(untestable.workingLo, untestable.workingHi);
        $('cdmc-untestable-parts').textContent = untestable.recycle != null ? ('£' + untestable.recycle) : 'Quoted personally';
        show($('cdmc-t-untestable'));
      } else if (untestable && untestable.recycle != null) {
        // The working branch could not be proved (no part price, or Face ID cannot be checked on a
        // phone that will not power up). One honest number beats two where one is invented.
        S.quoteUntestable = true;
        cashStr = '£' + untestable.recycle + ' for parts';
        $('cdmc-untestable-works').textContent = 'Quoted personally';
        $('cdmc-untestable-parts').textContent = '£' + untestable.recycle;
        show($('cdmc-t-untestable'));
      } else {
        cashStr  = 'We\'ll assess';
      }
      upgStr   = 'We\'ll assess';
      extraStr = 'more';
    } else {
      cashStr  = v.cash && v.cashHi ? moneyRange(v.cash, v.cashHi) : 'We\'ll quote you personally';
      upgStr   = v.upgrade && v.upgHi ? moneyRange(v.upgrade, v.upgHi) : 'We\'ll quote you personally';
      // ⚠ A DIFFERENCE BETWEEN TWO RANGES IS ALMOST NEVER A RANGE (Dan, 2026-09-16: "it says trade in
      // and get £20 – £20 more"). Both ends of the uplift move together — upgLo is 1.375×cash and upgHi
      // is 1.30×cashHi — so the gap collapses to ONE number far more often than not, and the banner
      // then read "£20 – £20 more". It goes through the same one writer as every other range.
      var exLo = v.upgrade - v.cash, exHi = v.upgHi - v.cashHi;
      // R-130 (SJ-60) — "£55 – £45 more": the two bands have different widths, so the ends can cross. Say the most.
      var extra = (v.upgrade && v.cash) ? 'up to £' + Math.max(exLo, exHi) + ' more' : 'more';
      extraStr = extra;
    }
    var isBlacklisted = blacklistBlocked(S.blacklist);
    if (isBlacklisted) {
      cashStr = 'We\'ll quote directly';
      upgStr  = 'We\'ll quote directly';
      extraStr = 'more';
    }
    if (isSell) {
      if (needsDiag) {
        hide($('cdmc-upsell-hero'));
        $('cdmc-t-intent-label').textContent = 'Cash valuation, needs a look first';
        hide($('cdmc-t-upg-col'));
      } else {
        show($('cdmc-upsell-hero'));
        $('cdmc-upsell-cash-price').textContent = cashStr;
        $('cdmc-upsell-trade-price').textContent = upgStr;
        var upsellExtra = $('cdmc-upsell-extra');
        if (upsellExtra) upsellExtra.textContent = extraStr;
        $('cdmc-t-intent-label').textContent = 'Cash valuation';
        hide($('cdmc-t-upg-col'));
      }
    } else {
      hide($('cdmc-upsell-hero'));
      $('cdmc-t-intent-label').textContent = needsDiag ? 'Needs assessment first' : 'Trade in / cash options';
      if (needsDiag) hide($('cdmc-t-upg-col'));
      else show($('cdmc-t-upg-col'));
    }
    $('cdmc-t-cash').textContent = cashStr;
    $('cdmc-t-upg').textContent = upgStr;
    if (S.lock === 'no') {
      $('cdmc-lockwarn-full').textContent = isSell ? cashStr : upgStr;
      show($('cdmc-t-lockwarn'));
    } else {
      hide($('cdmc-t-lockwarn'));
    }
    var blWarn = $('cdmc-t-blacklist-warn');
    if (isBlacklisted) {
      hide($('cdmc-upsell-hero'));
      hide($('cdmc-t-upg-col'));
      hide($('cdmc-t-lockwarn'));
      hide($('cdmc-t-untestable'));
      S.quoteUntestable = false;
      $('cdmc-t-intent-label').textContent = 'Blocked, so parts only. We\'ll quote directly';
      if (blWarn) show(blWarn);
    } else if (blWarn) {
      hide(blWarn);
    }
    if (needsDiag && S.quoteUntestable) $('cdmc-t-intent-label').textContent = isSell ? 'Cash valuation, tested when it arrives' : 'Tested when it arrives';
    // R-117 #1: "highly accurate … no unexpected deductions" is a promise only a priced, testable quote can make.
    // R-130 (SJ-01) — nor can a quote from the built-in fallback figures: only a live-table quote is "highly accurate".
    var acc = $('cdmc-t-accuracy'); if (acc) acc.classList.toggle('cd-hidden', needsDiag || isBlacklisted || !(v && v.live));
    // R-130 (SJ-46) — "not sure" gets the normal quote plus one line about the IMEI check.
    var blUnsure = $('cdmc-t-blacklist-unsure'); if (blUnsure) blUnsure.classList.toggle('cd-hidden', S.blacklist !== 'unsure');
    // R-130 (SJ-35) — the locked-phone figure is this phone's own recycling price from the live table, never a flat £20.
    var lwp = $('cdmc-lockwarn-parts');
    if (lwp) { var rb = recycleBandFor(S.model); lwp.textContent = rb != null ? ('£' + rb + ' parts price') : 'a parts price we quote personally'; }
    // R-130 (SJ-47) — "Estimate ready" only when there IS an estimate.
    var stVal = document.querySelector('#cdmc-t-readout .cdmc__readout-val--ok');
    if (stVal) stVal.textContent = /quote|assess/i.test(String(cashStr)) ? 'We\'ll confirm by email' : 'Estimate ready';
    renderRepairAlternative();
    if (S.intent === 'upgrade') {
      show($('cdmc-upgrade-picker'));
      loadUpgradePicker();
    } else {
      hide($('cdmc-upgrade-picker'));
    }
    var submitLbl = $('cdmc-t-submit-label');
    if (submitLbl) {
      // v513 (D-20260921-b, AUDIT A-07) — the offer is no longer confirmed on WhatsApp: the lead emails the
      // customer their buying-form link and everything happens there.
      submitLbl.textContent = isSell ? 'GET MY CASH OFFER →' : 'CONFIRM MY TRADE IN →';
    }
    renderValuationBreakdown(needsDiag || isBlacklisted);
    renderTradeinSummary(v, isSell);
  }

  // "Repair all faults instead" + "Not the figure you wanted?" — a REPAIR price, so it shows on the free-recycling
  // outcome too (D-20260911-d is about buying these models; their repairs are unchanged). Moved verbatim.
  // R-117 #4 / D-20260915-m: the diagnostic fee is a DIAGNOSTIC, never a repair price. It used to be pushed into the
  // repair bundle (and bundle-discounted), so a no-display phone read "Repair all faults instead £40". Now repairs are
  // totalled without the untestable faults, and the fee is named beside them.
  function renderRepairAlternative() {
    if (SELL_ONLY) return;   // r165 (R-163): the sell only page carries no repair price, and the section leaves these rows out
    var DIAG_ONLY = ['wont_turn_on', 'water', 'screen_damaged', 'other_fault'];
    var costLabelEl = document.querySelector('#cdmc-ti-repair-cost .cdmc__ti-repair-cost-label');
    var fromLabelEl = $('cdmc-repair-from-label');
    if (costLabelEl) costLabelEl.textContent = '🔧 Repair all faults instead';
    if (fromLabelEl) fromLabelEl.textContent = 'Repair from';
    if (S.faults.length > 0) {
      var priced = S.faults.filter(function(f){ return f && f !== 'none' && DIAG_ONLY.indexOf(f) === -1; });
      var hasDiag = S.faults.some(function(f){ return DIAG_ONLY.indexOf(f) !== -1; });
      var repairTotal = computeRepairTotalForFaults(priced);
      var hasFaceId = S.faults.indexOf('face_id') !== -1;
      var hasManualFaults = hasFaceId || hasDiag;
      if (repairTotal > 0 || hasDiag) {
        var repairLabel;
        if (repairTotal > 0) {
          repairLabel = '£' + repairTotal + (priced.length > 1 ? ' (bundle)' : '');
          if (hasDiag) repairLabel += ' + £' + DIAG_FEE + ' diagnostic';
        } else {
          repairLabel = '£' + DIAG_FEE + ' check, then the repair is quoted';
          if (costLabelEl) costLabelEl.textContent = '🔧 Get it diagnosed instead';
          if (fromLabelEl) fromLabelEl.textContent = 'Diagnostic';
        }
        if (hasFaceId) repairLabel += ' + contact us for Face ID';
        $('cdmc-ti-repair-cost-price').textContent = repairLabel;
        show($('cdmc-ti-repair-cost'));
        // The upsell row already says "Diagnostic" in its own label when there is nothing else to repair.
        $('cdmc-repair-upsell-price').textContent = repairTotal > 0 ? repairLabel
          : ('£' + DIAG_FEE + ', then the repair is quoted' + (hasFaceId ? ' + contact us for Face ID' : ''));
        show($('cdmc-repair-price-row'));
        show($('cdmc-repair-upsell'));
      } else if (hasManualFaults) {
        $('cdmc-ti-repair-cost-price').textContent = 'Contact us for a quote';
        show($('cdmc-ti-repair-cost'));
        $('cdmc-repair-upsell-price').textContent = 'Contact us for a quote';
        show($('cdmc-repair-price-row'));
        show($('cdmc-repair-upsell'));
      } else {
        hide($('cdmc-ti-repair-cost'));
        hide($('cdmc-repair-price-row'));
        hide($('cdmc-repair-upsell'));
      }
    } else {
      hide($('cdmc-ti-repair-cost'));
      hide($('cdmc-repair-upsell'));
    }
  }

  // D-20260911-d — the free-recycling outcome. No cash figure, no credit, no "we'll quote you personally", and no
  // bank-transfer or prepaid-label promise: the customer sends the enquiry and Dan confirms how to send it in.
  // #cdmc-t-cash still carries the outcome as TEXT because the WhatsApp message, the Formspree summary, the ops
  // lead and the Klaviyo event all read it (none of them finds a number in it).
  function setRecycleView(on) {
    var rc = $('cdmc-t-recycle');
    if (rc) rc.classList.toggle('cd-hidden', !on);
    ['cdmc-t-price-wrap', 'cdmc-t-readout', 'cdmc-t-est-note', 'cdmc-t-accuracy'].forEach(function(id){
      var el = $(id);
      if (el) el.classList.toggle('cd-hidden', on);
    });
  }
  // D-20260915-n rule 1 — reported lost or stolen. No figure, no parts price, no repair offer, no payment or postage
  // promise. #cdmc-t-cash carries the refusal as TEXT for the same reason the recycle outcome does: the WhatsApp message,
  // the summary and the ops lead read it, and none of them finds a number in it (quoted_price stays null).
  var STOLEN_LABEL = 'We can\'t buy it: reported lost or stolen';
  function _renderStolenResult(v) {
    var isSell = (S.intent === 'sell');
    $('cdmc-t-intent-label').textContent = STOLEN_LABEL;
    $('cdmc-t-cash').textContent = STOLEN_LABEL;
    $('cdmc-t-upg').textContent = STOLEN_LABEL;
    ['cdmc-upsell-hero', 'cdmc-t-upg-col', 'cdmc-t-lockwarn', 'cdmc-t-blacklist-warn', 'cdmc-t-untestable', 'cdmc-upgrade-picker',
     'cdmc-t-readout', 'cdmc-t-est-note', 'cdmc-t-accuracy', 'cdmc-ti-repair-cost', 'cdmc-repair-upsell',
     'cdmc-ti-upgrade-compare'].forEach(function(id){ hide($(id)); });   // FSA-014: and the repair comparison an earlier result may have shown
    show($('cdmc-t-stolen-warn'));
    // FSA-014 (full audit, 2026-09-22): the refusal is the END of this quote, as it is on the buying form. The screen used
    // to keep the details form, a WhatsApp button and summary rows promising payment within 24 hours and a free label,
    // which read as "carry on". Now the details form (and with it the summary, the contact fields and the button) is
    // hidden, and the refusal box offers only a new quote once the report is cleared.
    hide($('cdmc-t-details'));
    renderValuationBreakdown(true);
    renderTradeinSummary(v && v.recycle ? null : v, isSell);
  }
  function _renderRecycleResult(v) {
    var isSell = (S.intent === 'sell');
    $('cdmc-t-intent-label').textContent = RECYCLE_LABEL;
    $('cdmc-t-cash').textContent = RECYCLE_LABEL;
    $('cdmc-t-upg').textContent = RECYCLE_LABEL;
    ['cdmc-upsell-hero', 'cdmc-t-upg-col', 'cdmc-t-lockwarn', 'cdmc-t-blacklist-warn', 'cdmc-upgrade-picker'].forEach(function(id){ hide($(id)); });
    renderRepairAlternative();
    var submitLbl = $('cdmc-t-submit-label');
    if (submitLbl) submitLbl.textContent = 'ARRANGE FREE RECYCLING ON WHATSAPP';
    renderValuationBreakdown(true);
    renderTradeinSummary(v, isSell);
  }

  function computeRepairTotalForFaults(faults) {
    if (!faults || faults.length === 0) return 0;
    var DIAG_FAULTS = ['wont_turn_on', 'water', 'screen_damaged', 'other_fault'];
    var prices = [];
    var seen = {};
    faults.forEach(function(f) {
      if (f === 'none') return;
      if (DIAG_FAULTS.indexOf(f) !== -1) { prices.push(DIAG_FEE); return; }
      var key = FAULT_TO_REPAIR_KEY[f];
      if (!key) return;
      if (seen[key]) return;
      seen[key] = true;
      var p = priceFor(S.model, key, S.parts || 'third-party');
      if (p == null) p = priceFor(S.model, key, 'third-party');
      if (p == null) p = priceFor(S.model, key, null);
      if (p == null) return;
      prices.push(p);
    });
    if (!prices.length) return 0;
    prices.sort(function(a, b) { return b - a; });
    return prices.reduce(function(total, p, i) {
      return total + (i === 0 ? p : Math.round(p * (1 - BUNDLE_DISCOUNT)));
    }, 0);
  }

  function renderValuationBreakdown(suppress) {
    var box = $('cdmc-t-breakdown');
    if (!box) return;
    if (suppress || S.type !== 'iphone') { hide(box); return; }
    var base = compValueFor(S.model, 'good', [], true);
    var unlockedV = compValueFor(S.model, S.cond, S.faults, true);
    var allV = compValueFor(S.model, S.cond, S.faults);
    if (!base || !allV || !unlockedV || base.recycle || allV.recycle) { hide(box); return; }   // D-20260911-d: nothing to break down

    var BD_LABEL = {
      battery:'Battery replacement', screen_cracked:'Cracked screen', screen_damaged:'Screen replacement',
      back_glass:'Back glass', rear_camera:'Camera fault', camera_lens_damage:'Camera lens',
      charging:'Charging fault', speaker:'Speaker / mic', buttons:'Buttons',
      wont_turn_on:'Won’t turn on', water:'Water damage', face_id:'Face ID', other_fault:'Other fault'
    };

    var realFaults = S.faults.filter(function(f){ return f !== 'none'; });
    var hasReduction = realFaults.length > 0 && unlockedV.cashHi < base.cashHi;
    var networkCut = unlockedV.cashHi - allV.cashHi;
    // R-129 ST-44 — the breakdown is a RANGE all the way down, so its rows add up to the range it ends on. It showed the
    // working price as the top figure alone (£90) and one deduction (−£50), then a total of "£30 – £40": the £30 was
    // never explained, and the teaser above had said "Working condition worth £70 – £90". Each row now carries both ends.
    var cut = function (lo, hi) { lo = Math.max(0, lo); hi = Math.max(0, hi); return lo === hi ? '−£' + hi : '−£' + Math.min(lo, hi) + ' to £' + Math.max(lo, hi); };

    var rows = [];
    if (hasReduction || networkCut > 0) rows.push(['Clean &amp; fully working', moneyRange(base.cash, base.cashHi), '']);
    if (hasReduction) {
      var names = realFaults.map(function(f){ return BD_LABEL[f] || faultLabel(f); }).join(', ');
      // Top of the range against top of the range. This read `base.cashHi - allV.cash` while every live quote was
      // "£55 – £55"; once the range has a width (R-116) that would fold the range itself into the fault deduction.
      rows.push(['Faults &amp; damage (' + names + ')', cut(base.cash - unlockedV.cash, base.cashHi - unlockedV.cashHi), 'minus']);
    }
    if (networkCut > 0) rows.push(['Locked to a network (−10%)', cut(unlockedV.cash - allV.cash, networkCut), 'minus']);

    var html = rows.map(function(r){
      return '<div class="cdmc__bd-row' + (r[2] ? ' cdmc__bd-row--' + r[2] : '') + '">' +
        '<span>' + r[0] + '</span><span>' + r[1] + '</span></div>';
    }).join('');
    // r149 (Codex FSA-003) — A TRADE IN'S BREAKDOWN ENDS ON ITS CREDIT. It ended on "Your estimated offer" with the CASH range
    // for everyone, so a customer shown "£55 to £65 trade in credit" read a breakdown that arrived at £40 to £50 (switching
    // to a trade in redrew it unchanged). For a trade in the cash total is called what it is, and the credit follows it.
    var bdTrade = S.intent !== 'sell' && allV.upgrade && allV.upgHi;
    html += '<div class="cdmc__bd-row cdmc__bd-row--total"><span>' + (bdTrade ? 'Cash offer' : 'Your estimated offer') + '</span>' +
      '<span>' + moneyRange(allV.cash, allV.cashHi) + '</span></div>';
    if (bdTrade) html += '<div class="cdmc__bd-row cdmc__bd-row--total"><span>Your trade in credit</span>' +
      '<span>' + moneyRange(allV.upgrade, allV.upgHi) + '</span></div>';
    // r149 (Codex FSA-004, ST-27) — the same words as the "No surprises" box: what moves an offer within the range
    html += '<p class="cdmc__bd-foot">Your final price falls within this range: towards the top for the best of its grade, towards the bottom for more wear or a weaker battery' + (S.storage ? '' : ', and it depends on the storage size') + '. We confirm it when we check it.</p>';   // R-130 (SJ-04)

    var rowsEl = $('cdmc-t-breakdown-rows');
    if (rowsEl) rowsEl.innerHTML = html;
    show(box);
  }

  function renderTradeinSummary(v, isSell) {
    var sumEl = $('cdmc-t-summary');
    if (!sumEl) return;
    var rows = [
      ['📱','Device', S.model + (S.storage ? ' · ' + S.storage : '')],   // R-132 (SJ-04) — the storage they chose
      ['📊','Condition', (({likenew:'Like new', good:'Good', fair:'Fair, some wear', broken:'Has a fault or damage'})[S.cond] || S.cond)
        + (faultGradeWords() ? '; otherwise ' + faultGradeWords() : '')],   // r148 (CC-04)
      (v && v.recycle) ? ['♻️','Outcome', RECYCLE_LABEL + ', no cash offer']
        : ['💷','Offer', isSell ? ($('cdmc-t-cash').textContent + ' cash') : ('Cash ' + $('cdmc-t-cash').textContent + ' / Upgrade ' + $('cdmc-t-upg').textContent)]
    ];
    if (S.lock) rows.push(['🔐','Apple / Google account', S.lock === 'yes' ? 'Signed out' : 'Still signed in / not sure']);   // R-130 (SJ-06)
    if (S.carrier) rows.push(['📶','Network', S.carrier === 'yes' ? 'Unlocked' : 'Locked to network']);
    if (S.blacklist) rows.push(['⛔','Blacklist', ({ no: 'Clean', yes: 'Blocked by a network or insurer: parts quote', unsure: 'Not sure, we\'ll check the IMEI', stolen: 'Reported lost or stolen, so we can\'t buy it' })[S.blacklist] || S.blacklist]);
    if (S.faults.length > 0) {
      var fLabels = [];
      S.faults.filter(function(f){ return f !== 'none'; }).forEach(function(f){
        var lbl = faultLabel(f);
        if (fLabels.indexOf(lbl) === -1) fLabels.push(lbl);
      });
      if (fLabels.length) rows.push(['📝','Faults', fLabels.join(', ')]);
    }
    if (S.blacklist === 'stolen') {
      // FSA-014: a refused phone has no next step, payment or postage (the summary is hidden with the form, but a
      // summary that promised them must not exist to be shown either)
    } else if (v && v.recycle) {
      rows.push(['📦','Next step', 'We\'ll send you a free Tracked 48 label']);   // no payment; a FREE Tracked 48 label (D-20260913-a reverses D-20260911-d's no-label half)
    } else if (S.intent === 'upgrade') {
      var flowLabel = S.tradeFlow === 'buy-first'
        ? 'Buy replacement first, then send old phone'
        : S.tradeFlow === 'send-first'
        ? 'Send old phone first, then buy replacement'
        : 'You choose on your buying form';   // R-130 (SJ-45) — the form asks buy-first or send-first
      rows.push(['🔄','How it works', flowLabel]);
    } else {
      // v512 (AUDIT A-09) — ONE PAYMENT PROMISE, NOT TWO. This row said "same-day on arrival" while
      // the status block directly above it, and the Sell card two screens back, both say "usually
      // within 24 hours". Two different promises about money, visible at the same time, on the
      // screen where the customer decides whether to trust us. The cautious one wins: it is the one
      // already said twice elsewhere, and it is the one that cannot be broken by a late post round.
      rows.push(['💳','Payment', 'Bank transfer, usually within 24 hours']);
      rows.push(['📦','Postage', reportedDamagedBattery() ? 'Damaged battery: message us before posting' : 'Free prepaid label']);   // WEB-045; WEB-039
    }
    sumEl.innerHTML = '<span class="cdmc__sum-title">SUMMARY</span>' +
      rows.map(function(r){
        return '<div class="cdmc__sum-row"><span class="cdmc__sum-icon">' + r[0] + '</span>' +
          '<span class="cdmc__sum-label">' + escHTML(r[1]) + '</span>' +
          '<span class="cdmc__sum-val">' + escHTML(r[2]) + '</span></div>';
      }).join('');
  }

  var _upgradeCache = null;

  // r170 (CXR1012-06, Codex 12 Oct) — A FAILED STOCK READ IS NOT AN EMPTY STOCK. A non OK answer became { products: [] } and
  // was cached as the real stock, so the phones in stock stayed hidden for the rest of the visit once the service was back.
  // A failed read now answers "none" for the screen asking, uncached, and the next screen to ask reads again.
  function fetchUpgradeOptions() {
    if (_upgradeCache) return Promise.resolve(_upgradeCache);
    return fetch('/collections/in-stock/products.json?limit=250')
      .then(function(r){ if (!r.ok) throw new Error('stock read ' + r.status); return r.json(); })
      .then(function(d){
        var prods = (d.products || []).filter(function(p){
          return (p.variants || []).some(function(v){ return v.available !== false; });
        });
        var mapped = prods.map(function(p){
          var availVars = (p.variants || []).filter(function(v){ return v.available !== false; });
          var v = availVars.length ? availVars.reduce(function(a,b){ return parseFloat(a.price)<parseFloat(b.price)?a:b; }) : p.variants[0] || {};
          // Keep the original listing title for matching and enquiries; split only its display.
          var titleParts = String(p.title || '').split(/\s+(?=\d+\s*(?:GB|TB)\b)/i);
          var hasDetails = titleParts.length > 1;
          var displayTitle = hasDetails ? titleParts.shift() : String(p.title || '');
          var details = hasDetails ? titleParts.join(' ').replace(/\bRefurbished\b/gi, '').split(/\s*,\s*/).filter(Boolean).join(' · ').trim() : '';
          return {
            displayTitle: displayTitle,
            details: details,
            title: p.title,
            price: Math.round(parseFloat(v.price || '0')),
            url: '/products/' + p.handle,
            image: (p.images && p.images[0]) ? p.images[0].src : '',
            handle: p.handle
          };
        });
        mapped.sort(function(a, b){ return a.price - b.price; });
        _upgradeCache = { all: mapped, budget: mapped[0] || null, premium: mapped[mapped.length - 1] || null };
        return _upgradeCache;
      })
      .catch(function(){ return { all: [], budget: null, premium: null }; });
  }

  var GEN_ORDER = [
    'iPhone 7','iPhone 7 Plus','iPhone 8','iPhone 8 Plus',
    'iPhone X','iPhone XR','iPhone XS','iPhone XS Max',
    'iPhone 11','iPhone 11 Pro','iPhone 11 Pro Max',
    'iPhone SE (2nd gen)',
    'iPhone 12 mini','iPhone 12','iPhone 12 Pro','iPhone 12 Pro Max',
    'iPhone 13 mini','iPhone 13','iPhone 13 Pro','iPhone 13 Pro Max',
    'iPhone SE (3rd gen)',
    'iPhone 14','iPhone 14 Plus','iPhone 14 Pro','iPhone 14 Pro Max',
    'iPhone 15','iPhone 15 Plus','iPhone 15 Pro','iPhone 15 Pro Max',
    'iPhone 16','iPhone 16 Plus','iPhone 16 Pro','iPhone 16 Pro Max',
    'iPhone 17e','iPhone 17','iPhone Air','iPhone 17 Pro','iPhone 17 Pro Max'   // r150 (FSA-006)
  ];

  function _genTier(title) {
    var best = -1;
    var bestLen = 0;
    GEN_ORDER.forEach(function(g, i){
      if (title.indexOf(g) !== -1 && g.length > bestLen) {
        best = i;
        bestLen = g.length;
      }
    });
    return best;
  }

  function _genNum(tier) {
    if (tier < 0) return -1;
    var g = GEN_ORDER[tier];
    if (g === 'iPhone SE (2nd gen)') return 11;
    if (g === 'iPhone SE (3rd gen)') return 13;
    if (g === 'iPhone Air') return 17;   // r150: Apple's Air carries no number; it is the 17 generation
    var m = g.match(/iPhone (\d+)/);
    return m ? parseInt(m[1]) : -1;
  }

  function loadUpgradePicker() {
    var listEl = $('cdmc-upgrade-picker-list');
    if (!listEl) return;
    function appendChoice(p, credit, frameClass) {
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'cdmc__upgrade-picker-item ' + frameClass;
      item.setAttribute('data-handle', p.handle);
      item.setAttribute('data-action', 'choose-upgrade');
      item.setAttribute('aria-pressed', S.chosenUpgrade && S.chosenUpgrade.handle === p.handle ? 'true' : 'false');
      if (S.chosenUpgrade && S.chosenUpgrade.handle === p.handle) item.classList.add('selected');
      var price = credit > 0 ? 'You pay £' + Math.max(0, p.price - credit) : '£' + p.price;
      item.innerHTML =
        (p.image ? '<img class="cdmc__upgrade-picker-item-img" src="' + escHTML(p.image) + '" alt="" width="56" height="64" loading="lazy">' : '<span class="cdmc__upgrade-picker-item-img-placeholder" aria-hidden="true">📱</span>') +
        '<span class="cdmc__upgrade-picker-item-meta">' +
          '<span class="cdmc__upgrade-picker-item-name">' + escHTML(p.displayTitle || p.title) + '</span>' +
          (p.details ? '<span class="cdmc__upgrade-device-facts">' + escHTML(p.details) + '</span>' : '') +
          '<span class="cdmc__upgrade-picker-youpay">' + price + '</span>' +
          (credit > 0 ? '<span class="cdmc__upgrade-picker-credit">£' + p.price + ' before trade in · after £' + credit + ' trade in credit</span>' : '') +
        '</span><span class="cdmc__upgrade-picker-item-check" aria-hidden="true">✓</span>';
      listEl.appendChild(item);
    }
    var isIphone  = S.type === 'iphone';
    var isIpad    = S.type === 'ipad';
    var isSamsung = S.type === 'samsung';
    var isGoogle  = S.type === 'google';
    if (!isIphone) {
      listEl.innerHTML = '<div class="cdmc__upgrade-picker-loading">Loading available stock…</div>';
      fetchUpgradeOptions().then(function(opts) {
        var all = opts.all || [];
        function matchType(title, keywords) {
          var t = title.toLowerCase();
          return keywords.some(function(k){ return t.indexOf(k) !== -1; });
        }
        var samsungItems = all.filter(function(p){ return matchType(p.title, ['samsung','galaxy']); });
        var googleItems  = all.filter(function(p){ return matchType(p.title, ['pixel','google']); });
        var ipadItems    = all.filter(function(p){ return matchType(p.title, ['ipad']); });
        var iphoneItems  = all.filter(function(p){ return matchType(p.title, ['iphone']); });
        var ordered;
        var headerMsg;
        if (isIpad) {
          ordered = ipadItems.concat(iphoneItems);
          headerMsg = 'We have iPads and refurbished iPhones in stock, or we can source what you\'re looking for.';
        } else if (isSamsung) {
          ordered = samsungItems.concat(googleItems).concat(iphoneItems);
          headerMsg = 'We stock Samsung, Google Pixel and refurbished iPhones, and switching to iPhone is always an option too.';
        } else if (isGoogle) {
          ordered = googleItems.concat(samsungItems).concat(iphoneItems);
          headerMsg = 'We stock Google Pixel, Samsung and refurbished iPhones, and switching to iPhone is always worth considering.';
        } else {
          ordered = all;
          headerMsg = 'Browse what\'s in stock and we\'ll match you with the best option.';
        }
        if (!ordered.length) {
          listEl.innerHTML = '<div class="cdmc__upgrade-picker-loading">No stock right now. Message us and we\'ll find the right device for you.</div>';
          return;
        }
        listEl.innerHTML = '<p style="font-size:0.75rem;color:rgba(255,255,255,0.45);margin-bottom:0.75rem;line-height:1.5">' + escHTML(headerMsg) + '</p>';
        ordered.forEach(function(p) { appendChoice(p, 0, ''); });
      });
      return;
    }
    listEl.innerHTML = '<div class="cdmc__upgrade-picker-loading">Loading available phones…</div>';
    fetchUpgradeOptions().then(function(opts){
      if (!opts.all || opts.all.length === 0) {
        listEl.innerHTML = '<div class="cdmc__upgrade-picker-loading">No stock right now. We\'ll check what\'s coming in when you message.</div>';
        return;
      }
      // r148 (CC-13): the headline's answer, never a figure the headline withheld (D-20260911-d's recycling included)
      var tiV = autoTradeinValue(S.cond, S.faults);
      var credit = tiV ? (tiV.upgrade || 0) : 0;
      var currentTier = _genTier(S.model);
      var currentGen  = _genNum(currentTier);
      var scored = opts.all.map(function(p) {
        var tier    = _genTier(p.title);
        var gen     = _genNum(tier);
        var genDiff = gen - currentGen;
        var isPro   = p.title.indexOf('Pro') !== -1;
        var isProMax = p.title.indexOf('Pro Max') !== -1;
        var cat;
        if (genDiff >= 1)      cat = 0;
        else if (genDiff === 0) cat = 1;
        else                    cat = 2;
        var sortScore = 0;
        if (cat === 0) {
          sortScore = genDiff * 100 + (isProMax ? 0 : isPro ? 10 : 20) + (p.price / 1000);
        } else if (cat === 1) {
          sortScore = p.price;
        } else {
          sortScore = p.price;
        }
        return { p: p, tier: tier, gen: gen, genDiff: genDiff, isPro: isPro, isProMax: isProMax, cat: cat, sortScore: sortScore };
      });
      scored.sort(function(a, b) {
        if (a.cat !== b.cat) return a.cat - b.cat;
        return a.sortScore - b.sortScore;
      });
      // R-129 ST-46 (Dan, 2026-09-22: "no older phones") — an UPGRADE is the same generation or newer. It showed up to
      // three generations older ("iPhone 11 · 1 gen older" for an iPhone 12), which is a trade-down, not a trade-in.
      var visible = scored.filter(function(s){ return s.genDiff >= 0; }).slice(0, 12);
      if (!visible.length) {
        listEl.innerHTML = '<div class="cdmc__upgrade-picker-loading">No newer phones in stock right now. Carry on and we\'ll tell you what\'s coming in.</div>';
        return;
      }
      listEl.innerHTML = credit > 0 ? ''
        : '<p class="cdmc__upgrade-picker-loading" style="margin-bottom:0.75rem">Your trade in credit comes off the price once we have checked your phone.</p>';
      visible.forEach(function(s) {
        var p = s.p;
        var frameLabel, frameClass;
        if (s.genDiff >= 1) {
          frameLabel = s.genDiff <= 3 ? 'Upgrade · ' + s.genDiff + ' gen' + (s.genDiff > 1 ? 's' : '') + ' newer' : 'Newer device';
          frameClass = 'cdmc__upgrade-picker-item--upgrade';
        } else if (s.genDiff === 0) {
          frameLabel = 'Same generation';
          frameClass = 'cdmc__upgrade-picker-item--same';
        } else if (s.genDiff === -1) {
          frameLabel = '1 gen older';
          frameClass = '';
        } else {
          frameLabel = 'Older device';
          frameClass = '';
        }
        appendChoice(p, credit, frameClass);
      });
      if (!visible.length) {
        listEl.innerHTML = '<div class="cdmc__upgrade-picker-loading">No matching stock right now. We\'ll email you some options.</div>';
      }
    });
  }

  function validateContact(prefix) {
    var nameEl     = $(prefix + '-name');
    var phoneEl    = $(prefix + '-phone');
    var emailEl    = $(prefix + '-email');
    var termsEl    = $(prefix + '-terms');
    var errEl      = $(prefix + '-err');
    var name  = (nameEl  || {}).value || '';
    var phone = (phoneEl || {}).value || '';
    var email = (emailEl || {}).value || '';
    var terms = (termsEl || {}).checked;
    if (!name.trim()) {
      if (errEl) { errEl.textContent = 'Please enter your name.'; show(errEl); }
      if (nameEl) nameEl.focus();
      return null;
    }
    // r149 (FSA-048) — a whole UK number: a mobile is 07 and nine more, any other 0 number nine or ten more (a few
    // landlines are ten digits), and the same after 44 (a +44 with its 0 kept, or a 0044, reads the same). It took any
    // 10 to 13 digits, so a number cut short still passed.
    var phoneDigits = phone.replace(/\D/g, '').replace(/^00/, '').replace(/^440/, '44').replace(/^44/, '0');
    var phoneValid = /^07\d{9}$/.test(phoneDigits) || /^0[1235689]\d{8,9}$/.test(phoneDigits);
    if (!phone.trim()) {
      if (errEl) { errEl.textContent = 'Please enter your phone number.'; show(errEl); }
      if (phoneEl) phoneEl.focus();
      return null;
    }
    if (!phoneValid) {
      if (errEl) { errEl.textContent = 'Please enter a valid UK phone number (e.g. 07700 900000).'; show(errEl); }
      if (phoneEl) phoneEl.focus();
      return null;
    }
    // v513 (D-20260921-b) — on the sell / trade-in form the email is REQUIRED: it is where the buying-form link
    // goes, and without it the customer has no way to reach the next step.
    // R-131 stage 1 (R-129 ST-29) — a repair's email is required too: the repair form goes there (D-20260922-d).
    // D-20260923-j: and an "other device" repair (cdmc-other), which now goes through the same repair form.
    if ((prefix === 'cdmc-t' || prefix === 'cdmc-r' || prefix === 'cdmc-other') && !email.trim()) {
      if (errEl) { errEl.textContent = prefix !== 'cdmc-t' ? 'Please enter your email. We send your repair form there.' : 'Please enter your email. We send your form link there.'; show(errEl); }
      if (emailEl) emailEl.focus();
      return null;
    }
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (errEl) { errEl.textContent = 'Please enter a valid email address.'; show(errEl); }
      if (emailEl) emailEl.focus();
      return null;
    }
    if (!terms) {
      if (errEl) { errEl.textContent = 'Please agree to the terms & conditions.'; show(errEl); }
      return null;
    }
    var startEl = $(prefix + '-start'); // repair flow only (CCRs 2013 reg 36 express request); absent on trade-in
    if (startEl && !startEl.checked) {
      if (errEl) { errEl.textContent = 'Please tick the box asking us to start your repair straight away.'; show(errEl); }
      return null;
    }
    hide(errEl);
    return {
      name: name.trim(),
      phone: phone.trim(),
      email: email.trim(),
      marketing: !!($(prefix + '-marketing') || {}).checked
    };
  }

  function repairSubmit() {
    var c = validateContact('cdmc-r');
    if (!c) return;
    var summary = buildRepairWAMessage(c);
    finishAndOpenWA(c, summary, 'repair');
  }

  function buildRepairWAMessage(c) {
    var repairLabel = ($('cdmc-r-repair') || {}).textContent || 'see below';
    var priceEl = $('cdmc-r-price');
    var fromEl = $('cdmc-r-from');
    var priceStr = priceEl ? (fromEl ? fromEl.textContent + ' ' : '') + priceEl.textContent : 'TBC';
    var lines = [
      'Hi Cell Devices,',
      '',
      '🔧 REPAIR ENQUIRY',
      '──────────────────',
      '📱 Device:   ' + S.model + (S.storage ? ' · ' + S.storage : ''),
      '🔧 Repair:   ' + repairLabel,
      '💷 Estimate: ' + priceStr,
      '📈 Pricing:  ' + PRICING_VERSION
    ];
    if (livePricingNote('repair', S.model)) lines.push('📈 ' + livePricingNote('repair', S.model));   // r163 (PDX-04)
    if (S.parts) {
      var wpl = S.parts === 'genuine' ? 'Genuine Apple' : (S.parts === 'oled' ? 'Aftermarket OLED' : (S.parts === 'lcd' ? 'LCD' : 'Third party (premium)'));
      lines.push('🧩 Parts:    ' + wpl);
    }
    if (S.battHealth) {
      var bhLabels = {good:'90 to 100%, good', degraded:'80 to 89%, degraded', low:'Below 80%, flagged', unknown:'Not checked'};
      lines.push('🔋 Battery:  ' + (bhLabels[S.battHealth] || S.battHealth));
    }
    var allSyms = [];
    liveSymptoms().forEach(function(sym){   // r170 (CXH1012-06): only what a chosen fault or the repair still asks for
      var lbl = SYMPTOM_LABELS[sym];
      if (lbl && allSyms.indexOf(lbl) === -1) allSyms.push(lbl);
    });
    if (allSyms.length) {
      lines.push('');
      lines.push('📋 Symptoms reported:');
      allSyms.forEach(function(l){ lines.push('   • ' + l); });
    }
    var primaryTags = primaryFaultKeysFor(S.repair);
    var extras = S.faults.filter(function(f){ return f !== 'none' && primaryTags.indexOf(f) === -1; });
    if (extras.length) {
      lines.push('');
      lines.push('⚠️  Additional faults flagged:');
      extras.forEach(function(f){ lines.push('   • ' + faultLabel(f)); });
    }
    var otherText = otherFaultText('repair');   // r152 (FSA-105): only while "Other fault" is ticked
    if (otherText) {
      lines.push('');
      lines.push('📝 Other notes: ' + otherText);
    }
    // r152 (app v779; Codex FSA-103): no "Please start work as soon as my device arrives" here. The customer never asked it on
    // this screen; they agree to a start with Accept on the repair form's price (ST-13), and only then.
    lines.push('');
    lines.push('──────────────────');
    lines.push('✅ I agree to the Terms & Conditions at celldevices.co.uk/policies/terms-of-service');
    lines.push('👤 Name:  ' + c.name);
    lines.push('📞 Phone: ' + c.phone);
    if (c.email) lines.push('📧 Email: ' + c.email);
    return lines.join('\n');
  }

  function tradeinSubmit() {
    var c = validateContact('cdmc-t');
    if (!c) return;
    var summary = buildTradeinWAMessage(c);
    finishAndOpenWA(c, summary, S.intent === 'sell' ? 'sell' : 'tradein');
  }

  function buildTradeinWAMessage(c) {
    var isSell = (S.intent === 'sell');
    var isUpgrade = (S.intent === 'upgrade');
    var isRecycle = isRecycleOnly(S.model);   // D-20260911-d: Dan is told it is free recycling, never handed a £ figure
    var cashStr = ($('cdmc-t-cash') || {}).textContent || 'TBC';
    var upgStr  = ($('cdmc-t-upg')  || {}).textContent || 'TBC';
    var condLabels = {likenew:'Like new', good:'Good', fair:'Fair, some wear', broken:'Has a fault or damage'};
    var lines = [
      'Hi Cell Devices,',
      '',
      isRecycle ? '♻️ FREE RECYCLING ENQUIRY' : isSell ? '💰 SELL ENQUIRY' : isUpgrade ? '🔄 TRADE IN / UPGRADE ENQUIRY' : '🔄 TRADE IN ENQUIRY',
      '──────────────────',
      '📱 Device:    ' + S.model + (S.storage ? ' · ' + S.storage : ''),
      '📊 Condition: ' + (condLabels[S.cond] || S.cond) + (faultGradeWords() ? '; otherwise ' + faultGradeWords() : ''),   // r148 (CC-04)
      isRecycle ? '♻️ Outcome:   Free recycling, no cash offer' : '💷 Estimate:  ' + (isSell ? cashStr + ' cash' : 'Cash ' + cashStr + ' / Upgrade ' + upgStr),
      '📈 Pricing:   ' + PRICING_VERSION
    ];
    if (livePricingNote('sell', S.model)) lines.push('📈 ' + livePricingNote('sell', S.model));   // r163 (PDX-04)
    if (isRecycle && isUpgrade) lines.push('📦 Also after: one of your refurbished phones');
    if (S.lock) lines.push('🔒 iCloud:    ' + (S.lock === 'yes' ? 'Unlocked / signed out' : 'Locked / not sure'));
    if (S.carrier) lines.push('📶 Network:   ' + (S.carrier === 'yes' ? 'Unlocked (any network)' : 'Locked to a network'));
    if (S.blacklist) lines.push(({
      no: '✅ Blacklist:  Clean',
      yes: '📵 BLOCKED by a network / insurer, parts only, quote directly, do NOT auto price',
      unsure: '❓ Blacklist:  Not sure, check the IMEI before pricing',
      stolen: '⛔ REPORTED LOST OR STOLEN, cannot buy (D-20260915-n rule 1)'
    })[S.blacklist] || ('Blacklist: ' + S.blacklist));
    if (S.battHealth) {
      var bhL = {good:'90 to 100%, good', degraded:'80 to 89%, degraded', low:'Below 80%, flagged', unknown:'Not checked'};
      lines.push('🔋 Battery:   ' + (bhL[S.battHealth] || S.battHealth));
    }
    var allSyms = [];
    liveSymptoms().forEach(function(sym){   // r170 (CXH1012-06): only what a fault still chosen asks for
      var lbl = SYMPTOM_LABELS[sym];
      if (lbl && allSyms.indexOf(lbl) === -1) allSyms.push(lbl);
    });
    if (allSyms.length) {
      lines.push('');
      lines.push('📋 Symptom detail:');
      allSyms.forEach(function(l){ lines.push('   • ' + l); });
    }
    var extras = S.faults.filter(function(f){ return f !== 'none'; });
    if (extras.length) {
      lines.push('');
      lines.push('⚠️  Faults:');
      extras.forEach(function(f){ lines.push('   • ' + faultLabel(f)); });
    }
    var otherTextTi = otherFaultText('tradein');   // r152 (FSA-105): only while "Other fault" is ticked
    if (otherTextTi) {
      lines.push('');
      lines.push('📝 Other notes: ' + otherTextTi);
    }
    if (isUpgrade && S.chosenUpgrade) {
      lines.push('');
      lines.push('📦 Upgrade to: ' + S.chosenUpgrade.title + ' (£' + S.chosenUpgrade.price + ')');
    }
    if (isUpgrade && S.tradeFlow) {
      lines.push('🔁 Flow: ' + (S.tradeFlow === 'buy-first'
        ? 'Buy first: send your old phone when the new one arrives'
        : 'Send your phone first: buy once we have checked it'));
    }
    lines.push('');
    lines.push('──────────────────');
    lines.push('✅ I agree to the Terms & Conditions at celldevices.co.uk/policies/terms-of-service');
    lines.push('👤 Name:  ' + c.name);
    lines.push('📞 Phone: ' + c.phone);
    if (c.email) lines.push('📧 Email: ' + c.email);
    return lines.join('\n');
  }

  /* ── Ops app auto-intake ─────────────────────────────────────────────
     Mirrors the lead into the Cell Devices ops app (cd-ops worker). Everything here is
     fire-and-forget: every error is swallowed, nothing awaits, and the customer's
     WhatsApp handoff is 100% unaffected if the ops endpoint is down. Contact details are
     included ONLY when the customer ticked the marketing/consent box (same gate as the
     Klaviyo subscribe); the server enforces the same rule again. */
  function opsNewIdemKey() {
    try {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    } catch (e) {}
    return 'k-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function opsFetchToken() {
    try {
      if (_opsToken && Date.now() < _opsTokenExp) return Promise.resolve();
      return fetch(OPS_INTAKE_URL + '/token').then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.ok && d.token) {
          _opsToken = d.token;
          _opsTokenExp = Date.now() + 9 * 60 * 1000; // refresh a minute before the 10-min expiry
        }
      }).catch(function () {});
    } catch (e) { return Promise.resolve(); }
  }

  // r152 (app v780; Codex FSA-104, FSA-105) — THE TYPED "OTHER FAULT" GOES WHEREVER THE FAULT GOES, AND ONLY WHILE IT IS TICKED.
  // The words reached the WhatsApp and Formspree summaries only, never the lead (so never the repair form's fault box), and
  // a box hidden by unticking "Other fault" was still read by the summaries. One reader now, for every place that sends it.
  function otherFaultText(path) {
    if (S.faults.indexOf('other_fault') === -1) return '';
    var el = $(path === 'tradein' ? 'cdmc-t2-other-text' : 'cdmc-r3-other-text');
    return el ? String(el.value || '').trim().slice(0, 300) : '';
  }

  function opsBuildLead(contact, kind) {
    // D-20260923-j: an "other device" repair has no model from the list, no price and no answers from the other screens,
    // so only what the customer typed goes with it (never a figure or a fault left over from an earlier path).
    if (S.type === 'other') return opsBuildOtherLead(contact, kind);   // r152 (FSA-013): a sale too
    var type = kind === 'repair' ? 'repair'
      : (kind === 'sell' ? 'sell' : (S.intent === 'upgrade' ? 'upgrade' : 'tradein'));
    var estEl = kind === 'repair' ? $('cdmc-r-price') : $('cdmc-t-cash');
    // Trade-in offers render as a range ("£65 – £105") — take the FIRST number (low bound).
    var estimate = parseFloat(((((estEl && estEl.textContent) || '').match(/[\d.]+/)) || [''])[0]);
    var faults = [];
    liveSymptoms().forEach(function (sym) {   // r170 (CXH1012-06): a withdrawn fault's symptoms stay off the enquiry
      var lbl = SYMPTOM_LABELS[sym];
      if (lbl && faults.indexOf(lbl) === -1) faults.push(lbl);
    });
    S.faults.forEach(function (f) {
      if (f === 'none') return;
      var typed = f === 'other_fault' ? otherFaultText(kind === 'repair' ? 'repair' : 'tradein') : '';   // r152 (FSA-104)
      var lbl = typed ? faultLabel(f) + ': ' + typed : faultLabel(f);
      if (lbl && faults.indexOf(lbl) === -1) faults.push(lbl);
    });
    var notes = [];
    if (kind === 'repair') {
      var repairLabel = ($('cdmc-r-repair') || {}).textContent || '';
      if (repairLabel) notes.push('Repair: ' + repairLabel);
      if (S.parts) notes.push('Parts: ' + S.parts);
    } else {
      if (S.lock) notes.push('iCloud signed out: ' + S.lock);
      if (S.carrier) notes.push('Network unlocked: ' + S.carrier);
      // v459: this read "Blacklist clean: " + S.blacklist — and S.blacklist 'yes' meant BLACKLISTED, so a blocked
      // phone was written up as "Blacklist clean: yes" and a clean one as "Blacklist clean: no".
      if (S.blacklist) notes.push('Blacklist: ' + (({ no: 'clean', yes: 'blocked by network/insurer', unsure: 'not sure', stolen: 'REPORTED LOST OR STOLEN' })[S.blacklist] || S.blacklist));
      // v512 (AUDIT A-08) — RECORD THE RANGE THE CUSTOMER WAS ACTUALLY SHOWN.
      // `quoted_price` above takes the FIRST number in "£35 – £40", by design: the low bound is the
      // safe one to store. But the customer read a RANGE, and whoever opens this lead sees only the
      // bottom of it — so an offer of £35 against a remembered £40 becomes a "not as described"
      // moment in a business whose whole pitch is that there are none. The full text costs nothing
      // and removes the gap between what was promised and what the operator sees.
      var shownCash = (($('cdmc-t-cash') || {}).textContent || '').trim();
      // R-129 ST-07 — a TRADE-IN customer read the trade-in credit, and the lead and the form email said only the cash
      // range ("Your estimate £40 – £50" to someone shown £55 – £65 credit). The credit goes first; the app's
      // quoteFromLead takes the top figure as the one "we never pay less than quoted" is measured against.
      var shownUpg = (($('cdmc-t-upg') || {}).textContent || '').trim();
      var shownLine = kind !== 'sell' && /\d/.test(shownUpg) ? shownUpg + ' trade in credit (or ' + shownCash + ' cash)' : shownCash;
      if (shownCash && /\d/.test(shownCash)) notes.push('Customer was shown: ' + shownLine);
      if (S.quoteUntestable) notes.push('UNTESTABLE (no display), ' + shownCash);
      if (S.intent === 'upgrade' && S.chosenUpgrade) notes.push('Upgrade to: ' + S.chosenUpgrade.title);
      if (faultGradeWords()) notes.push('Looks apart from the faults: ' + faultGradeWords());   // r148 (CC-04)
      if (isRecycleOnly(S.model)) notes.push('FREE RECYCLING, no cash offer (D-20260911-d)');
    }
    if (S.battHealth) notes.push('Battery: ' + S.battHealth);
    notes.push('Pricing: ' + PRICING_VERSION);
    var tableNote = livePricingNote(kind, S.model);   // r163 (PDX-04): its own note, so "Pricing: <version>" still reads alone
    if (tableNote) notes.push(tableNote);
    var payload = {
      type: type,
      model: S.model || '',
      storage: S.storage || '',
      condition: S.cond || '',
      faults: faults.join(', '),
      // v434 — the same answers as FIELDS, beside the prose. Until now `S.lock`, `S.carrier`,
      // `S.blacklist` and `S.battHealth` were joined into the `notes` string above and nothing
      // downstream could filter, sort, price or prefill from them — so the buying form asked the
      // seller the same three questions again two minutes later. `notes` is untouched: several
      // screens read it and the prose line is what Dan skims.
      // Sent as the calculator's OWN yes/no; the app maps to its vocabulary where it prefills.
      fault_keys: S.faults.filter(function (f) { return f && f !== 'none'; }).join(','),
      icloud_ok: S.lock || '',
      network_ok: S.carrier || '',
      // ⚠ v459 — THIS WAS INVERTED. It sent S.blacklist verbatim, but S.blacklist 'yes' was the "Yes / not sure"
      // (blacklisted) button while the app's contract (migration 097) reads blacklist_ok 'yes' as CLEAR — so a clean
      // phone arrived flagged "blacklist NOT clear" and a blacklisted one arrived clear (leads 7 and 9, corrected
      // 2026-09-15). Now blacklist_ok means what the column means, and blacklist_status carries the four-way answer;
      // its presence is also how the app tells this payload from the old inverted one.
      blacklist_ok: S.blacklist ? (S.blacklist === 'no' ? 'yes' : 'no') : '',
      blacklist_status: ({ no: 'clean', yes: 'blocked', unsure: 'unsure', stolen: 'stolen' })[S.blacklist] || '',
      battery_band: S.battHealth || '',
      // v520 (SJ-50) — a trade-in's "Buy first" / "Send first" choice, so the buying form can pre-select it
      // instead of asking again. Until now it reached only the WhatsApp text.
      trade_flow: kind === 'repair' || kind === 'sell' ? '' : (S.tradeFlow || ''),
      // An untestable quote's first number is the IF-WORKING low, not a promise (the promise is the £20 parts price),
      // and a stolen refusal has no number at all — neither may reach the lead as "the price we quoted".
      quoted_price: (kind !== 'repair' && (isRecycleOnly(S.model) || S.quoteUntestable || S.blacklist === 'stolen')) || isNaN(estimate) ? null : estimate,
      // First-touch attribution (2026-07-17): where this visitor's SESSION started —
      // 'ft:google/cpc/campaign' (UTM) | 'ref:google.com' | 'direct' — read from cd-beacon.js.
      // Defensive: without the beacon the lead still sends, attributed 'unknown' (r155, Codex FSA-116: it said 'direct',
      // and the lead then said "came direct" for a visit nobody could place).
      source: ('site-calculator:' + ((window.location && window.location.pathname) || '') +
        ' | ' + ((window.CDBeacon && window.CDBeacon.firstTouch && window.CDBeacon.firstTouch()) || 'unknown')).slice(0, 300),
      // ── SERVICE CONTACT AND MARKETING CONSENT ARE TWO DIFFERENT THINGS (2026-09-14) ───────────
      // `consent` keeps its original meaning — the "Keep me updated with deals & offers" tick —
      // because the LIVE worker still reads it that way, and this file and the app can be
      // published in either order. `marketing` says the same thing under the name the app now
      // prefers. Neither one gates the contact details any more.
      consent: !!contact.marketing,
      marketing: !!contact.marketing,
      notes: notes.join(' · ')
    };
    // ⚠ THE CUSTOMER'S DETAILS GO WITH THE LEAD, ALWAYS. They used to be attached only when the
    // MARKETING box was ticked, so somebody who just wanted a price arrived in the app as an
    // anonymous row Dan could not answer — measured 2026-09-14: 3 of 3 production leads had no
    // customer at all, which is why every enquiry was being handled by hand from WhatsApp and
    // Formspree. Answering the quote they asked for is a service step, not marketing; the tick
    // above is what decides whether they are ever SENT anything else.
    payload.name = contact.name;
    payload.phone = contact.phone;
    if (contact.email) payload.email = contact.email;
    return payload;
  }

  // D-20260923-j: the lead for a repair on a device the calculator does not list. Same shape and the same consent rules as
  // opsBuildLead; the model and the fault are exactly what they typed, and there is no quoted price (Dan prices it).
  function opsBuildOtherLead(contact, kind) {
    var sell = kind === 'sell';   // r152 (FSA-013): an unlisted phone to sell, priced by hand
    var payload = {
      type: sell ? 'sell' : 'repair',
      model: S.otherDevice || '',
      storage: '',
      condition: '',
      faults: S.otherFault || '',
      fault_keys: '',
      icloud_ok: '', network_ok: '', blacklist_ok: '', blacklist_status: '', battery_band: '', trade_flow: '',
      quoted_price: null,
      source: ('site-calculator:' + ((window.location && window.location.pathname) || '') +
        ' | ' + ((window.CDBeacon && window.CDBeacon.firstTouch && window.CDBeacon.firstTouch()) || 'unknown')).slice(0, 300),
      consent: !!contact.marketing,
      marketing: !!contact.marketing,
      notes: ['Other device (not on the quote tool): price by hand', (sell ? 'Condition: ' : 'Fault: ') + (S.otherFault || ''), 'Pricing: ' + PRICING_VERSION].join(' · ')
    };
    payload.name = contact.name;
    payload.phone = contact.phone;
    if (contact.email) payload.email = contact.email;
    return payload;
  }

  // r149 (Codex FSA-046, CC-81, DOR-09) — THE APP NEVER GOT IT, SO NO EMAIL IS COMING. The success screen says "Check your
  // email" as soon as the quote is sent, and the send is fire and forget: a network error, a refusal (401, 429, 500), a
  // failed token fetch or no token left that promise standing with nothing sent. Only while the screen still makes the
  // email promise (its WhatsApp button quiet), it now says what happened and makes WhatsApp the main button again.
  function leadNotSent() {
    var wa = $('cdmc-success-wa');
    if (!wa || !wa.classList.contains('cdmc__btn-wa--quiet')) return;
    wa.classList.remove('cdmc__btn-wa--quiet');
    var t = $('cdmc-success-title'); if (t) t.textContent = 'We couldn\'t send your form';
    var sub = $('cdmc-success-sub'); if (sub) sub.textContent = 'Your form link could not be sent just now, so no email is on its way. Tap below to message us on WhatsApp and we\'ll sort it for you.';
    var label = $('cdmc-success-wa-label'); if (label) label.textContent = 'Message us on WhatsApp →';
    var formBtn = $('cdmc-success-form'); if (formBtn) formBtn.classList.add('cd-hidden');
  }

  // r167 (Claude customer journey walk, app v977, CL1009-04) — THE APP HAS THE ENQUIRY, BUT NO FORM EMAIL WENT (a refused send,
  // the hourly cap, the day's ceiling: its answer form 'not_sent'). Only the small line changed, under the title "Check your
  // email" and a first step "Open the link in your email", so a stranger read the big words and went looking for an email
  // that was not there. leadNotSent's twin, for an enquiry that DID arrive: the title, the main button and the first step
  // say what is true. Only while the screen still makes the email promise (its WhatsApp button quiet).
  function formNotSent(kind) {
    var wa = $('cdmc-success-wa');
    if (!wa || !wa.classList.contains('cdmc__btn-wa--quiet')) return;
    wa.classList.remove('cdmc__btn-wa--quiet');
    var t = $('cdmc-success-title'); if (t) t.textContent = 'We\'ve got your details';
    var sub = $('cdmc-success-sub'); if (sub) sub.textContent = 'We have your details, but we couldn\'t email your form link just now. We\'ll send it as soon as we\'ve checked your enquiry, or tap below to message us.';
    var label = $('cdmc-success-wa-label'); if (label) label.textContent = 'Message us on WhatsApp →';
    var list = $('cdmc-next-list');
    var first = list && list.querySelector('.cdmc__next-step');
    var ft = first && first.querySelector('.cdmc__next-title'), fsub = first && first.querySelector('.cdmc__next-sub');
    if (ft && /Open the link in your email/.test(ft.textContent)) {
      ft.textContent = 'We email you your ' + (kind === 'repair' ? 'repair form' : 'form') + ' link';
      if (fsub) fsub.textContent = 'As soon as we have checked your enquiry, usually the same day (we are closed Tuesdays and Wednesdays)';
    }
  }

  function opsSendLead(contact, kind, onAccepted) {   // r156 — onAccepted: the quote conversion, once the app says yes
    // r170 (CXR1012-05, Codex 12 Oct) — AN ANSWER SPEAKS FOR ITS OWN ENQUIRY ONLY. The success screen is one set of elements
    // shared by every enquiry sent from the page; a late answer to an earlier one (its form link, "not sent", a failure)
    // was written over the newer enquiry's screen, or hid its form button. Each send takes a number (kept on this function,
    // so no other name has to stay in step with it), and only the newest one's answers touch the screen; an older answer
    // still counts its conversion and settles its own key.
    var gen = opsSendLead.sent = (opsSendLead.sent || 0) + 1;
    var mine = function () { return gen === opsSendLead.sent; };
    var sayNotSent = function () { if (mine()) leadNotSent(); };
    try {
      var payload = opsBuildLead(contact, kind);
      var body = JSON.stringify(payload);
      // DOR-07 (app v499's fingerprint half, bundle W7) — A KEY NAMES ONE ENQUIRY. It is reused only to re-send THE
      // SAME enquiry; a changed quote (the previous send unconfirmed, so the key was kept) gets its own key, because
      // the ops app now refuses a known key with different content (409 PUBLIC_INTAKE_KEY_REUSED) — and before v499
      // it would have silently filed the new enquiry under the old one.
      // W7.1 (the W7 independent watch, OPEN MEDIUM) — AND EACH ENQUIRY KEEPS ITS OWN KEY until it is confirmed. One shared
      // slot lost a re-key: B was refused as "key reused", a different enquiry A took the slot meanwhile, B's fresh key
      // lived only in its in-flight request, and if that answer was lost the next retry of B minted another key — a
      // second lead. `_opsIdemByBody` maps each unconfirmed enquiry to its key (a handful at most; the oldest are
      // dropped past ten); `_opsIdemKey`/`_opsIdemFor` still name the latest one for anything that reads them.
      var key = _opsIdemByBody[body];
      if (!key) {
        key = opsNewIdemKey(); _opsIdemByBody[body] = key;
        var held = Object.keys(_opsIdemByBody);
        while (held.length > 10) delete _opsIdemByBody[held.shift()];
      }
      _opsIdemKey = key; _opsIdemFor = body;   // reused on retry of this same enquiry; forgotten after a confirmed send
      var retried = false, rekeyed = false, accepted = false;
      var fire = function () {
        if (!_opsToken) { sayNotSent(); return; }   // r149 (FSA-046): no token, nothing sent
        fetch(OPS_INTAKE_URL + '/lead', {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            'X-Intake-Token': _opsToken,
            'Idempotency-Key': key
          },
          body: body,
          keepalive: true
        }).then(function (r) {
          if (r && r.ok) {   // confirmed: this enquiry's key is spent; the next submission gets a fresh one
            if (_opsIdemByBody[body] === key) delete _opsIdemByBody[body];
            if (_opsIdemKey === key) { _opsIdemKey = ''; _opsIdemFor = ''; }
            // r156 (FSA-051) — the app has the enquiry: NOW it counts, once, however many tries it took to get here
            if (!accepted && typeof onAccepted === 'function') { accepted = true; try { onAccepted(); } catch (e) {} }
            // v513 (D-20260921-b) — the success screen says the buying-form link was emailed. If the app says it
            // was NOT (mail refused, rate-limited, held for review), the screen must not keep claiming it did.
            r.clone().json().then(function (b) {
              if (!mine()) return;   // r170 (CXR1012-05): a newer enquiry owns the screen now
              // Dan, 2026-09-21: "We coukd add the buying form to that check your email thing" — the app hands back
              // the same personal link it just emailed, so the seller can start at once. Only an https link on the
              // app's own host is ever put on the button.
              var formBtn = $('cdmc-success-form');
              if (b && b.form === 'emailed' && formBtn && /^https:\/\/(ops\.celldevices\.co\.uk|cd-ops\.cd-ops\.workers\.dev)\/(b|rf)\/[a-f0-9]{64}$/.test(String(b.form_url || ''))) {
                formBtn.href = b.form_url;
                formBtn.classList.remove('cd-hidden');
                var fbl = formBtn.querySelector('span'); if (fbl) fbl.textContent = /\/rf\//.test(String(b.form_url)) ? 'Open my repair form now →' : 'Open my buying form now →';   // R-131 live run
                var sub0 = $('cdmc-success-sub');
                var t0 = $('cdmc-success-title'); if (t0) t0.textContent = /\/rf\//.test(String(b.form_url)) ? 'Your repair form is ready' : (S.intent === 'upgrade' || S.intent === 'tradein') ? 'Your trade in form is ready' : 'Your form is ready';   // R-129 ST-23; R-131
                if (sub0 && S._formEmail) sub0.textContent = 'Open it now, or use the link we\'ve emailed to ' + S._formEmail + '.';
                return;
              }
              if (!b || b.form !== 'not_sent') return;
              formNotSent(kind);   // r167 (CL1009-04) — the title, the main button and the first step, not only the small line
            }).catch(function () {});
          }
          // DOR-07 — 409 PUBLIC_INTAKE_IN_PROGRESS = "the same enquiry is still being recorded" (never a
          // success). Ask ONCE more, same key, so the answer is the one lead. Best effort: a phone that has
          // moved to WhatsApp may suspend the timer, and any other answer keeps the key for next time.
          // 409 PUBLIC_INTAKE_KEY_REUSED = "that key already belongs to a DIFFERENT enquiry": send this one ONCE
          // under a fresh key, so it is recorded as the new enquiry it is instead of being lost.
          else if (r && r.status === 409 && !(retried && rekeyed)) {
            r.json().then(function (b) {
              if (b && b.code === 'PUBLIC_INTAKE_IN_PROGRESS' && !retried) { retried = true; setTimeout(fire, 4000); }
              else if (!(b && b.code === 'PUBLIC_INTAKE_KEY_REUSED' && !rekeyed)) sayNotSent();   // r149 (FSA-046): a 409 we cannot resolve
              else if (b && b.code === 'PUBLIC_INTAKE_KEY_REUSED' && !rekeyed) {
                rekeyed = true;
                // (review) Always a FRESH key for this enquiry — never whatever the shared slot holds by now (another
                // enquiry's key, or '' after that one was confirmed); the slot follows only if it still held ours.
                // W7.1 (review) — one key per enquiry even across two attempts at it: adopt the key another attempt already
                // re-keyed to; stop if that attempt was already confirmed; only otherwise mint one (kept per enquiry).
                var cur = _opsIdemByBody[body], old = key;
                if (!cur) return;                                   // this enquiry was confirmed meanwhile — nothing to send
                if (cur !== old) key = cur;
                else { key = opsNewIdemKey(); _opsIdemByBody[body] = key; }
                if (_opsIdemKey === old) { _opsIdemKey = key; _opsIdemFor = body; }
                fire();
              }
            }).catch(function () {});
          }
          // r149 (FSA-046) — refused (401, 429, 500, anything else, or a 409 after both retries): the app has not got it
          else sayNotSent();
        }).catch(function () { sayNotSent(); });   // r149 (FSA-046): the network never delivered it
      };
      if (_opsToken && Date.now() < _opsTokenExp) { fire(); }
      else {
        var p = opsFetchToken();
        if (p && p.then) p.then(fire).catch(function () { sayNotSent(); });   // r149 (FSA-046): no token could be fetched
        else sayNotSent();
      }
    } catch (e) { sayNotSent(); }
  }

  // r156 (Codex FSA-051 and ME-01; Dan, D-20261003-c (7) "Once the app accepts it") — THE QUOTE CONVERSION COUNTS ONLY AN
  // ENQUIRY THE APP ACCEPTED. Both signals below fired at the tap, before opsSendLead had an answer, so a send the app
  // refused or never received (r149 then tells the customer we did not get it) still counted as a lead to Google Ads and
  // taught it the wrong thing. They now fire from opsSendLead's accepted answer, once per enquiry, with the quote as it
  // stood at the tap, and never for a send that failed.
  function fireQuoteConversion(kind, snap) {
    // ── The quote conversion (Dan's decision, 2026-09-13: Shopify Customer Events, D-20260913-c) ──
    // A quote is the business, and Google Ads has never been told about a single one. We publish a
    // CUSTOM Shopify customer event here; a custom pixel in Dan's admin subscribes to it and fires
    // the Ads conversion from inside Shopify's sandbox, where the Google tag already lives.
    // Why not just load gtag here: GA4/Ads are the Shopify Google & YouTube channel's (web pixel
    // 3215753591), so a tag in the theme is a SECOND tag and double-counts every page view.
    // Shopify.analytics.publish is verified present on the live storefront and carries a replayQueue,
    // so an event published before the pixels finish loading is still delivered.
    // ⚠ NO PERSONAL DATA IN THIS PAYLOAD. `contact` holds the customer's name, phone and email and
    // none of it may go to an analytics pixel — SECURITY_PRIVACY.md is BINDING and fails closed.
    // tools/theme-analytics-check.mjs asserts that, so a future field cannot quietly add one.
    try {
      if (analyticsAllowed() && window.Shopify && window.Shopify.analytics
          && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('cd_quote_submitted', {
          kind: kind || '',                          // 'repair' | 'sell' — Dan's two funnels
          device: snap.model || '',
          storage: snap.storage || '',
          intent: snap.intent || '',
          parts: snap.parts || ''
          // No value/currency on purpose: the only figure in scope is a quote RANGE, and a single
          // number here would be an invented price (DEVELOPMENT_PROTOCOL golden rule 6).
        });
      }
    } catch (e) {}
    // ── THE ADS CONVERSION, AND IT IS LIVE AGAIN (2026-09-13, second pass) ──
    // This call was INERT for its whole life — window.gtag did not exist on this page, because the
    // channel's gtag is sandboxed in a web-pixel worker. `snippets/cd-ads-tag.liquid` now loads an
    // ADS-ONLY gtag beside this calculator (NO gtag('config') call at all — measured: send_page_view:false is
    // accepted and ignored, and the config call is what emits the page view — plus consent-gated), so window.gtag is a
    // real function here and this line finally does something.
    // ⚠ The Shopify custom-event publish ABOVE is kept and is NOT the mechanism any more: custom
    // pixels cannot export Ads conversions (documented sandbox limitation — it was built, connected
    // and tried). The publish is harmless and leaves the event available to any future subscriber.
    // ⚠ analyticsAllowed() still gates this, and the tag will not have loaded without consent either,
    // so there are two independent locks and both fail closed.
    try {
      if (analyticsAllowed() && typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', { 'send_to': GADS_CONV });
      }
    } catch (e) {}
  }

  function finishAndOpenWA(contact, message, kind) {
    // r156 (FSA-051) — the quote as it stands at the tap, for the conversion fired once the app has accepted it.
    var convSnap = { model: S.model, storage: S.storage, intent: S.intent, parts: S.parts };
    try {
      var fd = new FormData();
      fd.append('kind', kind);
      fd.append('name', contact.name);
      fd.append('phone', contact.phone);
      if (contact.email) fd.append('email', contact.email);
      fd.append('marketing', contact.marketing ? 'yes' : 'no');
      fd.append('summary', message);
      fd.append('device', (S.type === 'other' ? S.otherDevice : S.model) || '');   // D-20260923-j
      if (S.storage) fd.append('storage', S.storage);
      if (S.intent) fd.append('intent', S.intent);
      if (S.parts) fd.append('parts', S.parts);
      fetch(FORMSPREE_URL, { method: 'POST', body: fd, mode: 'no-cors' });
    } catch (e) {}
    // ── Ops app auto-intake (fire-and-forget; WhatsApp handoff never waits on it) ──
    try { opsSendLead(contact, kind, function () { fireQuoteConversion(kind, convSnap); }); } catch (e) {}   // r156: counted once accepted
    if (contact.marketing && contact.email) {
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UBmfr5', {
          method: 'POST',
          headers: { 'content-type': 'application/json', 'revision': '2026-04-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Quote calculator',
                profile: { data: { type: 'profile', attributes: { email: contact.email } } }
              },
              relationships: { list: { data: { type: 'list', id: 'Xfgcuc' } } }
            }
          })
        });
      } catch (e) {}
      // ── Klaviyo event → fuels abandoned-quote (repair) + trade-in/sell recovery flows ──
      // Fires only with email + marketing consent (same gate as the subscribe above): GDPR-clean, identifiable.
      // r152 (FSA-013) — an unlisted phone's sale has no offer on screen, so no "offer seen" event is sent for it
      if (!(S.type === 'other' && kind !== 'repair')) try {
        var isRepair   = (kind === 'repair');
        var isOther    = isRepair && S.type === 'other';   // D-20260923-j: no price on screen, so none is sent
        var metricName = isRepair ? 'Quote Completed' : 'Trade-in Offer Seen';
        var estEl      = isOther ? null : (isRepair ? $('cdmc-r-price') : $('cdmc-t-cash'));
        var estimate   = ((estEl && estEl.textContent) || '').trim();
        var faultEl    = (isRepair && !isOther) ? $('cdmc-r-repair') : null;
        // Trade-in offers render as a range ("£65 – £105") — take the FIRST number (low bound),
        // never strip-and-concatenate (that turned £65–£105 into 65105).
        var valueNum   = parseFloat((estimate.match(/[\d.]+/) || [''])[0]);
        var props = {
          kind:     kind,
          intent:   S.intent || (isRepair ? 'repair' : ''),
          model:    (isOther ? S.otherDevice : S.model) || '',
          storage:  S.storage || '',
          parts:    S.parts || '',
          fault:    faultEl ? ((faultEl.textContent || '').trim()) : '',
          estimate: estimate
        };
        var eventAttrs = {
          metric:     { data: { type: 'metric', attributes: { name: metricName } } },
          properties: props,
          profile:    { data: { type: 'profile', attributes: { email: contact.email } } }
        };
        if (!isNaN(valueNum)) { eventAttrs.value = valueNum; eventAttrs.value_currency = 'GBP'; }
        fetch('https://a.klaviyo.com/client/events/?company_id=UBmfr5', {
          method: 'POST',
          headers: { 'content-type': 'application/json', 'revision': '2026-04-15' },
          body: JSON.stringify({ data: { type: 'event', attributes: eventAttrs } })
        });
      } catch (e) {}
    }
    clearQuoteState();
    var waUrl = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(message);
    var waBtn = $('cdmc-success-wa');
    if (waBtn) waBtn.href = waUrl;
    var retry = $('cdmc-wa-retry');
    if (retry) retry.href = waUrl;
    // v513 (D-20260921-b, AUDIT A-07) — a normal sell / trade-in quote goes through the BUYING FORM: the ops app
    // emails the link the moment the lead lands, and everything after that happens on the form. So WhatsApp is no
    // longer opened for them — it stays on the page as a small "questions?" link. Repairs, free recycling and a
    // reported-stolen phone still hand off to WhatsApp as before (none of them has a buying form).
    var viaForm = ((kind === 'sell' || kind === 'tradein') && !isRecycleOnly(S.model) && S.blacklist !== 'stolen')
      || (kind === 'repair' && !!(contact.email && String(contact.email).trim()));   // R-131 stage 1: the repair form
    S._formEmail = viaForm ? contact.email : null;
    var fb = $('cdmc-success-form'); if (fb) { fb.classList.add('cd-hidden'); fb.href = '#'; }
    setSuccessContent(kind, viaForm ? contact.email : null);
    goStep('success');
    if (!viaForm) {
      setTimeout(function(){
        if (waBtn) waBtn.click();
      }, 400);
    }
  }

  // WEB-039 — did the customer report a battery that is swollen / bowed ("Warm / swollen / bowed"), a screen
  // lifting from the frame, or a phone that gets very hot? Those are the ones D-20260919-c routes to "message first".
  function reportedDamagedBattery() {
    var sym = S.sym || {};
    return S.glsBatt === 'damaged' || (sym.bat || []).indexOf('bat_hot') !== -1 || (sym.gls || []).indexOf('gls_screen_lift') !== -1;
  }
  function setSuccessContent(kind, formEmail) {
    var title = $('cdmc-success-title');
    var sub   = $('cdmc-success-sub');
    var label = $('cdmc-success-wa-label');
    var waBtn = $('cdmc-success-wa');
    var isRecycle = kind !== 'repair' && isRecycleOnly(S.model);   // D-20260911-d
    // v513 — the buying-form path: WhatsApp is demoted to a quiet "questions?" link, never the primary action.
    if (waBtn) waBtn.classList.toggle('cdmc__btn-wa--quiet', !!formEmail);
    if (formEmail) {
      if (title) title.textContent = 'Check your email';
      if (sub) sub.textContent = 'We\'ve emailed your ' + (kind === 'repair' ? 'repair form' : 'form') + ' link to ' + formEmail + '. It usually arrives within a minute, so check junk if not.';
      if (label) label.textContent = 'Questions? WhatsApp us';
    } else if (kind === 'repair') {
      if (title) title.textContent = 'Repair confirmed';
      if (sub) sub.textContent = 'Tap below. The details are filled in, just hit send.';
      if (label) label.textContent = 'Open WhatsApp and send your quote →';
    } else if (isRecycle) {
      if (title) title.textContent = 'Free recycling';
      if (sub) sub.textContent = 'Tap below and we\'ll send you a free Tracked 48 label.';
      if (label) label.textContent = 'Open WhatsApp to arrange free recycling →';
    } else if (kind === 'sell') {
      if (title) title.textContent = 'Valuation complete';
      if (sub) sub.textContent = 'Tap below and we\'ll confirm and send your label.';
      if (label) label.textContent = 'Open WhatsApp to get my offer →';
    } else {
      if (title) title.textContent = 'Valuation complete';
      if (sub) sub.textContent = 'Tap below and we\'ll confirm the trade in and your upgrade.';
      if (label) label.textContent = 'Open WhatsApp to confirm the trade in →';
    }
    var list = $('cdmc-next-list');
    if (list) {
      // R-131 live run (2026-09-22): the repair-form steps come FIRST. They used to sit after `kind === 'repair'`,
      // which caught every repair, so a customer with the form in their inbox was told "We reply on WhatsApp".
      var steps = (formEmail && kind === 'repair') ? [
        // R-131 stage 1 — the repair form, then a price by email (D-20260922-d: the email is the interface)
        ['Open the link in your email', 'A short repair form: what is wrong, photos if you can, and how it gets to us'],
        ['We email you a price for the repair', 'Usually the same day (we are closed Tuesdays and Wednesdays)'],
        ['Accept it from that email', 'Then we send a free label, or arrange a local drop off or collection'],
        // D-20260923-j: an unlisted device has no part chosen yet, so its warranty is the general one
        ['Repair, test & return', '3 to 5 working days typical · ' + (S.type === 'other' ? 'warranty up to 12 months, depending on the part' : warrantyWords(S.parts))]
      ] : (kind === 'repair') ? [
        ['We reply on WhatsApp', 'Usually the same day (we are closed Tuesdays and Wednesdays)'],
        ['We send you a prepaid label', 'Royal Mail Tracked 24, scan it at any Post Office'],
        ['Repair, test & return', '3 to 5 working days typical · ' + warrantyWords(S.parts)]
      ] : isRecycle ? [
        ['We reply on WhatsApp', 'Usually the same day (we are closed Tuesdays and Wednesdays)'],
        ['We send you a free Tracked 48 label', 'Then we recycle it responsibly, free of charge']
      ] : formEmail ? [
        // v513 (D-20260921-b) — the form is where the rest happens. D-20260922-d — and the EMAIL carries each step.
        ['Open the link in your email', 'Your own form, two minutes. Have the IMEI ready (dial *#06#)'],
        ['We email you our offer', 'Accept it from the email. There is no need to keep checking the page'],
        [kind === 'sell' ? 'You post the phone' : 'You post your old phone', 'Free Royal Mail tracked label, scan it at any Post Office'],
        kind === 'sell' ? ['Paid within 24 hours', 'By bank transfer, once we\'ve checked it over']
          // R-129 ST-23 — Send first is paid in a discount code, not a dispatched phone
          // r149 (Codex FSA-047, ST-23) — the button sends 'send-first' (the app reads either): 'send_first' never matched, so
          // a Send first trade in was promised a bank transfer here
          : S.tradeFlow === 'send-first' ? ['Your discount code', 'Emailed once we have checked it, to use on your new phone']
            : ['We pay your trade in value', 'Within 24 hours of checking it, by bank transfer']
      ] : (kind === 'sell') ? [
        ['We reply on WhatsApp', 'Confirms offer + prepaid label'],
        ['You post the device', 'Free Royal Mail tracked label, scan it at any Post Office'],
        ['Paid within 24 hours', 'By bank transfer, once we\'ve checked it over']
      ] : [
        ['We reply on WhatsApp', 'Confirms offer + which phone you\'re after'],
        ['You post the old device', 'Free Royal Mail tracked label, scan it at any Post Office'],
        ['New device dispatched', 'The next working day once your trade in arrives']
      ];
      // WEB-039 (D-20260919-c) — a customer who REPORTED a swollen, hot or damaged battery is not sent an
      // ordinary label: the posting step becomes "message us first". Every other quote keeps its label.
      if (reportedDamagedBattery() && !isRecycle) {
        var routed = false;
        steps = steps.reduce(function (out, s) {
          if (!/label|post the/i.test(s[0] + ' ' + s[1])) { out.push(s); return out; }
          if (!routed) out.push(['Swollen, hot or damaged battery? Message us before posting', 'We\'ll arrange a safe way. Please don\'t post it as an ordinary parcel']);
          routed = true;   // one line, in place of every posting step
          return out;
        }, []);
      }
      list.innerHTML = steps.map(function(s, i){
        return '<div class="cdmc__next-step">' +
          '<div class="cdmc__next-num">' + (i + 1) + '</div>' +
          '<div><p class="cdmc__next-title">' + escHTML(s[0]) + '</p><p class="cdmc__next-sub">' + escHTML(s[1]) + '</p></div>' +
        '</div>';
      }).join('');
    }
  }

  // D-20260923-j (FSA-013): a device the calculator does not list is repaired through THE REPAIR FORM, like an iPhone:
  // the same contact checks (email required, terms), the same ops lead (type repair, no quoted price, Dan prices it by
  // hand), the same "Check your email" screen. It used to take a name and number only and open WhatsApp by itself.
  // r152 (app v778; Codex FSA-013; Dan, D-20260927-a (25)) — AN UNLISTED PHONE CAN BE SOLD HERE, PRICED BY HAND. Selling one
  // was a WhatsApp link only. Now the form asks Repair it or Sell it; a sale goes to the app as a sell lead with no price,
  // and the app's own flow emails the selling form, so Dan prices it from the answers, as any sale.
  function setOtherIntent(intent) {
    S.otherIntent = intent === 'sell' ? 'sell' : 'repair';
    var sell = S.otherIntent === 'sell';
    document.querySelectorAll('[data-action="other-intent"]').forEach(function (b) {
      var on = b.getAttribute('data-intent') === S.otherIntent;
      b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var lab = $('cdmc-other-fault-label'); if (lab) lab.textContent = sell ? 'What condition is it in?' : 'What\'s wrong?';
    var box = $('cdmc-other-fault'); if (box) box.placeholder = sell ? 'Does it turn on? Any cracks, faults or missing parts?' : 'Describe the fault…';
    var note = $('cdmc-other-email-note'); if (note) note.textContent = sell ? '(we send your selling form here)' : '(we send your repair form here)';
    var btn = $('cdmc-other-submit-label'); if (btn) btn.textContent = sell ? 'Send for an offer →' : 'Send for a repair quote →';
    // v871 (Codex CX0927-14): the introduction follows the choice too (it promised a repair form on Sell)
    var intro = $('cdmc-other-intro'); if (intro) intro.textContent = sell
      ? 'Not on the list? Tell us the device and its condition, and we\'ll email you a selling form and price it by hand.'
      : 'Not on the list? Tell us the device and what\'s wrong, and we\'ll email you a repair form and price it by hand.';
    hide($('cdmc-other-err'));
  }

  function otherSubmit() {
    var device = String(($('cdmc-other-device') || {}).value || '').trim();
    var fault = String(($('cdmc-other-fault') || {}).value || '').trim();
    var errEl = $('cdmc-other-err');
    var sell = SELL_ONLY || S.otherIntent === 'sell';   // r165 (R-163): a sell only page sends a sale, whatever the state says
    if (!device || !fault) {
      if (errEl) { errEl.textContent = sell ? 'Please tell us the device and what condition it is in.' : 'Please tell us the device and what\'s wrong with it.'; show(errEl); }
      var first = !device ? $('cdmc-other-device') : $('cdmc-other-fault');
      if (first) first.focus();
      return;
    }
    var c = validateContact('cdmc-other');
    if (!c) return;
    S.otherDevice = device.slice(0, 80);
    S.otherFault = fault.slice(0, 500);
    var msg = 'Hi Cell Devices,\n\nMy device isn\'t on the quote tool. ' + (sell ? 'Could you give me an offer for it?' : 'Could you quote me for a repair?') + '\n' +
              '• Device: ' + S.otherDevice + '\n• ' + (sell ? 'Condition: ' : 'Fault: ') + S.otherFault + '\n\nName: ' + c.name + '\nPhone: ' + c.phone +
              (c.email ? '\nEmail: ' + c.email : '');
    finishAndOpenWA(c, msg, sell ? 'sell' : 'repair');
  }

  function switchTradein() {
    if (S.type === 'other') return;
    S.intent = 'upgrade';
    _carryFaultsToTradeIn();
    enterCheck();
  }

  function switchSell() {
    if (S.type === 'other') return;
    S.intent = 'sell';
    _carryFaultsToTradeIn();
    enterCheck();
  }

  function _carryFaultsToTradeIn() {
    var carriedFaults = _inferTradeinFaults();
    S.faults = carriedFaults;
    document.querySelectorAll('#cdmc-cond-faults [data-action="fault-toggle"]').forEach(function(b){
      b.classList.toggle('active', carriedFaults.indexOf(b.getAttribute('data-fault')) !== -1);
    });
    if (carriedFaults.length > 0) {
      S.faulty = 'yes';
      if (!S.cond) S.cond = 'broken';
    }
  }

  // r152 (app v782; Codex FSA-057) — A SALE CARRIES WHAT THE CUSTOMER TOLD US, NOT A GUESS. Switching a repair to a sale
  // added one generic fault per repair on top of what they had said: a software problem became "won't turn on" (the
  // untestable price), small parts became "speaker", a frame became "back glass"; and a Face ID repair carried nothing,
  // so the phone was priced as if Face ID worked. Now their own faults come first, and the repair adds its fault only
  // when none of theirs already stands for it, in words that claim only what is known.
  function _inferTradeinFaults() {
    var faults = [];
    S.faults.forEach(function(f) {
      if (f !== 'none' && faults.indexOf(f) === -1) faults.push(f);
    });
    var bonded = HOUSING_ONLY.indexOf(S.model) !== -1;   // the housing repair IS the back glass repair on these
    var REPAIR_FAULT = {   // repair: [the fault it adds, the faults that already stand for it]
      'screen': ['screen_cracked', ['screen_cracked', 'screen_damaged', 'screen_lcd_fault', 'screen_touch_only']],
      'screen-lcd': ['screen_damaged', ['screen_cracked', 'screen_damaged', 'screen_lcd_fault', 'screen_touch_only']],
      'screen-touch': ['screen_damaged', ['screen_cracked', 'screen_damaged', 'screen_lcd_fault', 'screen_touch_only']],
      'battery': ['battery', ['battery']],
      'back-glass': ['back_glass', ['back_glass']],
      'housing': [bonded ? 'back_glass' : 'other_fault', ['back_glass', 'other_fault']],
      'camera': ['rear_camera', ['rear_camera', 'camera_lens_damage']],
      'camera-lens': ['camera_lens_damage', ['camera_lens_damage', 'rear_camera']],
      'charging-port': ['charging', ['charging']],
      'small-parts': ['other_fault', ['speaker', 'buttons', 'other_fault']],
      'software': ['other_fault', ['wont_turn_on', 'other_fault']],
      'other': ['other_fault', ['other_fault']],
      'water': ['water', ['water']],
      'face-id': ['face_id', ['face_id']]
    };
    var r = S.repair && REPAIR_FAULT[S.repair];
    if (r && !r[1].some(function (f) { return faults.indexOf(f) !== -1; })) faults.unshift(r[0]);
    return faults;
  }
  function switchRepair() {
    if (SELL_ONLY) return;   // r165 (R-163)
    S.intent = 'repair';
    S.repair = '';
    S.parts = '';
    S.primaryFromQuiz = false;
    S.chosenUpgrade = null;
    S.tradeFlow = '';
    _battHealthCallback = null;
    document.querySelectorAll('.cdmc__repair-btn.active, .cdmc__parts-btn.active').forEach(function(b){
      b.classList.remove('active');
    });
    showRepairsForType();
    goStep('sr1');
  }
  function switchUpgrade() {
    S.intent = 'upgrade';
    renderTradeinResult();
  }

  function updateDanStatus() {
    var now = (window.cdLondonNow ? cdLondonNow() : new Date());
    var day = now.getDay();
    var h = now.getHours() + now.getMinutes() / 60;
    var SCHEDULE = {0:[11,17], 1:[9,18], 4:[9,18], 5:[9,18], 6:[9,18]};
    var win = SCHEDULE[day];
    var online = !!(win && h >= win[0] && h < win[1]);
    var offlineMsg;
    var dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var openLabel = function(d){ return SCHEDULE[d][0] === 11 ? '11am' : '9am'; };
    if (win && h < win[0]) {
      offlineMsg = 'We\'re offline · Back at ' + openLabel(day) + ' today';
    } else {
      var next = day;
      for (var i = 1; i <= 7; i++) {
        next = (day + i) % 7;
        if (SCHEDULE[next]) break;
      }
      offlineMsg = 'We\'re offline · Back ' + dayNames[next] + ' at ' + openLabel(next);
    }
    var msg = online ? 'We\'re open · we usually reply the same day' : offlineMsg;
    var hStatus = $('cdmc-hero-status');
    var hDot = $('cdmc-hero-dot');
    var hText = $('cdmc-hero-text');
    if (hStatus && hDot && hText) {
      hStatus.classList.toggle('offline', !online);
      hDot.classList.toggle('online', online);
      hDot.classList.toggle('offline', !online);
      hText.textContent = msg;
    }
    var sDot = $('cdmc-success-dot');
    var sText = $('cdmc-success-text');
    if (sDot && sText) {
      sDot.classList.toggle('online', online);
      sDot.classList.toggle('offline', !online);
      sText.textContent = online ? 'We\'re open, so expect a reply today' : offlineMsg;
    }
  }

  var _reviewIdx = 0;
  function showReview() {
    var r = REVIEWS[_reviewIdx % REVIEWS.length];
    var q = $('cdmc-review-quote');
    var a = $('cdmc-review-author');
    var box = $('cdmc-review-rotator');
    if (!q || !a || !box) return;
    box.style.opacity = '0';
    setTimeout(function(){
      q.textContent = r.quote;
      a.textContent = r.author;
      box.style.opacity = '1';
    }, 280);
    _reviewIdx++;
  }

  var _notifHideTimer = null;
  // `ms` — how long it stays. 3.2s is right for a decorative toast and far too short for anything the
  // visitor is meant to ACT on: the resume prompt says "Tap here" and gave them about three seconds to
  // find it, on top of not being clickable at all (see .cdmc__notif.is-resume in the CSS).
  function showNotif(app, msg, icon, ms) {
    var n = $('cdmc-notif');
    if (!n) return;
    $('cdmc-notif-app').textContent = app || 'CELL_DEVICES';
    $('cdmc-notif-msg').textContent = msg || '';
    if (icon) $('cdmc-notif-icon').textContent = icon;
    n.classList.add('show');
    if (_notifHideTimer) clearTimeout(_notifHideTimer);
    _notifHideTimer = setTimeout(function () {
      n.classList.remove('show');
      n.classList.remove('is-resume');          // never leave a dead click target armed
    }, Number(ms) > 0 ? Number(ms) : 3200);
  }

  function faqToggle(btn) {
    var item = btn.closest('.cdmc-faq__item');
    if (item) item.classList.toggle('open');
  }

  // r149 (Codex FSA-048) — NEVER CUT A NUMBER SHORT. This kept the first 11 characters whatever they were, so
  // "+447700900000" became "+4477 009 000" (two digits gone) and the check below still took it. A UK number keeps all
  // of its digits: 0 and ten more ("07700 900 000"), or +44 (typed as 44 or 0044 too) and ten more ("+44 7700 900 000").
  // Anything else is left as typed for the check to answer.
  function groupDigits(d, first) {
    return d.length <= first ? d : d.length <= first + 3 ? d.slice(0, first) + ' ' + d.slice(first)
      : d.slice(0, first) + ' ' + d.slice(first, first + 3) + ' ' + d.slice(first + 3);
  }
  function formatPhone(input) {
    var v = input.value.replace(/[^\d+]/g, '');
    var d = v.replace(/\D/g, '');
    if (/^(\+|00)?44/.test(v)) {
      var rest = d.replace(/^(00)?44/, '').replace(/^0/, '').slice(0, 10);
      input.value = '+44' + (rest ? ' ' + groupDigits(rest, 4) : '');
    } else if (/^0/.test(v)) {
      input.value = groupDigits(d.slice(0, 11), 5);   // "00" on its way to "0044" stays as typed until it gets there
    } else {
      input.value = v;
    }
  }

  /* ── URL param prefill (?model= &fault= &intent=) ──────────────────
     Makes the site's deep links live: fault pages pass ?fault=, device
     pages and price-table rows pass ?model=, fork sell CTAs pass
     ?intent=sell. Unknown or missing params fall through to the normal
     start — the whole thing is wrapped so it can never break the tool. */
  function applySymptoms(symParam) {
    if (!symParam) return;
    String(symParam).split(',').forEach(function (s) {
      s = s.trim();
      if (!/^[a-z]+_[a-z_]+$/.test(s)) return;
      var btn = document.querySelector('[data-action$="-symptom"][data-fault="' + s + '"]');
      if (btn && typeof btn.click === 'function') btn.click();
    });
  }

  // WEB-035 — A HANDLE MUST NAME ONE MODEL. `+` used to vanish with the other punctuation, so
  // 'Galaxy S24' and 'Galaxy S24+' were both 'galaxy-s24' and the first in MODELS (the Plus) won:
  // five base Galaxy S21–S25 links opened the Plus. `+` is spelled '-plus' now, so every one of the
  // models round-trips to itself (gated by tools/theme-calculator-flow-check.mjs). ⚠ Liquid's
  // `handle` filter still DROPS the '+', so a Plus deep link written in the theme must spell it
  // `galaxy-s24-plus` by hand, never `{{ 'Galaxy S24+' | handle }}`.
  function _handleize(v) {
    return String(v).toLowerCase().replace(/\+/g, '-plus').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function saveQuoteState() {
    if (!S.model || S.current === 'success') return;
    try {
      localStorage.setItem('cd_quote_state', JSON.stringify({
        model: S.model,
        mh: _handleize(S.model),
        fault: S.repair || '',
        intent: S.intent || '',
        ts: Date.now()
      }));
    } catch (e) {}
  }

  function clearQuoteState() {
    try { localStorage.removeItem('cd_quote_state'); } catch (e) {}
  }

  function initResume() {
    if (_prefillApplied || _prefillRepair || _prefillIntent) return;
    if (S.current !== 's0' || S.model) return;
    var st = null;
    try {
      st = JSON.parse(localStorage.getItem('cd_quote_state') || 'null');
    } catch (e) { st = null; }
    if (!st || !st.model || !st.mh || !st.ts) return;
    if (Date.now() - st.ts > 72 * 60 * 60 * 1000) return;
    var n = $('cdmc-notif');
    if (n) {
      var resumeHandler = function () {
        n.removeEventListener('click', resumeHandler);
        n.classList.remove('show');
        n.classList.remove('is-resume');
        applyParams({ model: _handleize(st.model), fault: st.fault || '', intent: st.intent || '' });   // WEB-035 — the saved full name, not a possibly-lossy old handle
      };
      n.addEventListener('click', resumeHandler);
    }
    setTimeout(function () {
      // ⚠ `is-resume` is what makes it clickable — the base rule is pointer-events:none and `.show` does not
      // lift it, so for its whole life this prompt invited a tap it could not receive. Added BEFORE showNotif
      // so the bubble is live the moment it slides in, and 15s rather than 3.2s because a person has to read
      // it, decide, and aim. showNotif clears both classes when it hides, so nothing is left armed.
      if (n) n.classList.add('is-resume');
      showNotif('CELL_DEVICES', 'Continue your ' + st.model + ' quote? Tap here', '🔄', 15000);
    }, 900);
  }

  function _applyDeferredPrefill() {
    if (!_prefillRepair && !_prefillIntent) return;
    var pr = _prefillRepair, pi = _prefillIntent, ps = _prefillSym;
    _prefillRepair = ''; _prefillIntent = ''; _prefillSym = '';
    if (S.type === 'other' || !S.model) return;
    if (pr) { setIntent('repair'); setRepair(pr); applySymptoms(ps); }
    else if (pi) { setIntent(pi); }
  }

  function applyPrefill() {
    var q = window.location.search;
    if (!q || q.length < 2) return;
    var params = {};
    try {
      q.slice(1).split('&').forEach(function(kv){
        var i = kv.indexOf('=');
        if (i > 0) params[decodeURIComponent(kv.slice(0, i)).toLowerCase()] = decodeURIComponent(kv.slice(i + 1).replace(/\+/g, ' ')).toLowerCase();
      });
    } catch (e) { return; }
    // r165 (R-163): a link may answer the condition question (?cond=working / broken / likenew / good / fair). An unknown
    // value changes nothing, and a section's own preset stands.
    if (params.cond && COND_MAP[params.cond]) PRESET_COND = COND_MAP[params.cond];
    if (!params.model && !params.fault && !params.intent && !params.type) return;
    applyParams(params);
  }

  function applyParams(params) {
    try {

      var intentMap = { repair:'repair', sell:'sell', upgrade:'upgrade', tradein:'upgrade', 'trade-in':'upgrade', trade:'upgrade' };
      var intent = intentMap[params.intent || ''] || '';

      var faultMap = {
        screen:'screen', display:'screen',
        battery:'battery',
        'back-glass':'back-glass', backglass:'back-glass', back_glass:'back-glass',
        housing:'housing', frame:'housing',
        charging:'charging-port', 'charging-port':'charging-port', charging_port:'charging-port',
        camera:'camera', 'camera-lens':'camera-lens', camera_lens:'camera-lens',
        'face-id':'face-id', faceid:'face-id', face_id:'face-id',
        software:'software', water:'water', 'water-damage':'water',
        'small-parts':'small-parts', small_parts:'small-parts',
        other:'other', 'wont-turn-on':'software', wont_turn_on:'software', dead:'software'
      };
      var repair = faultMap[params.fault || ''] || '';
      if (repair && !intent) intent = 'repair';
      // r165 (R-163): on a sell only page a link or a saved quote that names a repair keeps its model and nothing else
      if (SELL_ONLY) { repair = ''; if (intent === 'repair') intent = ''; }

      var found = null;
      if (params.model) {
        var mh = params.model.replace(/-repair$/, '');
        var types = ['iphone', 'ipad', 'samsung', 'google'];
        for (var t = 0; t < types.length && !found; t++) {
          var list = MODELS[types[t]] || [];
          for (var m = 0; m < list.length; m++) {
            var hdl = _handleize(list[m]);   // WEB-035 — the ONE handle rule, not a second copy of the lossy regex
            if (hdl === mh) { found = { type: types[t], model: list[m] }; break; }
          }
        }
      }

      if (found) {
        setType(found.type);
        var sel = $('cdmc-model-sel');
        if (sel) sel.value = found.model;
        onModelChange(found.model);
        _prefillApplied = true;
        if (intent === 'repair') { setIntent('repair'); if (repair) setRepair(repair); if (repair) applySymptoms(params.sym); }
        // r149 (Codex FSA-045) — a sell or trade in link waits for the storage, which sets the offer: the intent is applied
        // at Continue (deviceContinue), where it skipped straight past the storage row to the condition screen
        else if (intent) { _prefillIntent = intent; }
        setTimeout(function(){ showNotif('Cell Devices', found.model + ' selected, carry on below', '📱'); }, 600);
      } else if (params.type && ['iphone', 'ipad', 'samsung', 'google'].indexOf(params.type) !== -1) {
        // No model given but a device type is (the battery page's iPad / Samsung / Pixel cards): open on that type
        // so the model list is already the right brand, then carry the fault/intent prefill as usual.
        setType(params.type);
        if (intent === 'repair') { if (repair) { _prefillRepair = repair; _prefillSym = params.sym || ''; } else { _prefillIntent = 'repair'; } }
        else if (intent) { _prefillIntent = intent; }
      } else if (intent === 'repair') {
        if (repair) { _prefillRepair = repair; _prefillSym = params.sym || ''; }
        else { _prefillIntent = 'repair'; }
      } else if (intent) {
        _prefillIntent = intent;
      }
      console.log('[CellDevices Calculator] prefill: model=' + (found ? found.model : '-') + ' intent=' + (intent || '-') + ' fault=' + (repair || '-'));
    } catch (err) {
      if (window.console && console.log) console.log('[CellDevices Calculator] prefill skipped', err);
    }
  }

  function init() {
    var root = $('cdmc');
    var pageRoot = document.querySelector('.cdmc-page') || document;
    pageRoot.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-action="faq-toggle"]');
      if (btn) { faqToggle(btn); }
    });
    if (!root) return;
    // r165 (R-163) — the mode and the condition preset the section rendered, read before anything can navigate
    SELL_ONLY = root.getAttribute('data-quote-mode') === 'sell';
    PRESET_COND = COND_MAP[String(root.getAttribute('data-preset-cond') || '').toLowerCase()] || '';
    if (SELL_ONLY) {
      REVIEWS = REVIEWS.filter(function (r) { return r.sell; });
      setOtherIntent('sell');
    }
    setType('iphone');
    syncPressed();   // r149 (FSA-040): the start state, announced
    opsFetchToken(); // warm the ops intake token (refreshed at submit if stale)
    loadLivePricing(); // Wave 6 Stage B: overlay the app's live pricing table when it says so
    // r168 (PDX-03) — and fetch it again once held past its age: each minute while the page is in view, when it comes back
    // into view, and when the browser brings the page back from its history
    setInterval(ageLivePricing, 60000);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') ageLivePricing(); });
    window.addEventListener('pageshow', function (e) { if (e && e.persisted) ageLivePricing(); });
    showReview();
    setInterval(showReview, 6500);
    updateDanStatus();
    setInterval(updateDanStatus, 60000);
    setTimeout(function(){ if (!_prefillApplied) showNotif('Cell Devices', 'Ready. Pick your device', '📱'); }, 600);
    // r149 (Codex FSA-040) — every choice button says whether it is pressed. The buttons show it with the class 'active' only,
    // which a screen reader cannot see; after each tap and once at start, their aria-pressed follows it. Deferred a tick:
    // this listener is registered before the tap's own handler below, so a direct call would read the state from before it.
    root.addEventListener('click', function(){ setTimeout(syncPressed, 0); });
    root.addEventListener('click', function(e){
      var t = e.target.closest('[data-action]');
      if (!t) return;
      var action = t.getAttribute('data-action');
      // R-096 (second wave) — an answer given on the folded repair screen: an earlier panel's change drops the panels after
      // it (the next one opens again from its Continue), so a price is never worked out from answers the later questions
      // did not see. goStep reads _panelSource to open the next panel in the right place.
      _panelSource = null;
      var stepEl = t.closest('.cdmc__step');
      var stepId = stepEl && stepEl.id ? stepEl.id.replace(/^cdmc-/, '') : '';
      if (screenOf(S.current) === 'sr1' && (stepId === 'sr1' || isRepairPanel(stepId)) && !/^(switch-|back$)/.test(action)) {
        _panelSource = stepId;
        dropPanelsAfter(stepId);
      }
      if (action === 'back') { goBack(); return; }
      if (action === 'set-type')   { setType(t.getAttribute('data-type')); return; }
      if (action === 'set-intent') { setIntent(t.getAttribute('data-intent')); return; }
      if (action === 'set-repair') { setRepair(t.getAttribute('data-repair')); return; }
      if (action === 'set-parts')  { setParts(t.getAttribute('data-parts')); return; }
      if (action === 'choose-upgrade') {
        var choice = _upgradeCache && _upgradeCache.all.find(function(p){ return p.handle === t.getAttribute('data-handle'); });
        if (choice) {
          S.chosenUpgrade = choice;
          document.querySelectorAll('.cdmc__upgrade-picker-item').forEach(function(b){
            var selected = b.getAttribute('data-handle') === choice.handle;
            b.classList.toggle('selected', selected);b.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        }
        return;
      }
      if (action === 'set-cond')   { setCond(t.getAttribute('data-cond')); return; }
      if (action === 'set-fault-grade') { setFaultGrade(t.getAttribute('data-fgrade')); return; }   // r148 (CC-04)
      if (action === 'set-lock')   { setLock(t.getAttribute('data-lock')); return; }
      if (action === 'set-faulty')    { setFaulty(t.getAttribute('data-faulty')); return; }
      if (action === 'set-carrier')   { setCarrier(t.getAttribute('data-carrier')); return; }
      if (action === 'set-blacklist') { setBlacklist(t.getAttribute('data-blacklist')); return; }
      if (action === 'check-continue'){ checkContinue(); return; }
      if (action === 'device-continue'){ deviceContinue(); return; }
      if (action === 'scr-symptom') { onSym('scr', t.getAttribute('data-fault'), t); return; }
      if (action === 'bat-symptom') { onSym('bat', t.getAttribute('data-fault'), t); return; }
      if (action === 'gls-symptom') { onSym('gls', t.getAttribute('data-fault'), t); return; }
      if (action === 'gls-batt')    { onGlsBatt(t.getAttribute('data-fault').replace('gls_batt_',''), t); return; }
      if (action === 'cm-symptom')  { onSym('cm', t.getAttribute('data-fault'), t); return; }
      if (action === 'sft-symptom') { onSym('sft', t.getAttribute('data-fault'), t); return; }
      if (action === 'fid-symptom') { onSym('sft', t.getAttribute('data-fault'), t); return; }
      if (action === 'fid-confirm') { confirmSymptoms('face-id'); return; }
      if (action === 'wat-symptom') { onSym('sft', t.getAttribute('data-fault'), t); return; }
      if (action === 'wat-confirm') { confirmSymptoms('water'); return; }
      if (action === 'sml-symptom') { onSym('sml', t.getAttribute('data-fault'), t); return; }
      if (action === 'chg-symptom') { onSym('chg', t.getAttribute('data-fault'), t); return; }
      if (action === 'cam-symptom') { onSym('cam', t.getAttribute('data-fault'), t); return; }
      if (action === 'scr-confirm') { confirmSymptoms('screen'); return; }
      if (action === 'bat-confirm') { confirmSymptoms('battery'); return; }
      if (action === 'gls-confirm') { confirmSymptoms(S.repair === 'housing' ? 'housing' : 'back-glass'); return; }
      if (action === 'cm-confirm') {
        var cmLensCracked = S.sym.cm.indexOf('cm_lens_cracked') !== -1;
        var cmModuleFaults = ['cm_blur','cm_black','cm_crash','cm_shake','cm_flash','cm_dust','cm_switched','cm_notsure'].some(function(f){ return S.sym.cm.indexOf(f) !== -1; });
        if (cmLensCracked && cmModuleFaults) {
          S.repair = 'camera';
          S.faults = S.faults.filter(function(f){ return f !== 'rear_camera' && f !== 'camera_lens_damage'; });
          if (S.faults.indexOf('camera_lens_damage') === -1) S.faults.push('camera_lens_damage');
        } else if (cmLensCracked && !cmModuleFaults) {
          S.repair = 'camera-lens';
          S.faults = S.faults.filter(function(f){ return f !== 'rear_camera' && f !== 'camera_lens_damage'; });
        } else {
          S.repair = 'camera';
          S.faults = S.faults.filter(function(f){ return f !== 'camera_lens_damage'; });
        }
        if (S.type === 'iphone') { goStep('sr-batt-health'); } else { goStep('sr3'); renderSr3(); }
        return;
      }
      if (action === 'cam-confirm') {
        var camLensSyms = ['cam_lens_cracked','cam_scratched','cam_flare','cam_lens_fine'];
        var camModuleSyms = ['cam_blurry','cam_spots','cam_vibrate','cam_noise'];
        var hasLensDamage = camLensSyms.some(function(f){ return S.sym.cam.indexOf(f) !== -1; });
        var hasModuleFault = camModuleSyms.some(function(f){ return S.sym.cam.indexOf(f) !== -1; });
        if (hasModuleFault) {
          S.repair = 'camera';
          S.faults = S.faults.filter(function(f){ return f !== 'rear_camera' && f !== 'camera_lens_damage'; });
          if (S.faults.indexOf('camera_lens_damage') === -1) S.faults.push('camera_lens_damage');
        } else {
          S.repair = 'camera-lens';
          S.faults = S.faults.filter(function(f){ return f !== 'rear_camera' && f !== 'camera_lens_damage'; });
        }
        if (S.type === 'iphone') { goStep('sr-batt-health'); } else { goStep('sr3'); renderSr3(); }
        return;
      }
      if (action === 'set-batt-health') {
        var bh = t.getAttribute('data-bh');
        S.battHealth = bh;
        document.querySelectorAll('[data-action="set-batt-health"]').forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-bh') === bh); });
        var lowNote = $('cdmc-bh-low-note');
        if (lowNote) lowNote.classList.toggle('cd-hidden', bh !== 'low');
        // ⚠ THIS LINE USED TO UNDO THE SELLER'S OWN ANSWER, AND R-096 IS WHAT MADE IT REACHABLE.
        // A battery health under 80% DERIVES a battery fault, and anything else used to remove one
        // — which was safe only while the two questions lived on different screens in a fixed
        // order. On one screen the seller can tick "Battery issues" first and then answer
        // "90–100%" (a fast-draining battery that still reports high capacity is a real phone), and
        // the chip they ticked silently un-ticked itself. A derived answer may be withdrawn; a
        // declared one may not, so the writer has to record WHICH it was. Measured on the harness.
        if (bh === 'low' && S.repair !== 'battery' && S.faults.indexOf('battery') === -1) {
          S.faults.push('battery');
          S.battFaultDerived = true;
        } else if (bh !== 'low' && S.battFaultDerived) {
          var bIdx = S.faults.indexOf('battery');
          if (bIdx !== -1 && S.repair !== 'battery') S.faults.splice(bIdx, 1);
          S.battFaultDerived = false;
        }
        // ⚠ THIS HANDLER WRITES S.faults, AND SINCE R-096 THE CHIPS THAT DISPLAY S.faults ARE ON
        // THE SAME SCREEN. Answering "below 80%" adds a battery fault; before the merge the chips
        // were re-synced on the way to the next screen, so nobody could see them disagree. Here the
        // "Battery issues" chip is six inches above and would sit unlit while the result page
        // deducted for it — the classic two-representations-of-one-fact split (L-always-08).
        document.querySelectorAll('#cdmc-cond-faults [data-action="fault-toggle"]').forEach(function (b) {
          b.classList.toggle('active', S.faults.indexOf(b.getAttribute('data-fault')) !== -1);
        });
        renderFaultDetails();
        hide($('cdmc-check-err'));
        return;
      }
      if (action === 'batt-health-next') {
        if (_battHealthCallback) {
          var cb = _battHealthCallback;
          _battHealthCallback = null;
          cb();
        } else {
          goStep('sr3'); renderSr3();
        }
        return;
      }
      if (action === 'sft-confirm') { confirmSymptoms(S.repair === 'other' ? 'other' : 'software'); return; }
      if (action === 'sml-confirm') { confirmSymptoms('small-parts'); return; }
      if (action === 'chg-confirm') { confirmSymptoms('charging-port'); return; }
      if (action === 'set-storage') {
        S.storage = t.getAttribute('data-storage') || '';
        document.querySelectorAll('.cdmc__storage-btn').forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-storage') === S.storage); });
        return;
      }
      if (action === 'fault-toggle') { faultToggle(t.getAttribute('data-fault'), t); return; }
      if (action === 't2b-toggle') {
        var sym = t.getAttribute('data-sym');
        var bkt = t.getAttribute('data-bucket');
        if (!S.sym[bkt]) S.sym[bkt] = [];
        var idx = S.sym[bkt].indexOf(sym);
        if (idx === -1) S.sym[bkt].push(sym); else S.sym[bkt].splice(idx, 1);
        // r170 (CXH1012-06): a fault's own question wrote it, so it goes out only while a fault still chosen asks for it.
        S.symFrom = S.symFrom || {};
        var symKey = bkt + ':' + sym;
        if (idx !== -1) delete S.symFrom[symKey]; else if (S.symFrom[symKey] !== 'primary') S.symFrom[symKey] = 'detail';
        t.classList.toggle('active', S.sym[bkt].indexOf(sym) !== -1);
        // On screen 3 the detail groups are all on screen at once and several faults share a
        // bucket, so the clicked button is not the only one whose state just changed.
        syncFaultDetailActive();
        hide($('cdmc-check-err'));
        return;
      }
      if (action === 'set-trade-flow') {
        S.tradeFlow = t.getAttribute('data-flow');
        document.querySelectorAll('.cdmc__trade-flow-btn').forEach(function(b){
          b.classList.toggle('active', b.getAttribute('data-flow') === S.tradeFlow);
        });
        // r149 (Codex FSA-044) — the summary says the choice now; it kept "You choose on your buying form" after a tap
        renderTradeinSummary(compValueFor(S.model, S.cond, S.faults), S.intent === 'sell');
        return;
      }
      if (action === 'scroll-to-form') {
        var form = $('cdmc-r-summary') || $('cdmc-r-name');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (action === 'repair-details') { repairDetails(); return; }
      if (action === 'repair-result')  { goStep('sr4', false); renderRepairResult(); return; }
      if (action === 'revert-to-primary') { revertToPrimary(); return; }
      if (action === 'calc-tradein') { calcTradein(); return; }
      if (action === 'repair-submit') { repairSubmit(); return; }
      if (action === 'tradein-submit') { tradeinSubmit(); return; }
      if (action === 'other-submit') { otherSubmit(); return; }
      if (action === 'other-intent') { setOtherIntent(t.getAttribute('data-intent')); return; }   // r152 (FSA-013)
      if (action === 'switch-tradein') { e.preventDefault(); switchTradein(); return; }
      if (action === 'switch-sell')    { e.preventDefault(); switchSell();    return; }
      if (action === 'switch-repair')  { e.preventDefault(); switchRepair();  return; }
      if (action === 'switch-upgrade') { e.preventDefault(); switchUpgrade(); return; }
      if (action === 'wa-click') {
        showNotif('WHATSAPP', 'Opening WhatsApp chat…', '💬');
        setTimeout(function(){ show($('cdmc-wa-sent')); }, 800);
        return;
      }
      if (action === 'faq-toggle') { faqToggle(t); return; }
      if (action === 'restart') {
        S = {
          type:'iphone', model:'', intent:'', repair:'', parts:'',
          faults:[], cond:'', lock:'', history:[], current:'s0', panels:[],
          sym:{ scr:[], bat:[], gls:[], cm:[], sft:[], sml:[], chg:[], cam:[] }, symFrom:{},
          glsBatt:'', primaryFromQuiz:false, chosenUpgrade:null, tradeFlow:'', storage:'', battHealth:'', faulty:'', carrier:'', blacklist:'',
          battFaultDerived:false, faultGrade:''
        };
        document.querySelectorAll('.active').forEach(function(b){ b.classList.remove('active'); });
        setType('iphone');
        // r165 (R-163) — the unlisted phone form follows the new state: S no longer holds a choice, and the line above took
        // the pressed look off its buttons, while its labels still read whatever was chosen before. Sell only stays a sale.
        setOtherIntent(SELL_ONLY ? 'sell' : 'repair');
        _presetCondUsed = false;   // r165: a new quote, so the page's condition answer is offered once more
        goStep('s0', false);
      }
    });
    document.addEventListener('change', function(e){
      var t = e.target.closest('[data-action]');
      if (!t) return;
      if (t.getAttribute('data-action') === 'model-change') { onModelChange(t.value); }
    });
    ['cdmc-r-phone','cdmc-t-phone','cdmc-other-phone'].forEach(function(id){
      var el = $(id);
      if (el) el.addEventListener('input', function(){ formatPhone(el); });
    });
    goStep('s0', false, SELL_ONLY);   // r165: a sell ad page opens on its headline, not scrolled to the tool
    applyPrefill();
    initResume();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
